import { commitPickerAdd, commitPickerRemove } from "./productPickerMutation";
import { supplierAsiSearchMode } from "./supplierAsiSearchPolicy";
import { CatalogueProcessingMode, FullCatalogueProgress, safeFullCatalogueProgress } from "./FullCatalogueControls";
import React, { useState, useRef, useContext, useEffect, useCallback } from "react";
import { createPortal } from "react-dom";
import { AuthContext } from "../../../../helpers/AuthContext";
import { supplierApiOptionsFromResponse, buildSupplierApiSelectorModel, buildSupplierApiMenuItems, resolveSupplierApiSelection, supplierApiSupplierPayload, supplierApiConnectionLabel, supplierApiAvailabilityMessage, buildPreviewResultModel, buildImportFailureDetails, catalogueFetchMessage, productDataImportLimits, appendCatalogueImportLimits, dryRunImportActionState, snapshotDryRunValues, catalogueImportDestinations, destinationForImportSource, buildImportDisplayContext, supplierApiEstimateMessage, canContinueProductDataImport, supportsProductDataAutoContinue } from "./supplierOptionHelpers";
import axios from "axios";
import { useProductDataAutoContinue } from "./useProductDataAutoContinue";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // Toast styles
import InstanceLeftSidebar from "../../InstanceLeftSidebar";
import "./style.css";
import ProductPopup from "../products/ProductPopup"; // Popup for viewing product details
import { useParams, useHistory } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import { List, ListItemButton, ListItemText } from "@mui/material";
import { uploadSupplierImage } from "../../../../services/customerFiles";
import {   Dialog,   DialogTitle,   DialogContent,   DialogActions,   Button,   TextField,   MenuItem,   Checkbox,   FormControlLabel,   Grid,   Box,   Typography,   Accordion,   AccordionSummary,   AccordionDetails,   IconButton,   RadioGroup,   FormControl,   CircularProgress,   FormLabel,   FormHelperText,   LinearProgress,   Badge,   Radio,   Tooltip,   Tabs,   Tab,   Divider,   Chip,   Stack,
InputAdornment,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  ToggleButton,
  ToggleButtonGroup,
  Menu,
  Select,
 } from "@mui/material";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import PublicIcon from "@mui/icons-material/Public";
import StorageIcon from "@mui/icons-material/Storage";
import LinkIcon from "@mui/icons-material/Link";
import BuildIcon from "@mui/icons-material/Build";
import FlagIcon   from "@mui/icons-material/Flag";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import PriceChangeIcon from "@mui/icons-material/PriceChange";
import CollectionsIcon from "@mui/icons-material/Collections";
import AssignmentIcon from "@mui/icons-material/Assignment";
import CategoryIcon from "@mui/icons-material/Category";
import AccessTimeIcon from "@mui/icons-material/AccessTime";

import LoadingComponent from "../../../../components/ComponentLoader";
import ButtonLoader from "../../../../components/ButtonLoader";
import { Formik, Form, Field, ErrorMessage, FastField, useFormikContext } from "formik";
import InventoryIcon from '@mui/icons-material/Inventory';
import { toCents, fromCents, retailFromMarginCents } from '../../../../utils/totals'
import {
  getCustomProductPriceBreak,
  normalizeCustomProductForOrder,
} from '../../../../utils/products/normalizeCustomProductForOrder'
import { showProductImagePlaceholder, productImageCandidates, showNextProductImage } from '../../../../utils/products/customProductImage'
import * as Yup from "yup";

import { useTheme } from "@mui/material/styles";

import ViewModuleIcon       from "@mui/icons-material/ViewModule";
import ViewListIcon         from "@mui/icons-material/ViewList";
import SearchIcon           from "@mui/icons-material/Search";
import ClearIcon            from "@mui/icons-material/Clear";
import StorefrontIcon       from "@mui/icons-material/Storefront";
import CheckCircleIcon      from "@mui/icons-material/CheckCircle";
import ImageNotSupportedIcon from "@mui/icons-material/ImageNotSupported";

import DensityMediumIcon from "@mui/icons-material/DensityMedium";
import RefreshIcon      from "@mui/icons-material/Refresh";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

import FormatLineSpacingIcon from "@mui/icons-material/FormatLineSpacing";


import FolderOffIcon from "@mui/icons-material/FolderOff";
import SettingsIcon from "@mui/icons-material/Settings";
import ViewColumnIcon from "@mui/icons-material/ViewColumn";
import {
  UIStatusChip,
  UITableActionCell,
  UITableShell,
  UITableToolbar,
} from "../../../../components/ui";

import { jsPDF } from "jspdf";
// import "jspdf-autotable";
import autoTable from "jspdf-autotable";



function PrefillOnEdit({ open, mode, initialProduct, prefillFromTemplate, setImageUrls }) {
  const { setFieldValue } = useFormikContext();

  useEffect(() => {
    if (!open) return;
    if (mode !== "edit" || !initialProduct) return;

    prefillFromTemplate(initialProduct, setFieldValue);

    const imgs = Array.isArray(initialProduct.Images) ? initialProduct.Images : [];
    const primary = initialProduct.ImageUrl || imgs[0] || "";
    setImageUrls(primary ? (imgs.length ? imgs : [primary]) : imgs);
  }, [open, mode, initialProduct, setFieldValue, prefillFromTemplate, setImageUrls]);

  return null;
}


const COMMON_VARIANT_ATTRIBUTE_TYPES = ["Size", "Color", "Material", "Style", "Finish"];
// Attribute identity is case-insensitive; stored/display type is canonical; value display is preserved.
// Legacy PRCL is read as Color, but all new manual product writes use COLOR.
const RESERVED_VARIANT_KEYS = new Set([
  "Number", "SKU", "ImageUrl", "Prices", "Price", "Cost", "CurrencyCode", "Attributes", "IsQUR", "Quantity",
  "UPC", "GTIN", "Barcode", "CustomData", "Inventory", "Status", "Ribbon", "ProductVideoUrl",
  "ColorHex", "ColorCode", "CasePackQty", "quantityAvailable", "quantityOnHand", "quantityReserved",
  "quantityBackordered", "quantityIncoming", "warehouseBreakdown", "InventoryLastCheckedAt", "InventoryRaw",
  "LaunchDate", "activeFromImport", "lastSeenImportBatchId", "lastSeenAt",
]);

const wordsFromLabel = (label) => String(label || "")
  .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
  .replace(/[^a-zA-Z0-9]+/g, " ")
  .trim()
  .split(/\s+/)
  .filter(Boolean);

const pascalFromWords = (words) => words
  .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
  .join("");

const normalizeAttributeType = (label) => {
  const raw = String(label || "").trim();
  const normalized = raw.toLowerCase().replace(/[^a-z0-9]+/g, " ").trim();
  if (normalized === "size") return "Size";
  if (normalized === "color" || normalized === "colour" || normalized === "prcl") return "Color";
  if (normalized === "material") return "Material";
  if (normalized === "style") return "Style";
  if (normalized === "finish") return "Finish";
  const custom = pascalFromWords(wordsFromLabel(raw));
  return custom || "Attribute";
};

const attributeCode = (label) => {
  const type = normalizeAttributeType(label);
  if (type === "Size") return "SIZE";
  if (type === "Color") return "COLOR";
  if (type === "Material") return "MATERIAL";
  if (type === "Style") return "STYLE";
  if (type === "Finish") return "FINISH";
  return wordsFromLabel(type).map((word) => word.toUpperCase()).join("_") || "ATTRIBUTE";
};

const pluralAttributeBucket = (label) => {
  const type = normalizeAttributeType(label);
  if (type === "Size") return "Sizes";
  if (type === "Color") return "Colors";
  if (type === "Material") return "Materials";
  if (type === "Style") return "Styles";
  if (type === "Finish") return "Finishes";
  return type.endsWith("s") ? type : `${type}s`;
};

const valueCode = (value) => {
  const code = wordsFromLabel(value).map((word) => word.toUpperCase()).join("_");
  return code || String(value || "").trim() || "VALUE";
};

const attributeTypeFromSkuCode = (code) => {
  const normalized = String(code || "").trim().toUpperCase();
  if (normalized === "SIZE") return "Size";
  if (normalized === "COLOR" || normalized === "PRCL") return "Color";
  if (normalized === "MATERIAL") return "Material";
  if (normalized === "STYLE") return "Style";
  if (normalized === "FINISH") return "Finish";
  return normalizeAttributeType(normalized.toLowerCase().replace(/_/g, " "));
};

const normalizeFormAttributes = (attributes = []) => (Array.isArray(attributes) ? attributes : [])
  .map((attribute) => ({
    type: normalizeAttributeType(attribute?.type || attribute?.Type || attribute?.Code || ""),
    value: String(attribute?.value ?? attribute?.Value ?? attribute?.Name ?? "").trim(),
  }))
  .filter((attribute) => attribute.type && attribute.value);

const skuValuesForVariant = (skuRows = [], variant = {}, index = 0) => {
  if (!Array.isArray(skuRows)) return [];
  const number = String(variant?.Number || variant?.SKU || "").trim();
  const matched = skuRows.find((row, rowIndex) => {
    const rowSku = String(row?.SKU || row?.Number || "").trim();
    return (number && rowSku && rowSku === number) || rowIndex === index;
  });
  return Array.isArray(matched?.Values) ? matched.Values : [];
};

const formAttributesFromFlatVariant = (variant = {}, skuValues = []) => {
  const existing = normalizeFormAttributes(variant.Attributes);
  if (existing.length) return existing;

  const attrs = [];
  ["Size", "Color", "Material", "Style", "Finish"].forEach((type) => {
    if (variant?.[type]) attrs.push({ type, value: String(variant[type]).trim() });
  });

  Object.entries(variant || {}).forEach(([key, val]) => {
    if (RESERVED_VARIANT_KEYS.has(key) || ["Size", "Color", "Material", "Style", "Finish"].includes(key)) return;
    const value = String(val ?? "").trim();
    if (value && typeof val !== "object") attrs.push({ type: normalizeAttributeType(key), value });
  });

  (Array.isArray(skuValues) ? skuValues : []).forEach((value) => {
    const type = attributeTypeFromSkuCode(value?.Code);
    const name = String(value?.Name || "").trim();
    if (type && name) attrs.push({ type, value: name });
  });

  const seen = new Set();
  const deduped = attrs.filter((attr) => {
    const key = `${normalizeAttributeType(attr.type)}::${String(attr.value).trim().toLowerCase()}`;
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });

  return deduped.length ? deduped : [{ type: "Size", value: "" }];
};

const buildFlatVariantFromFormVariant = (variant = {}) => {
  const number = String(variant.Number || variant.SKU || "").trim();
  const flat = {
    Number: number,
    SKU: number,
    ImageUrl: variant.ImageUrl || "",
    Prices: [{
      Cost: Number(variant.Cost ?? variant.Price) || Number(variant.Price) || 0,
      Price: Number(variant.Price) || 0,
      IsQUR: false,
      Quantity: { From: 1, To: qtyInfinity, $index: 1 },
      CurrencyCode: variant.CurrencyCode || "CAD",
    }],
  };

  normalizeFormAttributes(variant.Attributes).forEach(({ type, value }) => {
    flat[normalizeAttributeType(type)] = value;
  });

  return flat;
};

const attributesForFlatVariant = (variant = {}) => Object.entries(variant || {})
  .filter(([key, value]) => !RESERVED_VARIANT_KEYS.has(key) && String(value ?? "").trim() && typeof value !== "object")
  .map(([key, value]) => ({ type: normalizeAttributeType(key), value: String(value).trim() }));

const buildAttributesFromVariants = (flatVariants = []) => {
  const buckets = {};
  const seen = new Set();

  (Array.isArray(flatVariants) ? flatVariants : []).forEach((variant) => {
    const sku = String(variant?.Number || variant?.SKU || "").trim();
    attributesForFlatVariant(variant).forEach(({ type, value }) => {
      const bucket = pluralAttributeBucket(type);
      const key = `${bucket}::${value.trim().toLowerCase()}`;
      if (seen.has(key)) return;
      seen.add(key);
      if (!buckets[bucket]) buckets[bucket] = { Values: [] };
      buckets[bucket].Values.push({
        Code: valueCode(value),
        Name: value,
        VendorCode: sku,
        SKU: sku,
        $index: buckets[bucket].Values.length + 1,
      });
    });
  });

  return buckets;
};

const buildSkuFromVariants = (flatVariants = []) => (Array.isArray(flatVariants) ? flatVariants : [])
  .map((variant) => {
    const sku = String(variant?.Number || variant?.SKU || "").trim();
    return {
      SKU: sku,
      Values: attributesForFlatVariant(variant).map(({ type, value }) => ({
        Code: attributeCode(type),
        Name: value,
        VendorCode: sku,
      })),
    };
  })
  .filter((row) => row.SKU || row.Values.length);

const ASI_MODES = ["keyword-live", "keyword-test", "asi-live", "asi-test"];
const currencies = ["CAD", "USD"];
const qtyInfinity = 2147483647;
// --- Market helpers (frontend-only UI + query builder) ---
const nextMarket = (m) => ({ ALL: "CAN", CAN: "USA", USA: "ALL" }[m] || "ALL");

const marketToken = (m) =>
  m === "CAN" ? "market_segment:CANALL"
: m === "USA" ? "market_segment:USAALL"
: "";

// Translate legacy tokens to modern market_segment filter (keeps old deep links working)
const normalizeLegacyMarketTokens = (q) => {
  let out = (q || "").trim();

  // if a modern market_segment is already present, leave as-is
  if (/\bmarket_segment:\w+\b/i.test(out)) return out;

  // legacy → modern (only if modern is not already present)
  if (/\bcanadian:1\b/i.test(out)) {
    out = out.replace(/\bcanadian:1\b/ig, "").trim();
    out = `${out} market_segment:CANALL`.trim();
  }
  if (/\bamerican:1\b/i.test(out)) {
    out = out.replace(/\bamerican:1\b/ig, "").trim();
    out = `${out} market_segment:USAALL`.trim();
  }

  return out.replace(/\s+/g, " ").trim();
};

// Build final ASI q string: base terms + optional supplier + market segment
const buildAsiQuery = (raw, mkt, asiSupplierId) => {
  const parts = [];
  const base = normalizeLegacyMarketTokens(raw);

  if (base) parts.push(base);

  // supplier scoping (don’t add if user already typed asi:####)
  if (asiSupplierId && !/\basi:\d+\b/i.test(base || "")) {
    parts.push(`asi:${asiSupplierId}`);
  }

  // only append UI-selected market if not already in q
  const hasMarket = /\bmarket_segment:\w+\b/i.test(base);
  if (!hasMarket) {
    const mt = marketToken(mkt);
    if (mt) parts.push(mt);
  }

  return parts.join(" ").replace(/\s+/g, " ").trim();
};

// Only show a field error after blur OR after the user tried to submit
const getErrorHelpers = (errors, touched, submitCount) => {
  const show = (name) => Boolean(errors?.[name]) && (touched?.[name] || submitCount > 0);
  const text = (name) => (show(name) ? errors[name] : undefined);
  return { show, text };
};


// TextField that only writes to Formik on BLUR (no per-keystroke setFieldValue)
const BlurTextField = ({ name, label, rows, multiline, ...rest }) => {
  const { setFieldValue, values, errors, touched, submitCount } = useFormikContext();
  const [local, setLocal] = React.useState(values?.[name] ?? "");

  React.useEffect(() => {
    // keep in sync if Formik value changes externally
    if (!touched?.[name]) setLocal(values?.[name] ?? "");
  }, [values?.[name]]); // eslint-disable-line

  const hasError = Boolean(errors?.[name]) && (touched?.[name] || submitCount > 0);

  return (
    <TextField
      label={label}
      fullWidth
      multiline={multiline}
      rows={rows}
      value={local}
      onChange={(e) => setLocal(e.target.value)}
      onBlur={(e) => setFieldValue(name, e.target.value)}
      error={hasError}
      helperText={hasError ? errors?.[name] : undefined}
      {...rest}
    />
  );
};

// ─── Identity + normalization helpers ─────────────────────────────────────────

const CUSTOM_PREFIX = "CUSTOM-";

const normalizeSource = (s) => {
  const x = String(s ?? "").toLowerCase().trim();
  if (!x) return "";
  // anything ASI-ish
  if (x === "asi" || x.startsWith("asi-") || x.includes("keyword")) return "asi";
  if (x === "promoworld" || x === "catalog" || x.startsWith("promoworld-")) return "promoworld";
  // anything custom-ish (Elite Promo Marketing, custom-core, customproducts, etc.)
  if (
    x === "custom" ||
    x.startsWith("custom-") ||
    x.includes("elite") ||
    x.includes("customproduct") ||
    x.includes("custom_core") ||
    x.includes("custom-core")
  ) return "custom";
  return x;
};

// Canonicalize pid (if custom, strip CUSTOM- prefix; case-insensitive)
const canonicalPid = (src, pid) => {
  const s = normalizeSource(src);
  const p = String(pid ?? "");
  return s === "custom" ? p.replace(/^custom-/i, "") : p;
};

// A stable key used for compares
const canonicalKey = (src, pid) =>
  `${normalizeSource(src) || "asi"}|${canonicalPid(src, pid)}`;

// Derive source from a cart line (tolerant to synonyms + legacy)
const getItemSource = (p) => {
  let s = normalizeSource(p?.Source ?? p?.source);
  if (s) return s;
  const pid = String(p?.ProductId ?? p?.productId ?? p?.Id ?? p?.id ?? "");
  return /^custom-/i.test(pid) ? "custom" : "asi";
};

// Keep this simple and tolerant to shapes
const getItemPid = (p) =>
  (p?.ProductId ?? p?.productId ?? p?.Id ?? p?.id ?? "").toString();

// Which provider are we browsing?
const getSourceFromTab = (activeTab) =>
  activeTab === "Elite Promo Marketing" ? "custom" : activeTab === "PromoWorld" ? "promoworld" : "asi";

// The ProductId we store on the order
const makeOrderProductId = (product, source) => {
  const raw = String(product?.Id ?? product?.id ?? "");
  return normalizeSource(source) === "custom" ? `${CUSTOM_PREFIX}${raw}` : raw;
};










const PRODUCT_COLUMNS = [
  { id: "s_no",      label: "#",          sortable: false, minWidth: 55,  align: "center", visible: true  },
  { id: "image",     label: "Image",      sortable: false, minWidth: 80,  align: "center", visible: true  },
  { id: "name",      label: "Product",    sortable: false, minWidth: 240, align: "left",   visible: true  },
  { id: "sku",       label: "SKU / No.",  sortable: false, minWidth: 120, align: "left",   visible: true  },  
  { id: "supplier",  label: "Supplier",   sortable: false, minWidth: 160, align: "left",   visible: true  },
  { id: "price",     label: "Price",      sortable: false, minWidth: 110, align: "left",   visible: true  },
  { id: "colors",    label: "Colors",     sortable: false, minWidth: 130, align: "left",   visible: true  }, 
  { id: "sizes",     label: "Sizes",      sortable: false, minWidth: 130, align: "left",   visible: false },
  { id: "material",  label: "Material",   sortable: false, minWidth: 110, align: "left",   visible: false },  
  { id: "prod_time", label: "Prod. Days", sortable: false, minWidth: 100, align: "center", visible: false },  
  { id: "stock",     label: "Stock",      sortable: false, minWidth: 100, align: "center", visible: true  },
  { id: "actions",   label: "Actions",    sortable: false, minWidth: 110, align: "center", visible: true, locked: true },
];




const PRODUCTS_PER_PAGE = 100;




const QUICK_SEARCHES = [
  { label: "Pens",         query: "pen" },
  { label: "Mugs",         query: "mug" },
  { label: "T-Shirts",     query: "shirt" },
  { label: "Bags",         query: "bag" },
  { label: "Water Bottles",query: "water bottle" },
  { label: "Notebooks",    query: "notebook" },
  { label: "Stickers",     query: "sticker" },
];




function InstanceProducts({
  popupMode = false,
  embedded = false,
  isPresentation = false,
  closeProductListPopup,
  updateItemsToOrder,
  onAddProduct = null,
  onRemoveProduct = null,
  order,
  instanceUniqueId: instanceUniqueIdProp,
  allowedSources = null,
}) {
  const { authState } = useContext(AuthContext);
  const routeParams = useParams();
  const instanceUniqueId = instanceUniqueIdProp || routeParams.instanceUniqueId;
  const isEmbedded = embedded === true;
  const usesStandalonePopup = popupMode && !isEmbedded;
  // State for product feed, search, pagination, and product details popup
  // after:
  const [marketFilter, setMarketFilter] = useState("CAN");

  const [queries, setQueries] = useState({
    'keyword-test': '',
    'keyword-live': '',
    'asi-test':    '',
    'asi-live':    '',
    'custom':      '',
    'promoworld':  ''
  });
  const [searchMode, setSearchMode] = useState("keyword-live");  // "keyword" | "asi-live" | "asi-test"
  const [products, setProducts] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [asiCurrentPage, setAsiCurrentPage] = useState(1);
  const [asiTotalPages, setAsiTotalPages] = useState(1);
  const [customCurrentPage, setCustomCurrentPage] = useState(1);
  const [customTotalPages, setCustomTotalPages] = useState(1);
  const [promoWorldCurrentPage, setPromoWorldCurrentPage] = useState(1);
  const [promoWorldTotalPages, setPromoWorldTotalPages] = useState(1);
  const [asiHasSearched, setAsiHasSearched] = useState(false);
  const [customHasSearched, setCustomHasSearched] = useState(false);
  const [promoWorldHasSearched, setPromoWorldHasSearched] = useState(false);

  const CUSTOM_PREFIX = "CUSTOM-";



  const selectedIndex = React.useMemo(() => {
    const idx = new Set();
    const list = order?.Products || [];

    for (const p of list) {
      const src = getItemSource(p);
      const pid = getItemPid(p);
      // canonical key
      idx.add(canonicalKey(src, pid));

      // also alias raw id for custom (some writers strip the prefix)
      if (src === "custom") {
        const raw = String(p?.RawProductId ?? "").trim();
        if (raw) idx.add(`custom|${raw}`);
      }
    }
    return idx;
  }, [order?.Products]);

  const makeOrderProductId = (product, source) => {
    const raw = String(product?.Id ?? product?.id ?? "");
    return source === "custom" ? `${CUSTOM_PREFIX}${raw}` : raw;  // ASI stays numeric
  };

  const getSourceFromTab = (activeTab) =>
    activeTab === "Elite Promo Marketing" ? "custom" : activeTab === "PromoWorld" ? "promoworld" : "asi";

  // State for tab control (default to "ASI")
  const normalizedAllowedSources = React.useMemo(
    () => Array.isArray(allowedSources) && allowedSources.length
      ? new Set(allowedSources.map((source) => String(source || '').toLowerCase()))
      : null,
    [allowedSources]
  );
  const sourceTabs = React.useMemo(() => ([
    { key: "ASI", label: "ASI", source: "asi" },
    { key: "Elite Promo Marketing", label: "Elite Promo", source: "custom" },
    { key: "PromoWorld", label: "PromoWorld", source: "promoworld" },
  ]).filter((tab) => !normalizedAllowedSources || normalizedAllowedSources.has(tab.source)), [normalizedAllowedSources]);
  const defaultActiveTab = normalizedAllowedSources
    ? (sourceTabs.find((tab) => tab.source === 'asi')?.key
      || sourceTabs.find((tab) => tab.source === 'promoworld')?.key
      || sourceTabs[0]?.key
      || 'ASI')
    : 'ASI';
  const [activeTab, setActiveTab] = useState(defaultActiveTab);
  React.useEffect(() => {
    const activeSource = activeTab === 'ASI' ? 'asi' : activeTab === 'PromoWorld' ? 'promoworld' : 'custom';
    if (normalizedAllowedSources && !normalizedAllowedSources.has(activeSource)) {
      const fallback = sourceTabs.find((tab) => tab.source === 'promoworld')?.key || sourceTabs[0]?.key;
      if (fallback && fallback !== activeTab) handleTabChange(fallback);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab, normalizedAllowedSources, sourceTabs]);

  const currentPage = activeTab === "ASI" ? asiCurrentPage : activeTab === "PromoWorld" ? promoWorldCurrentPage : customCurrentPage;
  const totalPages = activeTab === "ASI" ? asiTotalPages : activeTab === "PromoWorld" ? promoWorldTotalPages : customTotalPages;

  // given a product card, return the *exact* identity we'll save
  const candidateOrderIdentity = (product) => {
    const raw    = String(product?.Id ?? product?.id ?? "");
    const source = getSourceFromTab(activeTab);    // 'custom', 'promoworld', or 'asi'
    const pid    = makeOrderProductId({ Id: raw }, source); // custom keeps a CUSTOM- prefix; ASI/PromoWorld keep their IDs
    return { source, pid, raw };
  };

  // State for controlling the custom product popup (modal style)
  const [loadingProducts, setLoadingProducts] = useState({});

  const [popupProduct,    setPopupProduct]    = useState(null);
  const [popupProductId,  setPopupProductId]  = useState(null);
  const [popupLookupType, setPopupLookupType] = useState(null);
  const [isPopupOpen,     setIsPopupOpen]     = useState(false);
  const [showImportPopup, setShowImportPopup] = useState(false);

  // adv. filters
  const [asiSupplierId, setAsiSupplierId] = useState("");
  const [supplierPickerOpen, setSupplierPickerOpen] = useState(false);
  const [supplierOptions, setSupplierOptions] = useState([]);
  const [loadingSupplierOptions, setLoadingSupplierOptions] = useState(false)
  const [showCustomPopup, setShowCustomPopup] = useState(false);
  const [editMode, setEditMode] = useState(false);

  useEffect(() => {
    if (!popupMode || isEmbedded || typeof document === "undefined") return undefined;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [isEmbedded, popupMode]);
  const [editingProduct, setEditingProduct] = useState(null);

  // strict ASI number extractor (only 4–6 digit numbers)
  const digitsOnly = (v) => (v == null ? "" : String(v).replace(/\D/g, ""));
  const pickAsiNumber = (...vals) => {
    for (const v of vals) {
      const d = digitsOnly(v);
      if (d && d.length >= 4 && d.length <= 6) return d; // typical ASI length
    }
    return "";
  };

  const getAsiFromSupplier = (s) => {
    if (!s) return "";

    // 1) prefer the asi-live reference’s unique_ref_number (your new field)
    const refs = Array.isArray(s.References) ? s.References : [];
    const asiRef = refs.find(r =>
      /asi-live/i.test(String(r?.source ?? "")) || /^asi$/i.test(String(r?.source ?? ""))
    );
    if (asiRef) {
      const fromRef = pickAsiNumber(
        asiRef.unique_ref_number,   // snake_case
        asiRef.uniqueRefNumber,     // camelCase (just in case)
        asiRef.asi_number,
        asiRef.asiNumber,
        asiRef.value                // legacy fallback if you ever used it
      );
      if (fromRef) return fromRef;
    }

    // 2) fallbacks on the supplier object if you ever hydrate it there
    return pickAsiNumber(s.AsiNumber, s.asiNumber, s.ASI, s.asi);
  };

  const normalizePreferredSupplier = (raw) => {
    const src = raw?.Supplier || raw?.CoreSupplier || raw;

    return {
      ...src,
      id: src.Id ?? src.id,
      name: src.Name ?? src.name ?? src.businessName ?? "Unnamed",
      businessName: src.Name ?? src.businessName ?? src.name ?? "Unnamed",
      AsiNumber: src.AsiNumber ?? src.asiNumber ?? "",
      References: Array.isArray(src.References) ? src.References : [],
      connected: true,
    };
  };

  const openSupplierPicker = async () => {
    setSupplierPickerOpen(true);
    setLoadingSupplierOptions(true);

    try {
      const resp = await axios.get(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/suppliers/get-suppliers`,
        {
          params: {
            instanceUniqueId,
            tab: "connected", // Preferred Suppliers tab
            page: 1,
            pageSize: 250,
          },
          headers: { accessToken: localStorage.getItem("accessToken") },
        }
      );

    const preferred = (resp.data?.rows || [])
        .map(normalizePreferredSupplier);

      console.log("[preferred suppliers picker]", {
        rawCount: resp.data?.rows?.length || 0,
        normalizedCount: preferred.length,
        suppliers: preferred.map((s) => ({
          id: s.id,
          name: s.businessName || s.name,
          asi: getAsiFromSupplier(s),
          AsiNumber: s.AsiNumber,
          References: s.References,
        })),
      });

      setSupplierOptions(preferred);
    } catch (err) {
      console.error("Failed to load preferred suppliers:", err);
      setSupplierOptions([]);
    } finally {
      setLoadingSupplierOptions(false);
    }
  };

  const handlePickSupplier = (s) => {
    const asi = getAsiFromSupplier(s);
    if (asi) setAsiSupplierId(asi);
    setSupplierPickerOpen(false);
  };



  let history = useHistory();

  const [defaultTaxId, setDefaultTaxId] = useState(null);
  const [defaultMargin, setDefaultMargin] = useState(40);
  const [defaultAsiMarket, setDefaultAsiMarket] = useState("CAN");

  useEffect(() => {
    const fetchDefaults = async () => {
      if (!instanceUniqueId) return;
      try {
        const instanceRes = await axios.get(
          `${process.env.REACT_APP_NODEJS_SERVER_URL}/instances/byinstanceUniqueId/${instanceUniqueId}`
        );
        const instanceId = instanceRes?.data?.id;
        if (!instanceId) {
          setDefaultTaxId(null);
          return;
        }
        const defaultsRes = await axios.get(
          `${process.env.REACT_APP_NODEJS_SERVER_URL}/instances/${instanceId}/defaults`,
          { headers: { accessToken: localStorage.getItem("accessToken") } }
        );
        const defaults = defaultsRes?.data?.defaults || {};
        const nextDefaultTaxId = defaults?.defaultTaxId;
        const nextDefaultMargin = Number(defaults?.defaultMargin);
        const nextDefaultAsiMarket = defaults?.defaultAsiMarket;
        setDefaultTaxId(nextDefaultTaxId ? Number(nextDefaultTaxId) : null);
        setDefaultMargin(Number.isFinite(nextDefaultMargin) ? nextDefaultMargin : 40);
        setDefaultAsiMarket(nextDefaultAsiMarket || "CAN");
      } catch (error) {
        setDefaultTaxId(null);
        setDefaultMargin(40);
        setDefaultAsiMarket("CAN");
      }
    };

    fetchDefaults();
  }, [instanceUniqueId]);

  useEffect(() => {
    if (defaultAsiMarket === "CAN" || defaultAsiMarket === "USA") {
      setMarketFilter(defaultAsiMarket);
    }
  }, [defaultAsiMarket]);

  const handleSearch = async (page = 1) => {
    let lookupType = null;

    const modeForASI = ASI_MODES.includes(searchMode) ? searchMode : "keyword-live";
    const rawQ = (activeTab === "ASI"
      ? (queries[modeForASI] || "")
      : activeTab === "PromoWorld"
      ? (queries.promoworld || "")
      : (queries.custom || "")
    ).trim();

    setLoading(true);
    setError("");
    if (activeTab === "ASI") setAsiHasSearched(true);
    if (activeTab === "Elite Promo Marketing") setCustomHasSearched(true);
    if (activeTab === "PromoWorld") setPromoWorldHasSearched(true);

    // Determine which query string to use
    let q;
    let endpoint;
    let isPopup = false;

    if (activeTab === "ASI") {
      q = queries[modeForASI];

      switch (searchMode) {
        case "asi-test":
          endpoint   = `${process.env.REACT_APP_NODEJS_SERVER_URL}/products/get-product`;
          isPopup    = true;
          lookupType = "asi-test";
          break;

        case "keyword-test":
          endpoint   = `${process.env.REACT_APP_NODEJS_SERVER_URL}/products/get-products`;
          isPopup    = false;
          lookupType = "keyword-test";
          break;

        case "keyword-live":
          endpoint   = `${process.env.REACT_APP_NODEJS_SERVER_URL}/products/get-live-products`;
          isPopup    = false;
          lookupType = "keyword-live";
          break;

        case "asi-live":
          endpoint   = `${process.env.REACT_APP_NODEJS_SERVER_URL}/products/get-asi-live-product`;
          isPopup    = true;
          lookupType = "asi-live";
          break;

        default:
          lookupType = "keyword-live";
          isPopup    = true;
          endpoint   = `${process.env.REACT_APP_NODEJS_SERVER_URL}/products/get-live-products`;
      }
    } else if (activeTab === "PromoWorld") {
      q        = queries.promoworld;
      endpoint = `${process.env.REACT_APP_NODEJS_SERVER_URL}/catalog/products`;
    } else {
      // Elite Promo Marketing tab always uses 'custom'
      q        = queries.custom;
      endpoint = `${process.env.REACT_APP_NODEJS_SERVER_URL}/products/get-custom-products`;
    }

    // If it's an ID lookup, just fire the popup
    if (isPopup) {
      setTimeout(() => {
        openPopup(q, true, lookupType);
        setLoading(false);
      }, 300);
      return;
    }

    try {
      // If the user pasted a numeric product ID into the general box, shortcut to the ASI ID popup.
      if (activeTab === "ASI" && searchMode === "keyword-live" && /^\d{6,}$/.test(rawQ)) {
        openPopup(rawQ, true, "asi-live");
        setLoading(false);
        return;
      }

      // Build correct ASI search string for keyword-live
      let qForLive = rawQ;
      if (activeTab === "ASI" && modeForASI === "keyword-live") {
        qForLive = buildAsiQuery(rawQ, marketFilter, asiSupplierId);
      }

      const params = activeTab === "ASI"
        ? {
            q: qForLive,          // ← includes market_segment & optional asi:<supplierId>
            page,
            // rpp: 100,             // bump a bit so we don’t miss matches
            rpp: PRODUCTS_PER_PAGE,
            sort: "DFLT"
            // NOTE: don’t send marketSegment/dl – ASI expects market segment in q
          }
        : activeTab === "PromoWorld"
        ? { q, page, rpp: PRODUCTS_PER_PAGE }
        : {
            instanceUniqueId,
            q,
            page,
            // rpp: 25
            rpp: PRODUCTS_PER_PAGE,
          };

      const resp = await axios.get(endpoint, { params });

      if (activeTab === "ASI") {
        setProducts(resp.data.Results || []);
        setAsiTotalPages(resp.data.TotalPages || 1);
        setAsiCurrentPage(page);
      } else if (activeTab === "PromoWorld") {
        setProducts(resp.data?.Results || []);
        setPromoWorldTotalPages(resp.data?.TotalPages || 1);
        setPromoWorldCurrentPage(resp.data?.CurrentPage || page);
      } else {
        const customItems = Array.isArray(resp.data)
          ? resp.data
          : (resp.data?.Results || resp.data?.rows || []);
        const nextCustomTotalPages = resp.data?.TotalPages || resp.data?.totalPages || 1;
        const nextCustomCurrentPage = resp.data?.CurrentPage || resp.data?.currentPage || page;

        setProducts(customItems);
        setCustomTotalPages(nextCustomTotalPages);
        setCustomCurrentPage(nextCustomCurrentPage);
      }
    } catch (err) {
      setError("Error fetching products: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      handleSearch(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      handleSearch(currentPage - 1);
    }
  };

  // Open product details popup
  const openPopup = (productOrId, isIdLookup = false, lookupType = null) => {
    // remember which endpoint we’ll hit in the actual popup
    const inferredLookupType = lookupType || (activeTab === "PromoWorld" ? "promoworld" : null);
    setPopupLookupType(inferredLookupType);

    if (isIdLookup) {
      setPopupProduct(null);
      setPopupProductId(productOrId);
    } else {
      setPopupProduct(productOrId);
      setPopupProductId(null);
    }

    setIsPopupOpen(true);
  };


  // Close product details popup
  const closePopup = () => {
    setIsPopupOpen(false);
    setPopupProduct(null);
    setPopupProductId(null);
  };

  // Handle tab change
  const handleTabChange = (tab) => {
    setActiveTab(tab);

    // pick the right searchMode for each tab
    if (tab === "Elite Promo Marketing") {
      setSearchMode("custom");
    } else if (tab === "PromoWorld") {
      setSearchMode("promoworld");
    } else {
      // going back to ASI → ensure a valid ASI mode
      setSearchMode(prev => ASI_MODES.includes(prev) ? prev : "keyword-live");
    }

    // close popups & clear state
    setShowCustomPopup(false);
    setProducts([]);
    setError("");
    if (tab === "ASI") {
      setAsiCurrentPage(1);
      setAsiTotalPages(1);
      setAsiHasSearched(false);
    } else if (tab === "PromoWorld") {
      setPromoWorldCurrentPage(1);
      setPromoWorldTotalPages(1);
      setPromoWorldHasSearched(false);
    } else {
      setCustomCurrentPage(1);
      setCustomTotalPages(1);
      setCustomHasSearched(false);
    }

    // reset all search inputs with the correct keys
    setQueries({
      "keyword-test": "",
      "keyword-live": "",
      "asi-live":     "",
      "asi-test":     "",
      "custom":       "",
      "promoworld":   ""
    });
  };

  useEffect(() => {
    if (activeTab === "ASI" && !ASI_MODES.includes(searchMode)) {
      setSearchMode("keyword-live");
    }
    if (activeTab === "Elite Promo Marketing" && searchMode !== "custom") {
      setSearchMode("custom");
    }
    if (activeTab === "PromoWorld" && searchMode !== "promoworld") {
      setSearchMode("promoworld");
    }
  }, [activeTab, searchMode]);

  // Open the custom product modal popup
  const openCustomPopup = (product = null) => {
    setEditMode(!!product);        // true if we passed a product
    setEditingProduct(product);    // null for "create", obj for "edit"
    setShowCustomPopup(true);
  };

  const handleCreateProduct = async (values) => {
    // Normalize "comma-sep" fields: accept string or array, output CSV string
    const toCsv = (v) => {
      if (v == null) return "";
      if (Array.isArray(v)) {
        return v.map(x => String(x).trim()).filter(Boolean).join(",");
      }
      if (typeof v === "string") {
        return v.split(",").map(s => s.trim()).filter(Boolean).join(",");
      }
      return String(v);
    };

    // If textarea holds a JSON string, pass it through;
    // if it's an object/array, stringify it; if empty, fallback to [].
    const jsonPassThrough = (v, fallback = []) => {
      if (v == null || v === "") return JSON.stringify(fallback);
      if (typeof v === "string") {
        try {
          JSON.parse(v);            // verify it's valid JSON
          return v;                 // already a JSON string
        } catch {
          // user typed non-JSON; wrap it as a string so backend doesn't crash
          return JSON.stringify(v);
        }
      }
      // object/array
      return JSON.stringify(v);
    };

    // File helper: support File | File[] | FileList
    const firstFile = (f) => {
      if (!f) return null;
      if (f instanceof File) return f;
      if (Array.isArray(f)) return f[0] || null;
      if (f && typeof f === "object" && "length" in f) return f[0] || null; // FileList
      return null;
    };

    try {
      const formData = new FormData();

      formData.append("instanceUniqueId", values.instanceUniqueId || "elite-promo-marketing");
      formData.append("supplierCode", values.supplierCode || "");

      // checkbox (optional)
      if (typeof values.overrideSupplier !== "undefined") {
        formData.append("overrideSupplier", String(!!values.overrideSupplier));
      }

      formData.append("supplier", values.supplier || "");
      formData.append("supplierObj", JSON.stringify(values.supplierObj ?? {}));
      formData.append("supplierDetails", JSON.stringify(values.supplierDetails || {}));
      formData.append("supplierAutoApprove", String(Boolean(values.supplierAutoApprove)));

      formData.append("name", values.name || "");
      formData.append("description", values.description || "");

      formData.append("imageUrl", values.imageUrl || "");
      formData.append(
        "imagesJson",
        jsonPassThrough(values.imagesJson, []) // accepts "[]", array, or object string
      );

       // pricing mode flags + helpers
       if (typeof values.isQUR !== "undefined") {
         formData.append("isQUR", values.isQUR ? "1" : "0");
       }
       if (typeof values.useAdvancedPrices !== "undefined") {
         formData.append("useAdvancedPrices", String(values.useAdvancedPrices));
       }
       if (typeof values.pricesJson !== "undefined") {
         formData.append("pricesJson", values.pricesJson || "");
       }

      // accept string or array
      formData.append("categories",  toCsv(values.categories));
      formData.append("themes",      toCsv(values.themes));
      formData.append("origin",      toCsv(values.origin));
      formData.append("tradeNames",  toCsv(values.tradeNames));

      // numbers (send as strings)
      formData.append("productionTime", String(values.productionTime ?? 0));
      formData.append("rushTime",       String(values.rushTime ?? 0));

      formData.append("currency", values.currency || "CAD");
      formData.append("price", String(values.price ?? 0));

      const isSinglePriceMode =
        values.priceMode === "single" ||
        String(values.useAdvancedPrices) !== "true";
      const submittedPrice = Number(values.price ?? 0);
      const submittedCost =
        values.cost === "" || values.cost == null
          ? submittedPrice
          : Number(values.cost);
      formData.append("cost", String(isSinglePriceMode ? submittedCost : 0));

      // JSON fields: handle textarea strings vs objects
      // If your form names are "variantsJson" / "attributesJson" / "skuJson", prefer those
      formData.append("variantsJson", jsonPassThrough(values.variantsJson ?? values.variants, []));
      formData.append("attributesJson", jsonPassThrough(values.attributesJson, {}));
      formData.append("skuJson", jsonPassThrough(values.skuJson ?? values.sku, []));

      const img = firstFile(values.image);
      if (img) formData.append("image", img);

      const response = await axios.post(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/products/create-custom-product`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            accessToken: localStorage.getItem("accessToken"),
          },
        }
      );

      alert("Created custom product successfully");
      console.log("Created custom product:", response.data);
      return true;
    } catch (error) {
      alert(error?.response?.data?.error || "Error creating custom product");
      return false;
      console.error("Error creating custom product:", error);
    }
  };

  const handleUpdateProduct = async (values, originalProduct) => {
    try {
      const payload = {
        ...values,
        instanceUniqueId,
        id: String(originalProduct?.Id ?? originalProduct?.id),
      };

      await axios.post(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/products/update-custom-product`,
        payload,
        { headers: { accessToken: localStorage.getItem("accessToken") } }
      );

      alert("Updated custom product successfully");

      // ✅ force-refresh the current results so the new supplier shows up
      await handleSearch(currentPage);
      return true;
    } catch (error) {
      console.error("Error updating custom product:", error);
      alert(error?.response?.data?.error || "Error updating custom product");
      return false;
    }
  };




  const handleAddCustomProduct = async (product) => {
    const rawId = product.Id || product.id;
    const source = "custom";
    const orderKey = makeOrderProductId(product, source);
    const defaultSku = deriveDefaultSku(product);

    try {
      setLoadingProducts(prev => ({ ...prev, [rawId]: true }));

      const parsedDefaultMargin = Number(defaultMargin);
      const margin = Number.isFinite(parsedDefaultMargin) ? parsedDefaultMargin : 40;
      const formattedProduct = normalizeCustomProductForOrder(product, {
        productId: orderKey,
        defaultSku,
        defaultMargin: margin,
        taxId: defaultTaxId,
      });

      await commitPickerAdd({ product: formattedProduct, existing: order?.Products || [], onAddProduct, replaceProducts: updateItemsToOrder });
      setError("");
    } catch (e) {
      console.error("Add custom product failed:", e);
      setError(e?.response?.data?.message || e?.message || "Unable to add this custom product to the order.");
    } finally {
      setLoadingProducts(prev => ({ ...prev, [rawId]: false }));
    }
  };


// utility – place near top of file
const priceFromMargin = (cost, marginPct = 40) => {
  const safeCost = Number(cost) || 0;
  const safeMargin = Number(marginPct);
  if (!(safeCost > 0) || !(safeMargin >= 0 && safeMargin < 100)) return 0;
  // Match edit/pricing-engine style rounding (nearest cent), not forced ceil.
  return Number((safeCost / (1 - safeMargin / 100)).toFixed(2));
};

const firstNonEmptyString = (...vals) => {
  for (const v of vals) {
    const s = String(v ?? "").trim();
    if (s) return s;
  }
  return "";
};

const deriveDefaultSku = (product = {}) => {
  const direct = firstNonEmptyString(
    product?.SKU,
    product?.sku,
    product?.Number,
    product?.ProductCode,
    product?.asiNumber,
    product?.Item_SKU
  );
  if (direct) return direct;

  if (Array.isArray(product?.Numbers) && product.Numbers.length) {
    const first = firstNonEmptyString(product.Numbers[0]);
    if (first) return first;
  }

  if (Array.isArray(product?.Variants) && product.Variants.length) {
    const firstVariant = product.Variants[0] || {};
    const first = firstNonEmptyString(firstVariant?.Number, firstVariant?.SKU, firstVariant?.sku);
    if (first) return first;
  }

  if (Array.isArray(product?.Sku) && product.Sku.length) {
    const firstSku = product.Sku[0] || {};
    const first = firstNonEmptyString(firstSku?.SKU, firstSku?.Number, firstSku?.sku);
    if (first) return first;
  }

  if (Array.isArray(product?.SKU) && product.SKU.length) {
    const firstSku = product.SKU[0] || {};
    const first = firstNonEmptyString(firstSku?.SKU, firstSku?.Number, firstSku?.sku);
    if (first) return first;
  }

  return firstNonEmptyString(product?.ProductId, product?.Id, product?.id);
};

const handleCardClick = async (product) => {
  if (!isPresentation) {
    openPopup(product, false, activeTab === "PromoWorld" ? "promoworld" : null);
    return;
  }

  const rawId  = product.Id || product.id;
  setLoadingProducts(prev => ({ ...prev, [rawId]: true }));

  try {
    const source   = getSourceFromTab(activeTab);          // 'asi', 'custom', or 'promoworld'
    const orderKey = makeOrderProductId(product, source);  // custom gets CUSTOM- prefix; others keep raw IDs

    // PromoWorld search results are intentionally lightweight. Before adding
    // one to a Showcase/cart, hydrate the full catalogue record so variants,
    // attributes, descriptions, supplier metadata, categories, and pricing
    // are not lost when the selected line is persisted.
    let resolvedProduct = product;
    if (source === "promoworld" && rawId) {
      try {
        const detailResponse = await axios.get(
          `${process.env.REACT_APP_NODEJS_SERVER_URL}/catalog/products/${encodeURIComponent(rawId)}`
        );
        if (detailResponse?.data && typeof detailResponse.data === "object") {
          resolvedProduct = detailResponse.data;
        }
      } catch (detailError) {
        console.warn("PromoWorld detail hydration failed; using search result fallback.", detailError);
      }
    }

    const selectedVariant = Array.isArray(resolvedProduct?.Variants) ? resolvedProduct.Variants[0] : null;
    const variantPrices = Array.isArray(selectedVariant?.Prices) ? selectedVariant.Prices : [];
    const variantPrice = variantPrices[0] || null;
    const defaultSku = deriveDefaultSku(resolvedProduct);

    const color  = selectedVariant?.Color || resolvedProduct?.Colors?.[0] || "";
    const size   = selectedVariant?.Size || resolvedProduct?.Sizes?.[0] || "";
    const parsedQty = Number(
      variantPrice?.Quantity?.From ??
      product?.Price?.Quantity?.From ??
      1
    );
    const qty = Number.isFinite(parsedQty) && parsedQty > 0 ? parsedQty : 1;
    const parsedCost = Number(variantPrice?.Cost ?? product?.Price?.Cost ?? 0);
    const rawCost = Number.isFinite(parsedCost) ? parsedCost : 0;
    const costCents = toCents(rawCost);
    const costForPricing = fromCents(costCents);
    const parsedDefaultMargin = Number(defaultMargin);
    const margin = Number.isFinite(parsedDefaultMargin) ? parsedDefaultMargin : 40;
    const explicitRetail = Number(variantPrice?.Price ?? product?.Price?.Price);
    const isLocked = Boolean(variantPrice?.IsLocked ?? selectedVariant?.IsLocked ?? product?.Price?.IsLocked ?? product?.IsLocked);
    const explicitRetailCents =
      Number.isFinite(explicitRetail) && explicitRetail > 0
        ? toCents(explicitRetail)
        : 0;

    const retailCents =
      isLocked && explicitRetailCents > 0
        ? explicitRetailCents
        : toCents(priceFromMargin(costForPricing, margin));
    const lineRevenueCents = retailCents * qty;

    const promoWorldPricings = source === "promoworld"
      ? variantPrices.map((priceBreak, index) => {
          const rowQtyRaw = Number(priceBreak?.Quantity?.From ?? 1);
          const rowQty = Number.isFinite(rowQtyRaw) && rowQtyRaw > 0 ? rowQtyRaw : 1;
          const rowCostRaw = Number(priceBreak?.Cost ?? 0);
          const rowCost = Number.isFinite(rowCostRaw) ? rowCostRaw : 0;
          const rowExplicitRetail = Number(priceBreak?.Price);
          const rowLocked = Boolean(priceBreak?.IsLocked ?? selectedVariant?.IsLocked ?? resolvedProduct?.IsLocked);
          const rowRetail =
            rowLocked && Number.isFinite(rowExplicitRetail) && rowExplicitRetail > 0
              ? rowExplicitRetail
              : priceFromMargin(rowCost, margin);

          return {
            Type: "BreakDown",
            SubType: "",
            CostName: priceBreak?.CostName || `${rowQty}+`,
            ProductId: orderKey,
            SKU: selectedVariant?.SKU || defaultSku,
            Quantity: rowQty,
            NetCost: rowCost,
            Margin: margin,
            Retail: rowRetail,
            ClientPrice: rowRetail,
            Total: +(rowRetail * rowQty).toFixed(2),
            CurrencyCode: priceBreak?.CurrencyCode || selectedVariant?.CurrencyCode || resolvedProduct?.CurrencyCode || "CAD",
            IsLocked: rowLocked,
            DisplayStatus: "Display to Client",
            Color: selectedVariant?.Color || "",
            Size: selectedVariant?.Size || "",
            SortOrder: index,
          };
        })
      : [];

    const formattedProduct = {
      // Preserve rich source metadata. This matters for Showcase, where the
      // selected product is also the seed used for WordPress product creation.
      ...(source === "promoworld" && resolvedProduct && typeof resolvedProduct === "object"
        ? resolvedProduct
        : {}),

      // identity
      ProductId: orderKey,
      Source: source,
      LookupType: source === "custom" ? "custom" : source === "promoworld" ? "promoworld" : popupLookupType,

      // display
      Id: rawId,
      Imprinting: resolvedProduct.Imprinting,
      selectedColor: color,
      Size: size,
      Colors: resolvedProduct?.Colors,
      Sizes: resolvedProduct?.Sizes,
      ImageUrl: activeTab === "ASI"
        ? `https://api.asicentral.com/v1/${resolvedProduct.ImageUrl}?size=normal`
        : resolvedProduct.ImageUrl,
      Name: resolvedProduct.Name,
      Description: resolvedProduct.Description,
      ShortDescription: resolvedProduct.ShortDescription,

      // pricing
      Quantity: qty,
      Cost: fromCents(costCents),
      Retail: fromCents(retailCents),
      ClientPrice: fromCents(retailCents),
      Total: fromCents(lineRevenueCents),
      Subtotal: fromCents(lineRevenueCents),
      CurrencyCode: variantPrice?.CurrencyCode || selectedVariant?.CurrencyCode || resolvedProduct?.Price?.CurrencyCode || resolvedProduct?.CurrencyCode,

      // catalog variant details
      VariantId: selectedVariant?.Id,
      ExternalVariantId: selectedVariant?.ExternalVariantId,
      UPC: selectedVariant?.UPC,
      ColorHex: selectedVariant?.ColorHex,
      VariantImageUrl: selectedVariant?.ImageUrl,

      // defaults
      Margin: margin,
      IsLocked: isLocked,
      Tax: defaultTaxId,

      // supplier
      Supplier: resolvedProduct?.Supplier?.Name || resolvedProduct?.SupplierName || resolvedProduct?.Supplier || "",
      SupplierId: resolvedProduct?.Supplier?.Id || resolvedProduct?.SupplierId || resolvedProduct?.supplierId || null,

      // sku defaults for /orders/edit normalization
      SKU: selectedVariant?.SKU || defaultSku,
      Number: selectedVariant?.SKU || defaultSku,

      // Keep PromoWorld's source payload available to the shared Edit Item flow.
      // The editor still supports the legacy asiLiveRawData name, while ProductData
      // gives source-neutral consumers a canonical rich catalogue object.
      ...(source === "promoworld" ? {
        ProductData: resolvedProduct,
        productData: resolvedProduct,
        pricings: promoWorldPricings.length ? promoWorldPricings : undefined,
      } : {})
    };

    await commitPickerAdd({ product: formattedProduct, existing: order?.Products || [], onAddProduct, replaceProducts: updateItemsToOrder });
  } catch (e) {
    console.error("Add (presentation) product failed:", e);
    setError(e?.response?.data?.message || e?.message || "Unable to add this product.");
  } finally {
    setLoadingProducts(prev => ({ ...prev, [rawId]: false }));
  }
};


  // Returns the unique key you'd expect to exist in order.Products[].ProductId
  const candidateOrderKey = (product) => {
    const raw = String(product?.Id ?? product?.id ?? "");
    const source = getSourceFromTab(activeTab); // "custom" or "asi" in this view
    return makeOrderProductId({ Id: raw }, source);
  };

  // Robust compare against existing list (supports legacy numeric-only items)
 // ───────── REPLACE your current checkIsSelected with this ─────────
// normalize + compare helpers (place near your other helpers in the component file)
const _eq = (a, b) => String(a ?? "").toLowerCase() === String(b ?? "").toLowerCase();
const _stripCustom = (v) => String(v ?? "").replace(/^custom-/i, ""); // strips CUSTOM- / custom-

// Canonicalize a pid based on source (custom => strip prefix, asi => raw)
const _canonPid = (src, pid) => (String(src).toLowerCase() === "custom" ? _stripCustom(pid) : String(pid ?? ""));
const checkIsSelected = (product) => {
  const raw = String(product?.Id ?? product?.id ?? "").trim();
  if (!raw) return false;

  const src = getSourceFromTab(activeTab);       // 'asi' | 'custom'
  const pid = makeOrderProductId({ Id: raw }, src);

  // canonical pid
  if (selectedIndex.has(canonicalKey(src, pid))) return true;

  // also support raw-id alias for custom lines
  if (normalizeSource(src) === "custom" && selectedIndex.has(`custom|${raw}`)) return true;

  return false;
};

const removeFromSelected = async (product) => {
  const rawId = product?.Id ?? product?.id;
  try {
    setLoadingProducts((prev) => ({ ...prev, [rawId]: true }));

    const raw = String(rawId ?? "").trim();
    const src = getSourceFromTab(activeTab);
    const pid = makeOrderProductId({ Id: raw }, src);

    const updated = (order?.Products || []).filter((p) => {
      const psrc = getItemSource(p);
      const ppid = getItemPid(p);

      // remove canonical match
      if (canonicalKey(psrc, ppid) === canonicalKey(src, pid)) return false;

      // remove raw-id alias for custom
      if (normalizeSource(src) === "custom" && normalizeSource(psrc) === "custom") {
        if (String(p?.RawProductId ?? "").trim() === raw) return false;
      }

      return true;
    });

    await commitPickerRemove({ product: { Source: src, ProductId: pid }, remaining: updated, onRemoveProduct, replaceProducts: updateItemsToOrder });
  } catch (err) {
    console.error("Error removing product from order:", err);
  } finally {
    setLoadingProducts((prev) => ({ ...prev, [rawId]: false }));
  }
};



  // permissions
  const canCreateCustom = [
    "order-rep",
    "client-rep",
    "operations-rep",
    "promo-store-manager",
    "administrator",
  ].includes(authState.role);

  const canImportCatalogue = authState.role === "administrator";



const [viewMode, setViewMode] = useState("card");


const theme = useTheme();
const C = {
  headerBg:    "#1e293b",
  headerText:  "#f8fafc",
  headerMuted: "#94a3b8",
  border:      theme.palette.divider,
  textPri:     theme.palette.text.primary,
  textSec:     theme.palette.text.secondary,
  textMuted:   theme.palette.text.disabled,
  paperBg:     theme.palette.background.paper,
  subtleBg:    theme.palette.action.hover,
};



const [visibleColumns, setVisibleColumns] = useState(
  () => new Set(PRODUCT_COLUMNS.filter(c => c.visible !== false).map(c => c.id))
);
const [density,            setDensity]            = useState("comfortable");
const [columnMenuAnchor,   setColumnMenuAnchor]   = useState(null);
const [densityMenuAnchor,  setDensityMenuAnchor]  = useState(null);

const densitySettings = {
  compact:     { py: 0.75, fontSize: "0.8125rem" },
  comfortable: { py: 1.5,  fontSize: "0.875rem"  },
  spacious:    { py: 2.25, fontSize: "0.9375rem" },
};
const currentDensity = densitySettings[density];

const toggleColVisibility = (colId) =>
  setVisibleColumns(prev => {
    const next = new Set(prev);
    next.has(colId) ? next.delete(colId) : next.add(colId);
    return next;
  });



const resolveImageUrl = (product) => {
  if (activeTab === "ASI" && product.ImageUrl) {
    return `https://api.asicentral.com/v1/${product.ImageUrl}?size=normal`;
  }
  if (activeTab === "PromoWorld") return productImageCandidates(product)[0] || "";
  return (
    product.ImageUrl ||
    (Array.isArray(product.Images) ? product.Images[0] : "") ||
    ""
  );
};

const handleProductImageError = (event, product) => {
  if (activeTab === "PromoWorld") showNextProductImage(event, product);
  else showProductImagePlaceholder(event);
};

const resolvePrice = (product) => {
  const customPrice = activeTab === "Elite Promo Marketing" ? getCustomProductPriceBreak(product) : null;
  const val =
    (customPrice && (Number(customPrice.Cost ?? customPrice.cost) > 0
      ? customPrice.Cost ?? customPrice.cost
      : customPrice.Price ?? customPrice.price)) ??
    product.Price?.Cost ??
    product.Price?.Price ??
    product.Prices?.[0]?.Cost ??
    product.Prices?.[0]?.Price ??
    null;
  const currency =
    customPrice?.CurrencyCode ||
    customPrice?.currencyCode ||
    product.Price?.CurrencyCode ||
    product.Prices?.[0]?.CurrencyCode ||
    product.Currency ||
    "CAD";
  const numericValue = Number(val);
  return val != null && Number.isFinite(numericValue) ? { value: numericValue, currency } : null;
};

const resolveSupplierName = (product) =>
  product.Supplier?.Name ||
  product.SupplierName ||
  (typeof product.Supplier === "string" ? product.Supplier : "") ||
  "";

const resolveInventoryLabel = (product) => {
  const summary = product?.InventorySummary || {};
  if (summary.hasExactQuantities && summary.totalQuantityAvailable != null) return `${summary.totalQuantityAvailable} available`;
  if (summary.isCloseout) return "Closeout";
  if (summary.isAvailable === true) {
    return summary.totalVariantCount > 1
      ? `Available: ${summary.availableVariantCount}/${summary.totalVariantCount} variants`
      : "Available";
  }
  if (summary.isAvailable === false) return "Unavailable";
  if (product?.Availability?.isAvailable === true || product?.HasInventory === true) return "Available";
  if (product?.Availability?.isAvailable === false || product?.HasInventory === false) return "Unavailable";
  return "Stock unknown";
};

const resolveSku = (product) =>
  product.Number ||
  product.SKU ||
  (Array.isArray(product.Numbers) ? product.Numbers[0] : "") ||
  "";

const resolveAddHandler = (product) =>
  activeTab === "ASI" || activeTab === "PromoWorld"
    ? () => handleCardClick(product)
    : () => handleAddCustomProduct(product);


const renderSkeletonCards = () => (
  <Box
    sx={{
      display: "grid",
      gridTemplateColumns: "repeat(auto-fill, minmax(190px, 1fr))",
      gap: 2,
      mt: 2,
    }}
  >
    {Array.from({ length: 8 }).map((_, i) => (
      <Box
        key={i}
        sx={{ border: `1px solid ${C.border}`, borderRadius: "10px", overflow: "hidden", bgcolor: C.paperBg }}
      >
        <Skeleton variant="rectangular" height={150} />
        <Box sx={{ p: 1.25 }}>
          <Skeleton width="85%" height={16} sx={{ mb: 0.75 }} />
          <Skeleton width="55%" height={12} sx={{ mb: 0.5 }} />
          <Skeleton width="40%" height={12} />
        </Box>
      </Box>
    ))}
  </Box>
);


const renderSkeletonTable = () => (
  <TableContainer
    component={Paper}
    elevation={0}
    sx={{ border: `1px solid ${C.border}`, borderRadius: "10px", mt: 2 }}
  >
    <Table size="small">
      <TableHead>
        <TableRow>
          {["Image", "Product Name", "SKU", "Supplier", "Price", ""].map((h) => (
            <TableCell
              key={h}
              sx={{
                bgcolor: C.headerBg, color: C.headerText, fontWeight: 700,
                fontSize: "0.72rem", letterSpacing: "0.04em",
                textTransform: "uppercase", borderBottom: "none", py: 1.25,
              }}
            >
              {h}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {Array.from({ length: 6 }).map((_, i) => (
          <TableRow key={i}>
            <TableCell>
              <Skeleton variant="rectangular" width={40} height={40} sx={{ borderRadius: 1 }} />
            </TableCell>
            <TableCell><Skeleton width="70%" /></TableCell>
            <TableCell><Skeleton width="50%" /></TableCell>
            <TableCell><Skeleton width="60%" /></TableCell>
            <TableCell><Skeleton width="40%" /></TableCell>
            <TableCell><Skeleton width={60} /></TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
);

const hasSearched = activeTab === "ASI" ? asiHasSearched : activeTab === "PromoWorld" ? promoWorldHasSearched : customHasSearched;

const renderEmptyState = () => (
  <Box
    sx={{
      display: "flex", flexDirection: "column",
      alignItems: "center", justifyContent: "center",
      py: 8, color: C.textMuted,
    }}
  >
    <InventoryIcon sx={{ fontSize: 48, mb: 1.5, opacity: 0.3 }} />
    <Typography variant="body1" fontWeight={600} sx={{ mb: 0.5, color: C.textSec }}>
      {hasSearched ? "No products found" : "Search to browse products"}
    </Typography>
    <Typography variant="body2" sx={{ color: C.textMuted }}>
      {hasSearched
        ? "Try different keywords or clear the supplier filter."
        : activeTab === "ASI"
        ? 'Enter a keyword like "hat" or "shirt" and press Search.'
        : activeTab === "PromoWorld"
        ? "Search the global PromoWorld catalogue."
        : "Enter a product name to search custom products."}
    </Typography>
  </Box>
);


const renderCardGrid = () => (
  <Box
    sx={{
      display: "grid",
      gridTemplateColumns: "repeat(auto-fill, minmax(190px, 1fr))",
      gap: 2,
      mt: 2,
    }}
  >
    {products.map((product) => {
      const rawId        = product.Id || product.id;
      const isSelected   = checkIsSelected(product);
      const isLoading    = !!loadingProducts[rawId];
      const imgUrl       = resolveImageUrl(product);
      const name         = product.Name || "Unnamed Product";
      const sku          = resolveSku(product);
      const supplierName = resolveSupplierName(product);
      const priceObj     = resolvePrice(product);
      const addHandler   = resolveAddHandler(product);
      const inventoryLabel = resolveInventoryLabel(product);

      return (
        <Tooltip
          key={rawId}
          placement="top"
          arrow
          title={
            <Box sx={{ maxWidth: 220, p: 0.5 }}>
              <Typography variant="caption" fontWeight={700} display="block">{name}</Typography>
              {sku          && <Typography variant="caption" display="block" sx={{ opacity: 0.75 }}>SKU: {sku}</Typography>}
              {supplierName && <Typography variant="caption" display="block" sx={{ opacity: 0.75 }}>Supplier: {supplierName}</Typography>}
              {priceObj     && <Typography variant="caption" display="block" sx={{ opacity: 0.75 }}>Price: {priceObj.currency} ${priceObj.value.toFixed(2)}</Typography>}
            </Box>
          }
        >
          <Box
            onClick={() =>
              !isPresentation
                ? activeTab === "Elite Promo Marketing"
                  ? openPopup(rawId, true, "custom")
                  : openPopup(product, false, activeTab === "PromoWorld" ? "promoworld" : null)
                : addHandler()
            }
            sx={{
              position: "relative",
              border: "1.5px solid",
              borderColor: isSelected ? "primary.main" : C.border,
              borderRadius: "10px",
              bgcolor: C.paperBg,
              overflow: "hidden",
              cursor: "pointer",
              transition: "box-shadow 0.18s ease, transform 0.18s ease, border-color 0.18s ease",
              "&:hover": {
                boxShadow: "0 4px 18px rgba(0,0,0,0.10)",
                transform: "translateY(-2px)",
                borderColor: "primary.main",
              },
            }}
          >

            {!isPresentation && activeTab === "Elite Promo Marketing" && canCreateCustom && (
              <IconButton
                size="small"
                onClick={(e) => { e.stopPropagation(); openCustomPopup(product); }}
                title="Edit custom product"
                sx={{
                  position: "absolute", top: 6, right: 6, zIndex: 2,
                  bgcolor: "#ff9800", color: "#fff", width: 26, height: 26,
                  "&:hover": { bgcolor: "#fb8c00" },
                }}
              >
                <BuildIcon sx={{ fontSize: 14 }} />
              </IconButton>
            )}


            {isSelected && (
              <CheckCircleIcon
                sx={{
                  position: "absolute", top: 8, left: 8, fontSize: 20,
                  color: "primary.main", zIndex: 2, bgcolor: C.paperBg, borderRadius: "50%",
                }}
              />
            )}


            {activeTab === "PromoWorld" && (
              <Chip
                label={inventoryLabel === "Stock unknown" ? "PromoWorld" : inventoryLabel}
                size="small"
                sx={{
                  position: "absolute", top: 6, left: 6, zIndex: 2, height: 20,
                  fontSize: "0.62rem", fontWeight: 800,
                  bgcolor: "#e0f2fe", color: "#0369a1", border: "1px solid #7dd3fc",
                  "& .MuiChip-label": { px: "7px" }
                }}
              />
            )}

            {isLoading && (
              <Box
                sx={{
                  position: "absolute", inset: 0, zIndex: 3, borderRadius: "10px",
                  bgcolor: "rgba(255,255,255,0.72)",
                  display: "flex", alignItems: "center", justifyContent: "center",
                }}
              >
                <CircularProgress size={28} thickness={4} />
              </Box>
            )}


            <Box
              sx={{
                width: "100%", height: 150,
                display: "flex", alignItems: "center", justifyContent: "center",
                bgcolor: "#f8fafc", borderBottom: `1px solid ${C.border}`, overflow: "hidden",
              }}
            >
              {imgUrl ? (
                <Box
                  component="img"
                  key={imgUrl} src={imgUrl}
                  alt={name}
                  sx={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }}
                  onError={event => handleProductImageError(event, product)}
                />
              ) : null}
              <Box
                sx={{
                  display: imgUrl ? "none" : "flex",
                  flexDirection: "column", alignItems: "center", color: C.textMuted,
                }}
              >
                <ImageNotSupportedIcon sx={{ fontSize: 32, mb: 0.5 }} />
                <Typography variant="caption" sx={{ fontSize: "0.65rem" }}>No image</Typography>
              </Box>
            </Box>


            <Box sx={{ p: 1.25 }}>
              <Typography
                variant="body2"
                fontWeight={600}
                sx={{
                  overflow: "hidden", display: "-webkit-box",
                  WebkitLineClamp: 2, WebkitBoxOrient: "vertical",
                  lineHeight: 1.35, color: C.textPri, mb: 0.5, fontSize: "0.8125rem",
                }}
              >
                {name}
              </Typography>

              {sku && (
                <Typography variant="caption" sx={{ color: C.textMuted, fontFamily: "monospace", fontSize: "0.68rem", display: "block" }}>
                  {sku}
                </Typography>
              )}

              {supplierName && (
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.4, mt: 0.5 }}>
                  <StorefrontIcon sx={{ fontSize: 11, color: C.textMuted }} />
                  <Typography variant="caption" sx={{ color: C.textMuted, fontSize: "0.68rem", lineHeight: 1 }}>
                    {supplierName}
                  </Typography>
                </Box>
              )}

              {priceObj && (
                <Typography variant="caption" fontWeight={700} sx={{ display: "block", mt: 0.5, color: "primary.main", fontSize: "0.78rem" }}>
                  {priceObj.currency} ${priceObj.value.toFixed(2)}
                </Typography>
              )}
            </Box>


            {isPresentation && (
              <Box sx={{ px: 1.25, pb: 1.25, display: "flex", justifyContent: "flex-end" }} onClick={(e) => e.stopPropagation()}>
                {isSelected ? (
                  <Button
                    size="small" variant="outlined" color="error"
                    onClick={() => removeFromSelected(product)}
                    sx={{ fontSize: "0.7rem", height: 26, textTransform: "none", fontWeight: 600, borderRadius: "6px" }}
                  >
                    Remove
                  </Button>
                ) : (
                  <Button
                    size="small" variant="contained"
                    onClick={addHandler}
                    sx={{ fontSize: "0.7rem", height: 26, textTransform: "none", fontWeight: 600, borderRadius: "6px", boxShadow: "none" }}
                  >
                    Add
                  </Button>
                )}
              </Box>
            )}
          </Box>
        </Tooltip>
      );
    })}
  </Box>
);


const renderTableView = () => (
  <TableContainer
    component={Paper}
    elevation={0}
    sx={{ border: `1px solid ${C.border}`, borderRadius: "10px", mt: 2 }}
  >
    <Table size="small" stickyHeader>
      <TableHead>
        <TableRow>
          {[
            { label: "Image",        width: 64    },
            { label: "Product Name", width: "auto" },
            { label: "SKU",          width: 130   },
            { label: "Supplier",     width: 160   },
            { label: "Price",        width: 100   },
            { label: "",             width: 110   },
          ].map(({ label, width }) => (
            <TableCell
              key={label}
              sx={{
                width,
                bgcolor: C.headerBg, color: C.headerText,
                fontWeight: 700, fontSize: "0.72rem",
                letterSpacing: "0.04em", textTransform: "uppercase",
                borderBottom: "none", py: 1.25,
                "&:first-of-type": { borderRadius: "10px 0 0 0" },
                "&:last-of-type":  { borderRadius: "0 10px 0 0"  },
              }}
            >
              {label}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {products.map((product, idx) => {
          const rawId        = product.Id || product.id;
          const isSelected   = checkIsSelected(product);
          const isLoading    = !!loadingProducts[rawId];
          const imgUrl       = resolveImageUrl(product);
          const name         = product.Name || "Unnamed Product";
          const sku          = resolveSku(product) || "—";
          const supplierName = resolveSupplierName(product) || "—";
          const priceObj     = resolvePrice(product);
          const addHandler   = resolveAddHandler(product);
      const inventoryLabel = resolveInventoryLabel(product);

          return (
            <TableRow
              key={rawId}
              hover
              onClick={() =>
                !isPresentation
                  ? activeTab === "Elite Promo Marketing"
                    ? openPopup(rawId, true, "custom")
                    : openPopup(product, false, activeTab === "PromoWorld" ? "promoworld" : null)
                  : undefined
              }
              sx={{
                cursor: isPresentation ? "default" : "pointer",
                bgcolor: isSelected
                  ? "rgba(25, 118, 210, 0.05)"
                  : idx % 2 === 0 ? C.paperBg : C.subtleBg,
                transition: "background-color 0.12s",
              }}
            >
              {/* Thumbnail */}
              <TableCell sx={{ py: 1, px: 1.5 }}>
                <Box
                  sx={{
                    width: 40, height: 40, borderRadius: 1,
                    border: `1px solid ${C.border}`,
                    display: "flex", alignItems: "center", justifyContent: "center",
                    bgcolor: "#f8fafc", flexShrink: 0, overflow: "hidden",
                  }}
                >
                  {imgUrl ? (
                    <Box component="img" key={imgUrl} src={imgUrl} alt="" onError={event => handleProductImageError(event, product)} sx={{ width: "100%", height: "100%", objectFit: "contain" }} />
                  ) : null}
                  <ImageNotSupportedIcon sx={{ display: imgUrl ? "none" : "block", fontSize: 16, color: C.textMuted }} />
                </Box>
              </TableCell>

              {/* Name */}
              <TableCell sx={{ py: 1 }}>
                <Tooltip title={name} placement="top-start">
                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                    {isSelected && <CheckCircleIcon sx={{ fontSize: 13, color: "primary.main", flexShrink: 0 }} />}
                    {activeTab === "PromoWorld" && <Chip label={inventoryLabel === "Stock unknown" ? "PromoWorld" : inventoryLabel} size="small" sx={{ height: 18, fontSize: "0.6rem", fontWeight: 800, bgcolor: "#e0f2fe", color: "#0369a1", border: "1px solid #7dd3fc", "& .MuiChip-label": { px: "6px" } }} />}
                    <Typography
                      variant="body2" fontWeight={600}
                      sx={{ color: C.textPri, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: 240, fontSize: "0.8125rem" }}
                    >
                      {name}
                    </Typography>
                  </Box>
                </Tooltip>
              </TableCell>

              {/* SKU */}
              <TableCell sx={{ py: 1 }}>
                <Typography variant="caption" sx={{ fontFamily: "monospace", color: C.textSec, fontSize: "0.75rem" }}>
                  {sku}
                </Typography>
              </TableCell>

              {/* Supplier */}
              <TableCell sx={{ py: 1 }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                  <StorefrontIcon sx={{ fontSize: 13, color: C.textMuted }} />
                  <Typography variant="caption" sx={{ color: C.textSec }}>
                    {supplierName}
                  </Typography>
                </Box>
              </TableCell>

              {/* Price */}
              <TableCell sx={{ py: 1 }}>
                <Typography variant="caption" fontWeight={700} sx={{ color: priceObj ? "primary.main" : C.textMuted }}>
                  {priceObj ? `${priceObj.currency} $${priceObj.value.toFixed(2)}` : "QUR"}
                </Typography>
              </TableCell>

              {/* Actions */}
              <TableCell sx={{ py: 1 }} onClick={(e) => e.stopPropagation()}>
                {isLoading ? (
                  <CircularProgress size={18} thickness={4} />
                ) : !isPresentation ? (
                  activeTab === "Elite Promo Marketing" && canCreateCustom ? (
                    <IconButton
                      size="small"
                      onClick={(e) => { e.stopPropagation(); openCustomPopup(product); }}
                      title="Edit custom product"
                      sx={{ bgcolor: "#ff9800", color: "#fff", width: 26, height: 26, "&:hover": { bgcolor: "#fb8c00" } }}
                    >
                      <BuildIcon sx={{ fontSize: 14 }} />
                    </IconButton>
                  ) : (
                    <Button
                      size="small" variant="outlined"
                      onClick={() => activeTab === "Elite Promo Marketing" ? openPopup(rawId, true, "custom") : openPopup(product, false, activeTab === "PromoWorld" ? "promoworld" : null)}
                      sx={{ fontSize: "0.7rem", height: 26, textTransform: "none", fontWeight: 600, borderRadius: "6px" }}
                    >
                      View
                    </Button>
                  )
                ) : isSelected ? (
                  <Button
                    size="small" variant="outlined" color="error"
                    onClick={() => removeFromSelected(product)}
                    sx={{ fontSize: "0.7rem", height: 26, textTransform: "none", fontWeight: 600, borderRadius: "6px" }}
                  >
                    Remove
                  </Button>
                ) : (
                  <Button
                    size="small" variant="contained"
                    onClick={addHandler}
                    sx={{ fontSize: "0.7rem", height: 26, textTransform: "none", fontWeight: 600, borderRadius: "6px", boxShadow: "none" }}
                  >
                    Add
                  </Button>
                )}
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  </TableContainer>
);


const renderProductOutput = () => {
  if (loading) return viewMode === "card" ? renderSkeletonCards() : renderSkeletonTable();
  if (products.length === 0) return renderEmptyState();
  return viewMode === "card" ? renderCardGrid() : renderTableView();
};


const renderSearchBar = ({ showModeSelect = false } = {}) => {
  const qKey =
    activeTab === "ASI"
      ? (ASI_MODES.includes(searchMode) ? searchMode : "keyword-live")
      : activeTab === "PromoWorld"
      ? "promoworld"
      : "custom";

  const placeholder =
    activeTab === "Elite Promo Marketing" ? "Search custom products…"
    : activeTab === "PromoWorld" ? "Search PromoWorld products…"
    : searchMode === "keyword-test" ? "Test keyword (e.g. hat, shirt)"
    : searchMode === "asi-test"     ? "ASI Test Product ID"
    : searchMode === "asi-live"     ? "ASI Live Product ID"
    :                                 "Search by keyword (e.g. hat, shirt)";

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 1.5, flexWrap: "wrap" }}>

      {showModeSelect && activeTab === "ASI" && (
        <TextField
          select size="small"
          value={searchMode}
          onChange={(e) => setSearchMode(e.target.value)}
          sx={{ minWidth: 148 }}
        >
          <MenuItem value="keyword-live">Keyword Live</MenuItem>
          <MenuItem value="keyword-test">Keyword Test</MenuItem>
          <MenuItem value="asi-live">ASI # Live</MenuItem>
          <MenuItem value="asi-test">ASI # Test</MenuItem>
        </TextField>
      )}


      <TextField
        size="small"
        variant="outlined"
        placeholder={placeholder}
        value={queries[qKey] || ""}
        onChange={(e) => setQueries((q) => ({ ...q, [qKey]: e.target.value }))}
        onKeyDown={(e) => { if (e.key === "Enter") handleSearch(1); }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon fontSize="small" sx={{ color: C.textMuted }} />
            </InputAdornment>
          ),
          endAdornment: queries[qKey] ? (
            <InputAdornment position="end">
              <IconButton size="small" edge="end" onClick={() => setQueries((q) => ({ ...q, [qKey]: "" }))}>
                <ClearIcon fontSize="small" />
              </IconButton>
            </InputAdornment>
          ) : null,
        }}
        sx={{ flex: 1, minWidth: 200, maxWidth: 420 }}
      />


      <Button
        variant="contained" size="small"
        onClick={() => handleSearch(1)}
        startIcon={<SearchIcon />}
        sx={{ height: 40, textTransform: "none", fontWeight: 600, fontSize: "0.8125rem", borderRadius: "8px", boxShadow: "none", "&:hover": { boxShadow: "none" } }}
      >
        Search
      </Button>

      <Box sx={{ flex: 1 }} />


      <ToggleButtonGroup
        value={viewMode}
        exclusive
        onChange={(_, val) => val && setViewMode(val)}
        size="small"
        aria-label="product view mode"
        sx={{
          "& .MuiToggleButton-root": {
            border: `1px solid ${C.border}`, px: 1.5, py: 0.75,
            "&.Mui-selected": { bgcolor: "primary.main", color: "#fff", "&:hover": { bgcolor: "primary.dark" } },
          },
        }}
      >
        <Tooltip title="Card view" placement="top">
          <ToggleButton value="card" aria-label="card view"><ViewModuleIcon fontSize="small" /></ToggleButton>
        </Tooltip>
        <Tooltip title="Table view" placement="top">
          <ToggleButton value="table" aria-label="table view"><ViewListIcon fontSize="small" /></ToggleButton>
        </Tooltip>
      </ToggleButtonGroup>
    </Box>
  );
};

const renderPagination = () => {
  const show = activeTab === "ASI" ? asiHasSearched : activeTab === "PromoWorld" ? promoWorldHasSearched : customHasSearched;
  if (!show || totalPages <= 1) return null;
  return (
    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 1.5, mt: 2, py: 1 }}>
      <Button
        size="small" variant="outlined"
        onClick={handlePreviousPage} disabled={currentPage === 1}
        sx={{ textTransform: "none", fontWeight: 600, borderRadius: "8px", fontSize: "0.8rem" }}
      >
        Previous
      </Button>
      <Typography variant="body2" sx={{ color: C.textSec, fontWeight: 500, minWidth: 80, textAlign: "center" }}>
        Page {currentPage} of {totalPages}
      </Typography>
      <Button
        size="small" variant="outlined"
        onClick={handleNextPage} disabled={currentPage === totalPages}
        sx={{ textTransform: "none", fontWeight: 600, borderRadius: "8px", fontSize: "0.8rem" }}
      >
        Next
      </Button>
    </Box>
  );
};

const renderSupplierFilter = () => (
  <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1.5 }}>
    <TextField
      size="small"
      type="text"
      inputProps={{ inputMode: "numeric", pattern: "\\d*" }}
      value={asiSupplierId}
      onChange={(e) => setAsiSupplierId(e.target.value.replace(/\D/g, ""))}
      placeholder="ASI Supplier # (e.g. 34063)"
      disabled={searchMode !== "keyword-live"}
      sx={{ maxWidth: 224 }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <StorefrontIcon fontSize="small" sx={{ color: C.textMuted }} />
          </InputAdornment>
        ),
      }}
    />
    <Tooltip title="Pick from supplier list" placement="top">
      <span>
        <IconButton size="small" onClick={openSupplierPicker} disabled={searchMode !== "keyword-live"}>
          <AddIcon />
        </IconButton>
      </span>
    </Tooltip>
    {!!asiSupplierId && (
      <Button
        size="small" variant="outlined" color="error"
        onClick={() => setAsiSupplierId("")}
        sx={{ fontSize: "0.72rem", height: 32, textTransform: "none", borderRadius: "8px" }}
      >
        Clear
      </Button>
    )}
  </Box>
);

const renderSupplierPickerDialog = () => (
  <Dialog open={supplierPickerOpen} onClose={() => setSupplierPickerOpen(false)} maxWidth="sm" fullWidth>
    <DialogTitle className="create-order-dialog-title">Select supplier</DialogTitle>
    <DialogContent className="create-order-dialog-content" dividers>
      {loadingSupplierOptions ? (
        <CircularProgress size={24} />
      ) : (
        <List dense>
          {supplierOptions.map((s) => (
            <ListItemButton
              key={s.id}
              onClick={() => handlePickSupplier(s)}
              divider
              disabled={!getAsiFromSupplier(s)}
            >
              <ListItemText
                primary={s.businessName || s.name || "Unnamed"}
                secondary={`ASI: ${getAsiFromSupplier(s) || "—"}`}
                primaryTypographyProps={{ fontWeight: 600, fontSize: "0.875rem" }}
                secondaryTypographyProps={{ fontSize: "0.75rem" }}
              />
            </ListItemButton>
          ))}
        </List>
      )}
    </DialogContent>
    <DialogActions>
      <Button onClick={() => setSupplierPickerOpen(false)}>Close</Button>
    </DialogActions>
  </Dialog>
);



const [exportMenuAnchor, setExportMenuAnchor] = useState(null);


const getExportRows = () =>
  products.map((p, i) => {
    const priceVal = p.Price?.Cost ?? p.Price?.Price ?? p.Prices?.[0]?.Cost ?? "";
    const currency = p.Price?.CurrencyCode || p.Prices?.[0]?.CurrencyCode || "CAD";
    return {
      "#":           (currentPage - 1) * PRODUCTS_PER_PAGE + i + 1,
      "Name":        p.Name || "",
      "SKU":         p.Number || "",
      "Supplier":    p.Supplier?.Name || "",
      "Price":       priceVal !== "" ? `${currency} $${Number(priceVal).toFixed(2)}` : "",
      "Colors":      (p.Colors || []).join(", "),
      "Sizes":       (p.Sizes || []).join(", "),
      "Materials":   (p.Materials || []).join(", "),
      "Prod. Days":  (p.ProductionTimes || []).join(", "),
      "In Stock":    p.HasInventory ? "Yes" : "No",
    };
  });

const handleExportCSV = () => {
  if (!products.length) return;
  const rows = getExportRows();
  const headers = Object.keys(rows[0]);
  const csvRows = rows.map(r =>
    headers.map(h => `"${String(r[h] ?? "").replace(/"/g, '""')}"`).join(",")
  );
  const csv  = [headers.join(","), ...csvRows].join("\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url  = URL.createObjectURL(blob);
  const a    = document.createElement("a");
  a.href = url; a.download = `products-p${currentPage}.csv`; a.click();
  URL.revokeObjectURL(url);
  setExportMenuAnchor(null);
};

const handleExportExcel = () => {
  if (!products.length) return;
  import("xlsx").then(XLSX => {
    const rows = getExportRows();
    const ws   = XLSX.utils.json_to_sheet(rows);
    const wb   = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Products");
    XLSX.writeFile(wb, `products-p${currentPage}.xlsx`);
  });
  setExportMenuAnchor(null);
};

// const handleExportPDF = () => {
//   if (!products.length) return;
//   import("jspdf").then(({ default: jsPDF }) => {
//     import("jspdf-autotable").then(() => {
//       const doc  = new jsPDF({ orientation: "landscape" });
//       const rows = getExportRows();
//       const head = [Object.keys(rows[0])];
//       const body = rows.map(r => Object.values(r));
//       doc.autoTable({ head, body, styles: { fontSize: 7 }, headStyles: { fillColor: [30, 41, 59] } });
//       doc.save(`products-p${currentPage}.pdf`);
//     });
//   });
//   setExportMenuAnchor(null);
// };


const handleExportPDF = () => {
  if (!products.length) return;

  const doc = new jsPDF({ orientation: 'landscape' });
  doc.setFontSize(14);
  doc.text('Products Report', 14, 15);
  doc.setFontSize(9);
  doc.text(`Generated: ${new Date().toLocaleString()} — Page ${currentPage}`, 14, 22);

  const rows = getExportRows(); 
  const head = [Object.keys(rows[0])];
  const body = rows.map(r => Object.values(r));

  autoTable(doc, {
    head,
    body,
    startY: 28,
    styles: { fontSize: 7, cellPadding: 1.5, overflow: 'ellipsize' },
    headStyles: { fillColor: [30, 41, 59], textColor: [255, 255, 255], fontStyle: 'bold' },
    alternateRowStyles: { fillColor: [248, 250, 252] },
  });

  doc.save(`products-p${currentPage}.pdf`);
  setExportMenuAnchor(null);
};




const handleQuickSearch = async (query) => {
  setLoading(true);
  setError("");
  setAsiHasSearched(true);
  setSearchMode("keyword-live");
  setQueries(prev => ({ ...prev, "keyword-live": query }));
  try {
    const qForLive = buildAsiQuery(query, marketFilter, asiSupplierId);
    const endpoint = `${process.env.REACT_APP_NODEJS_SERVER_URL}/products/get-live-products`;
    const resp = await axios.get(endpoint, {
      params: { q: qForLive, page: 1, rpp: PRODUCTS_PER_PAGE, sort: "DFLT", instanceUniqueId }
    });
    setProducts(resp.data.Results ?? []);
    setAsiTotalPages(resp.data.TotalPages ?? 1);
    setAsiCurrentPage(1);
  } catch (err) {
    setError("Error fetching products: " + err.message);
  } finally {
    setLoading(false);
  }
};


  const content = (
  <div
    className={isEmbedded ? undefined : popupMode ? "rightSide place-items-top" : "instance-dashboard"}
    style={isEmbedded ? { width: "100%", maxWidth: "none", flex: "1 1 auto", boxSizing: "border-box" } : undefined}
  >

    {!popupMode && <InstanceLeftSidebar />}
    {!popupMode && <ToastContainer />}

    <div className={!popupMode ? "rightSide" : undefined}>
      <Box 
        className={`options-container fade-in-effect-usability ${
          usesStandalonePopup ? "popup-mode" : ""
        }`} // Temporary added this code for demo, feel free to delete later
        sx={{
          p: { xs: 1, md: 2 },
          display: "flex",
          flexDirection: "column",
          height: isEmbedded ? "70vh" : "calc(100vh - 60px)",
          minHeight: isEmbedded ? "70vh" : 0,
          overflow: "hidden",
          width: "100%",
        }}
      >
        <UITableShell
          customLayout
          paperSx={{
            flex: 1, borderRadius: "10px", border: "1px solid", borderColor: "divider",
            borderTop: "3px solid", borderTopColor: "primary.main",
            minHeight: 0, boxShadow: "0 1px 3px 0 rgba(0,0,0,0.07), 0 1px 2px -1px rgba(0,0,0,0.07)",
          }}
        >

          <UITableToolbar sx={{ backgroundColor: C.paperBg }}>


            <Stack direction="row" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={1.5}>


              <Stack direction="row" alignItems="center" spacing={1.5} flexWrap="wrap" useFlexGap>
                <Typography variant="h6" fontWeight={700} sx={{ color: C.textPri, lineHeight: 1 }}>
                  Products
                </Typography>

                {products.length > 0 && (
                  <Chip
                    label={`${products.length} result${products.length !== 1 ? "s" : ""}`}
                    size="small"
                    sx={{ backgroundColor: "var(--ec-status-neutral-bg)", color: "var(--ec-status-neutral-text)", border: "1px solid var(--ec-status-neutral-border)", fontWeight: 600, fontSize: "0.72rem", height: 22 }}
                  />
                )}

                <Divider orientation="vertical" flexItem sx={{ height: 20, alignSelf: "center" }} />


                <Stack direction="row" spacing={0.5}>
                  {sourceTabs.map(({ key, label }) => (
                    <Chip
                      key={key}
                      label={label}
                      size="small"
                      onClick={() => handleTabChange(key)}
                      sx={{
                        cursor: "pointer", fontWeight: 600, fontSize: "0.72rem", height: 26,
                        backgroundColor: activeTab === key ? "var(--ec-color-primary)" : "var(--ec-status-neutral-bg)",
                        color:           activeTab === key ? "var(--ec-color-surface)"  : "var(--ec-status-neutral-text)",
                        border:          activeTab === key ? "1px solid transparent"    : "1px solid var(--ec-status-neutral-border)",
                        transition: "all 0.15s ease",
                        "& .MuiChip-label": { px: "10px" },
                        "&:hover": { backgroundColor: activeTab === key ? "var(--ec-color-primary-dark)" : "var(--ec-color-surface-muted)" },
                      }}
                    />
                  ))}
                </Stack>




     <Divider orientation="vertical" flexItem sx={{ height: 20, alignSelf: "center" }} />



{/* {!asiHasSearched && activeTab === "ASI" && ( */}
{activeTab === "ASI" && (
  <Box sx={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 0.75, mt: 1 }}>
    <Typography variant="caption"
      sx={{ color: C.textMuted, fontWeight: 600, mr: 0.25, whiteSpace: "nowrap" }}>
      Quick search:
    </Typography>
    {QUICK_SEARCHES.map(({ label, query }) => (
      <Chip
        key={label}
        label={label}
        size="small"
        clickable

          onClick={() => handleQuickSearch(query)} 
        sx={{
          height: 26,
          fontSize: "0.72rem",
          fontWeight: 600,
          bgcolor: "transparent",
          border: "1px solid",
          borderColor: "divider",
          color: C.textSec,
          "& .MuiChip-label": { px: 1.25 },
          "&:hover": {
            bgcolor: "primary.main",
            borderColor: "primary.main",
            color: "#fff",
          },
          transition: "all 0.15s ease",
        }}
      />
    ))}
  </Box>
)}
              </Stack>


              <Stack direction="row" spacing={0.5} alignItems="center">


                <ToggleButtonGroup
                  value={viewMode} exclusive
                  onChange={(_, v) => { if (v) setViewMode(v); }}
                  size="small"
                  sx={{ "& .MuiToggleButton-root": { border: "1px solid", borderColor: "divider", px: 1, py: 0.5 } }}
                >
                  <ToggleButton value="card"  aria-label="Card view">
                    <Tooltip title="Card view"><ViewModuleIcon sx={{ fontSize: 17 }} /></Tooltip>
                  </ToggleButton>
                  <ToggleButton value="table" aria-label="Table view">
                    <Tooltip title="Table view"><ViewListIcon sx={{ fontSize: 17 }} /></Tooltip>
                  </ToggleButton>
                </ToggleButtonGroup>


                {viewMode === "table" && (
  <Tooltip title="Show / hide columns">
    <IconButton size="small" onClick={e => setColumnMenuAnchor(e.currentTarget)}
      sx={{ color: "text.secondary", }}>
      <ViewColumnIcon sx={{ fontSize: 18 }} />
    </IconButton>
  </Tooltip>
)}
{viewMode === "table" && (
  <Tooltip title="Row density">
    <IconButton size="small" onClick={e => setDensityMenuAnchor(e.currentTarget)}
      sx={{ color: "text.secondary",  }}>
      {/* <DensityMediumIcon sx={{ fontSize: 18 }} /> */}
       {/* <SettingsIcon sx={{ fontSize: 18 }} /> */}
        <FormatLineSpacingIcon sx={{ fontSize: 18 }} />
    </IconButton>
  </Tooltip>
)}

{/* Refresh */}
<Tooltip title="Refresh results">
  <span>
    <IconButton size="small" onClick={() => (asiHasSearched || customHasSearched || promoWorldHasSearched) && handleSearch(currentPage)}
      disabled={loading || (!asiHasSearched && !customHasSearched && !promoWorldHasSearched)}
      sx={{ color: "text.secondary",   }}>
      <RefreshIcon sx={{ fontSize: 18 }} />
    </IconButton>
  </span>
</Tooltip>


{/* Export CSV */}
<Tooltip title="Export">
  <span>
    <IconButton size="small"
      onClick={e => setExportMenuAnchor(e.currentTarget)}
      disabled={!products.length}
      sx={{ color: "text.secondary" }}>
      <FileDownloadIcon sx={{ fontSize: 18 }} />
    </IconButton>
  </span>
</Tooltip>

<Menu
  anchorEl={exportMenuAnchor}
  open={Boolean(exportMenuAnchor)}
  onClose={() => setExportMenuAnchor(null)}
  slotProps={{ paper: { sx: { minWidth: 170, borderRadius: 2 } } }}
>
  <Typography variant="overline"
    sx={{ px: 2, pt: 1.25, pb: 0.5, display: "block", color: "text.disabled" }}>
    Export as
  </Typography>
  <Divider sx={{ mb: 0.5 }} />

  <MenuItem onClick={handleExportCSV} sx={{ gap: 1.5, py: 0.75 }}>
    <Box component="span" sx={{ fontSize: 18, display: "flex", color: "#16a34a" }}>
      <FileDownloadIcon fontSize="small" />
    </Box>
    <ListItemText primaryTypographyProps={{ fontSize: "0.875rem", fontWeight: 600 }}>
      CSV (.csv)
    </ListItemText>
  </MenuItem>

  <MenuItem onClick={handleExportExcel} sx={{ gap: 1.5, py: 0.75 }}>
    <Box component="span" sx={{ fontSize: 18, display: "flex", color: "#2563eb" }}>
      <FileDownloadIcon fontSize="small" />
    </Box>
    <ListItemText primaryTypographyProps={{ fontSize: "0.875rem", fontWeight: 600 }}>
      Excel (.xlsx)
    </ListItemText>
  </MenuItem>

  <MenuItem onClick={handleExportPDF} sx={{ gap: 1.5, py: 0.75 }}>
    <Box component="span" sx={{ fontSize: 18, display: "flex", color: "#dc2626" }}>
      <FileDownloadIcon fontSize="small" />
    </Box>
    <ListItemText primaryTypographyProps={{ fontSize: "0.875rem", fontWeight: 600 }}>
      PDF (.pdf)
    </ListItemText>
  </MenuItem>
</Menu>


                <Divider orientation="vertical" flexItem sx={{ mx: 0.5, height: 24, alignSelf: "center" }} />

                {/* Close button popup only */}
                {popupMode && (
                  <Tooltip title="Close">
                    <IconButton size="small" onClick={closeProductListPopup} sx={{ color: "text.secondary" }}>
                      <CloseIcon sx={{ fontSize: 18 }} />
                    </IconButton>
                  </Tooltip>
                )}

                {/* Action buttons */}
                {/* {canCreateCustom && activeTab === "Elite Promo Marketing" && ( */}
                {canCreateCustom && (!normalizedAllowedSources || normalizedAllowedSources.has('custom')) && (
                  <>
                    <Button
                      variant="contained" color="primary" size="small" startIcon={<AddIcon />}
                      onClick={() => openCustomPopup()}
                      sx={{ fontWeight: 700, textTransform: "none", height: 34, px: 2, whiteSpace: "nowrap" }}
                    >
                      New Product
                    </Button>
                    {canImportCatalogue && (
                      <Button
                        variant="outlined" size="small"
                        onClick={() => setShowImportPopup(true)}
                        sx={{ fontWeight: 600, textTransform: "none", height: 34, px: 2, whiteSpace: "nowrap" }}
                      >
                        Import
                      </Button>
                    )}
                  </>
                )}
              </Stack>
            </Stack>

            <Divider sx={{ mt: 1.75, mb: 0 }} />


            <Stack direction="row" spacing={1.5} mt={1.75} flexWrap="wrap" useFlexGap alignItems="center">


              <TextField
                placeholder={activeTab === "ASI" ? "Search products…" : activeTab === "PromoWorld" ? "Search PromoWorld products…" : "Search custom products…"}
                size="small"
                value={queries[searchMode] || ""}
                onChange={e => setQueries(q => ({ ...q, [searchMode]: e.target.value }))}
                onKeyDown={e => { if (e.key === "Enter") handleSearch(1); }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon sx={{ fontSize: 16, color: C.textMuted }} />
                    </InputAdornment>
                  ),
                  endAdornment: (queries[searchMode] || "") ? (
                    <InputAdornment position="end">
                      <IconButton size="small" edge="end"
                        onClick={() => setQueries(q => ({ ...q, [searchMode]: "" }))}>
                        <ClearIcon sx={{ fontSize: 14 }} />
                      </IconButton>
                    </InputAdornment>
                  ) : null,
                }}
                sx={{ flex: 2, minWidth: 260, "& .MuiOutlinedInput-root": { backgroundColor: "var(--ec-input-bg)" } }}
              />


              {!popupMode && activeTab === "ASI" && (
                <FormControl size="small" sx={{ minWidth: 160 }}>
                  <Select
                    value={searchMode}
                    onChange={e => setSearchMode(e.target.value)}
                    sx={{ backgroundColor: "var(--ec-input-bg)" }}
                  >
                    <MenuItem value="keyword-live">Keyword Live</MenuItem>
                    <MenuItem value="keyword-test">Keyword Test</MenuItem>
                    <MenuItem value="asi-live">ASI # Live</MenuItem>
                    <MenuItem value="asi-test">ASI # Test</MenuItem>
                  </Select>
                </FormControl>
              )}


              {activeTab === "ASI" && (
                <Tooltip title={`Market: ${marketFilter} (click to cycle)`}>
                  <IconButton
                    size="small"
                    onClick={() => setMarketFilter(prev => nextMarket(prev))}
                    sx={{ border: "1px solid", borderColor: "divider", borderRadius: 1.5, width: 36, height: 36 }}
                  >
                    {marketFilter === "ALL" && <PublicIcon sx={{ fontSize: 18 }} />}
                    {marketFilter === "CAN" && <img src="https://flagcdn.com/24x18/ca.png" alt="Canada" style={{ width: 22, height: 16 }} />}
                    {marketFilter === "USA" && <img src="https://flagcdn.com/24x18/us.png" alt="USA"    style={{ width: 22, height: 16 }} />}
                  </IconButton>
                </Tooltip>
              )}

              {/* Supplier filter ASI only */}
              {activeTab === "ASI" && (
                <Stack direction="row" alignItems="center" spacing={0.5}>
                  <TextField
                    size="small"
                    placeholder="Supplier ASI #"
                    value={asiSupplierId}
                    onChange={e => setAsiSupplierId(e.target.value.replace(/\D/g, ""))}
                    disabled={searchMode !== "keyword-live"}
                    sx={{ width: 140, "& .MuiOutlinedInput-root": { backgroundColor: "var(--ec-input-bg)" } }}
                  />
                  <Tooltip title="Pick from connected suppliers">
                    <span>
                      <IconButton size="small" onClick={openSupplierPicker} disabled={searchMode !== "keyword-live"}>
                        <AddIcon sx={{ fontSize: 18 }} />
                      </IconButton>
                    </span>
                  </Tooltip>
                  {!!asiSupplierId && (
                    <Tooltip title="Clear supplier filter">
                      <IconButton size="small" onClick={() => setAsiSupplierId("")}>
                        <ClearIcon sx={{ fontSize: 14 }} />
                      </IconButton>
                    </Tooltip>
                  )}
                </Stack>
              )}

              {/* Search button */}
              <Button
                variant="contained" size="small"
                startIcon={<SearchIcon sx={{ fontSize: 15 }} />}
                onClick={() => handleSearch(1)}
                sx={{ height: 40, textTransform: "none", fontWeight: 600, px: 2.5, boxShadow: "none", "&:hover": { boxShadow: "none" } }}
              >
                Search
              </Button>
            </Stack>

            {/* Active supplier filter chip */}
            {!!asiSupplierId && (
              <Stack direction="row" spacing={0.75} mt={1.25} flexWrap="wrap" useFlexGap alignItems="center">
                <Typography variant="caption" sx={{ color: C.textMuted, fontWeight: 600 }}>Filters:</Typography>
                <Chip
                  label={`Supplier ASI: ${asiSupplierId}`}
                  size="small"
                  onDelete={() => setAsiSupplierId("")}
                  sx={{ backgroundColor: "var(--ec-status-info-bg)", color: "var(--ec-status-info-text)", border: "1px solid var(--ec-status-info-border)", fontWeight: 600, fontSize: "0.72rem" }}
                />
              </Stack>
            )}

            {error && (
              <Box sx={{ mt: 1.25 }}>
                <Chip label={error} size="small"
                  sx={{ backgroundColor: "var(--ec-status-error-bg)", color: "var(--ec-status-error-text)", border: "1px solid var(--ec-status-error-border)", fontWeight: 600, fontSize: "0.72rem" }} />
              </Box>
            )}
          </UITableToolbar>


          {viewMode === "card" && (
            <Box sx={{ flex: 1, overflow: "auto", p: 2, minHeight: 0,
                backgroundColor: "#f1f5f9",  
              "&::-webkit-scrollbar": { width: 6, height: 6 },
              "&::-webkit-scrollbar-thumb": { backgroundColor: "var(--ec-color-border-strong)", borderRadius: 99 },
              "&::-webkit-scrollbar-track": { backgroundColor: "transparent" },
            }}>

              {/* Loading skeletons */}
              {loading && (
                <Box sx={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))", gap: 2 }}>
                  {Array.from({ length: 8 }).map((_, i) => (
                    <Box key={i} sx={{ border: `1px solid ${C.border}`, borderRadius: "12px", overflow: "hidden", bgcolor: C.paperBg }}>
                      <Skeleton variant="rectangular" height={170} />
                      <Box sx={{ p: 1.5 }}>
                        <Skeleton width="85%" height={16} sx={{ mb: 0.75 }} />
                        <Skeleton width="55%" height={12} sx={{ mb: 0.5 }} />
                        <Skeleton width="40%" height={12} />
                      </Box>
                    </Box>
                  ))}
                </Box>
              )}

              {/* Not yet searched ASI empty state */}
              {!loading && !asiHasSearched && activeTab === "ASI" && (
                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100%", gap: 2, py: 8 }}>
                  <Box sx={{ width: 72, height: 72, borderRadius: "50%", backgroundColor: "var(--ec-color-surface-muted)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <StorefrontIcon sx={{ fontSize: 36, color: "var(--ec-color-text-muted)" }} />
                  </Box>
                  <Box sx={{ textAlign: "center" }}>
                    <Typography variant="h6" fontWeight={600} color="text.secondary" gutterBottom>Search the ASI Catalog</Typography>
                    <Typography variant="body2" color="text.disabled" sx={{ maxWidth: 340 }}>
                      Type a keyword like "hat" or "shirt" and click Search to browse thousands of products.
                    </Typography>
                  </Box>
                </Box>
              )}

              {/* Not yet searched Elite Promo empty state */}
              {!loading && !promoWorldHasSearched && activeTab === "PromoWorld" && (
                <Box sx={{ p: 4, textAlign: "center", color: C.textMuted }}>
                  <StorefrontIcon sx={{ fontSize: 42, mb: 1, opacity: 0.35 }} />
                  <Typography variant="h6" fontWeight={600} color="text.secondary" gutterBottom>PromoWorld Catalogue</Typography>
                  <Typography variant="body2">Search the global PromoWorld product catalogue.</Typography>
                </Box>
              )}

              {!loading && !customHasSearched && activeTab === "Elite Promo Marketing" && (
                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100%", gap: 2, py: 8 }}>
                  <Box sx={{ width: 72, height: 72, borderRadius: "50%", backgroundColor: "var(--ec-color-surface-muted)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <StorefrontIcon sx={{ fontSize: 36, color: "var(--ec-color-text-muted)" }} />
                  </Box>
                  <Box sx={{ textAlign: "center" }}>
                    <Typography variant="h6" fontWeight={600} color="text.secondary" gutterBottom>Elite Promo Marketing Products</Typography>
                    <Typography variant="body2" color="text.disabled" sx={{ maxWidth: 340 }}>
                      Search your custom product catalogue or create a new product.
                    </Typography>
                  </Box>
                  {canCreateCustom && (
                    <Button variant="contained" color="primary" size="small" startIcon={<AddIcon />}
                      onClick={() => openCustomPopup()}
                      sx={{ fontWeight: 700, textTransform: "none", height: 36, px: 2.5 }}>
                      New Custom Product
                    </Button>
                  )}
                </Box>
              )}

              {/* No results after search */}
              {!loading && (asiHasSearched || customHasSearched || promoWorldHasSearched) && products.length === 0 && (
                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100%", gap: 2, py: 8 }}>
                  <Box sx={{ width: 64, height: 64, borderRadius: "50%", backgroundColor: "var(--ec-color-surface-muted)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <FolderOffIcon sx={{ fontSize: 32, color: "var(--ec-color-text-muted)" }} />
                  </Box>
                  <Box sx={{ textAlign: "center" }}>
                    <Typography variant="h6" fontWeight={600} color="text.secondary" gutterBottom>No products found</Typography>
                    <Typography variant="body2" color="text.disabled" sx={{ maxWidth: 340 }}>
                      Try a different keyword, change your search mode, or adjust the market filter.
                    </Typography>
                  </Box>
                </Box>
              )}

              {/* Product Cards Grid */}
              {!loading && products.length > 0 && (
                <Box sx={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))", gap: 2 }}>
                  {products.map(product => {
                    const rawId       = product.Id || product.id;
                    const isSelected  = checkIsSelected(product);
                    const isLoadingThis = !!loadingProducts[rawId];
                    const imgUrl = resolveImageUrl(product);
                    const resolvedPrice = resolvePrice(product);
                    const priceVal = resolvedPrice?.value ?? null;
                    const currency = resolvedPrice?.currency || "CAD";
                    const supplierName = resolveSupplierName(product);
                    const inStock     = !!product.HasInventory;
                    const inventoryLabel = resolveInventoryLabel(product);

                    return (
                      <Box
                        key={rawId}
                        sx={{
                          position: "relative",
                          border: `1.5px solid ${isSelected ? "var(--ec-color-primary)" : C.border}`,
                          borderRadius: "12px",
                          overflow: "hidden",
                          bgcolor: C.paperBg,
                          cursor: "pointer",
                          display: "flex",
                          flexDirection: "column",
                          transition: "all 0.15s ease",
                          "& .custom-product-edit-action": {
                            opacity: 0,
                            pointerEvents: "none",
                            transform: "translateY(-2px)",
                            transition: "opacity 0.15s ease, transform 0.15s ease",
                          },
                          "&:hover": {
                            borderColor: "var(--ec-color-primary)",
                            boxShadow: "0 4px 20px 0 rgba(0,0,0,0.1)",
                            transform: "translateY(-2px)",
                          },
                          "&:hover .custom-product-edit-action": {
                            opacity: 1,
                            pointerEvents: "auto",
                            transform: "translateY(0)",
                          },
                        }}
                        onClick={() => openPopup(product, false, activeTab === "PromoWorld" ? "promoworld" : null)}
                      >
                        {!isPresentation && activeTab === "Elite Promo Marketing" && canCreateCustom && (
                          <IconButton
                            className="custom-product-edit-action"
                            size="small"
                            onClick={(e) => {
                              e.stopPropagation();
                              openCustomPopup(product);
                            }}
                            title="Edit custom product"
                            sx={{
                              position: "absolute",
                              top: 8,
                              right: 8,
                              zIndex: 3,
                              bgcolor: "#ff9800",
                              color: "#fff",
                              width: 28,
                              height: 28,
                              boxShadow: "0 2px 8px rgba(0,0,0,0.18)",
                              "&:hover": { bgcolor: "#fb8c00" },
                            }}
                          >
                            <BuildIcon sx={{ fontSize: 15 }} />
                          </IconButton>
                        )}
                        {/* Selected checkmark badge */}
                        {isSelected && (
                          <Box sx={{
                            position: "absolute", top: 8, right: 8, zIndex: 2,
                            bgcolor: "var(--ec-color-primary)", borderRadius: "50%",
                            width: 26, height: 26, display: "flex", alignItems: "center", justifyContent: "center",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                          }}>
                            <CheckCircleIcon sx={{ fontSize: 17, color: "#fff" }} />
                          </Box>
                        )}

                        {activeTab === "PromoWorld" && (
                          <Chip
                            label={inventoryLabel === "Stock unknown" ? "PromoWorld" : inventoryLabel}
                            size="small"
                            sx={{
                              position: "absolute", top: 8, left: 8, zIndex: 2, height: 20,
                              fontSize: "0.62rem", fontWeight: 800, bgcolor: "#e0f2fe", color: "#0369a1",
                              border: "1px solid #7dd3fc", "& .MuiChip-label": { px: "7px" }
                            }}
                          />
                        )}

                        {/* Stock badge */}
                        {activeTab !== "PromoWorld" && <Box sx={{ position: "absolute", top: 8, left: 8, zIndex: 2 }}>
                          {/*<Chip
                            label={inStock ? "In Stock" : "Out of Stock"}
                            size="small"
                            // sx={{
                            //   height: 20, fontSize: "0.62rem", fontWeight: 700,
                            //   backgroundColor: inStock ? "var(--ec-status-success-bg)" : "var(--ec-status-error-bg)",
                            //   color:           inStock ? "var(--ec-status-success-text)" : "var(--ec-status-error-text)",
                            //   border: `1px solid ${inStock ? "var(--ec-status-success-border)" : "var(--ec-status-error-border)"}`,
                            // }}

                            sx={{
  height: 20, fontSize: "0.62rem", fontWeight: 700,
  backgroundColor: inStock ? "#dcfce7" : "#fee2e2",
  color:           inStock ? "#15803d" : "#dc2626",
  border: `1px solid ${inStock ? "#86efac" : "#fca5a5"}`,
  "& .MuiChip-label": { px: "7px" },
}}
                          />*/}
                        </Box>}

                        {/* Product image */}
                        <Box sx={{ height: 170, bgcolor: "#f8fafc", display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden", flexShrink: 0 }}>
                          {imgUrl ? (
                            <Box
                              component="img"
                              key={imgUrl} src={imgUrl}
                              alt={product.Name}
                              sx={{ width: "100%", height: "100%", objectFit: "contain", p: 1 }}
                              onError={event => handleProductImageError(event, product)}
                            />
                          ) : null}
                          <Box sx={{ display: imgUrl ? "none" : "flex", alignItems: "center", justifyContent: "center", width: "100%", height: "100%" }}>
                            <ImageNotSupportedIcon sx={{ fontSize: 40, color: C.textMuted, opacity: 0.3 }} />
                          </Box>
                        </Box>

                        {/* Card body */}
                        <Box sx={{ p: 1.5, flex: 1, display: "flex", flexDirection: "column", gap: 0.5 }}>
                          <Typography
                            variant="body2" fontWeight={700}
                            sx={{ color: C.textPri, lineHeight: 1.35,
                              overflow: "hidden", textOverflow: "ellipsis",
                              display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical" }}
                          >
                            {product.Name}
                          </Typography>

                          {supplierName && (
                            <Typography variant="caption" sx={{ color: C.textMuted, fontSize: "0.7rem" }}>
                              {supplierName}
                            </Typography>
                          )}

                          {priceVal != null && (
                            <Typography variant="body2" fontWeight={800} sx={{ color: "var(--ec-color-primary)", mt: 0.25 }}>
                              {currency} ${Number(priceVal).toFixed(2)}
                            </Typography>
                          )}




  {/* Production time */}
  {Array.isArray(product.ProductionTimes) && product.ProductionTimes.length > 0 && (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.4, mt: 0.25 }}>
      <AccessTimeIcon sx={{ fontSize: 11, color: C.textMuted }} />
      <Typography variant="caption" sx={{ color: C.textMuted, fontSize: "0.68rem" }}>
        {product.ProductionTimes.length === 1
          ? `${product.ProductionTimes[0]} days`
          : `${Math.min(...product.ProductionTimes)}–${Math.max(...product.ProductionTimes)} days`}
      </Typography>
    </Box>
  )}

  {/* Virtual Sample */}
  {(product.IsNew || product.HasVirtualSample) && (
    <Box sx={{ display: "flex", gap: 0.4, flexWrap: "wrap", mt: 0.25 }}>
      {product.IsNew && (
        <Chip label="New" size="small"
          sx={{ height: 17, fontSize: "0.6rem", fontWeight: 700,
            backgroundColor: "#dbeafe", color: "#1d4ed8", border: "1px solid #93c5fd",
            "& .MuiChip-label": { px: "6px" } }}
        />
      )}
      {product.HasVirtualSample && (
        <Chip label="VS Ready" size="small"
          sx={{ height: 17, fontSize: "0.6rem", fontWeight: 700,
            backgroundColor: "#f3e8ff", color: "#7c3aed", border: "1px solid #c4b5fd",
            "& .MuiChip-label": { px: "6px" } }}
        />
      )}
    </Box>
  )}





                          {Array.isArray(product.Colors) && product.Colors.length > 0 && (
                            <Box sx={{ display: "flex", gap: 0.4, flexWrap: "wrap", mt: 0.25 }}>
                              {product.Colors.slice(0, 5).map((c, i) => (
                                <Chip key={i} label={c} size="small"
                                  sx={{ height: 17, fontSize: "0.6rem", fontWeight: 600,
                                    bgcolor: "var(--ec-status-neutral-bg)", color: "var(--ec-status-neutral-text)",
                                    border: "1px solid var(--ec-status-neutral-border)",
                                    "& .MuiChip-label": { px: "6px" } }}
                                />
                              ))}
                              {product.Colors.length > 5 && (
                                <Typography variant="caption" sx={{ color: C.textMuted, alignSelf: "center", fontSize: "0.62rem" }}>
                                  +{product.Colors.length - 5}
                                </Typography>
                              )}
                            </Box>
                          )}
                        </Box>


                        {isPresentation && updateItemsToOrder && (
                          <Box sx={{ px: 1.5, pb: 1.5 }} onClick={e => e.stopPropagation()}>
                            {isSelected ? (
                              <Button fullWidth size="small" variant="outlined" color="error"
                                onClick={() => removeFromSelected(product)}
                                disabled={isLoadingThis}
                                sx={{ height: 30, textTransform: "none", fontWeight: 600, fontSize: "0.75rem", borderRadius: "8px" }}>
                                {isLoadingThis ? <CircularProgress size={14} /> : "Remove"}
                              </Button>
                            ) : (
                              <Button fullWidth size="small" variant="contained"
                                onClick={() => (activeTab === "ASI" || activeTab === "PromoWorld") ? handleCardClick(product) : handleAddCustomProduct(product)}
                                disabled={isLoadingThis}
                                sx={{ height: 30, textTransform: "none", fontWeight: 700, fontSize: "0.75rem", borderRadius: "8px", boxShadow: "none", "&:hover": { boxShadow: "none" } }}>
                                {isLoadingThis ? <CircularProgress size={14} color="inherit" /> : "+ Add to Order"}
                              </Button>
                            )}
                          </Box>
                        )}
                      </Box>
                    );
                  })}
                </Box>
              )}
            </Box>
          )}


          {viewMode === "table" && (
            <TableContainer
              sx={{
                flex: 1, overflow: "auto", minHeight: 0, borderRadius: "0 !important",
                "&::-webkit-scrollbar": { width: 6, height: 6 },
                "&::-webkit-scrollbar-thumb": { backgroundColor: "var(--ec-color-border-strong)", borderRadius: 99 },
                "&::-webkit-scrollbar-track": { backgroundColor: "transparent" },
              }}
            >
              <Table stickyHeader size="small" sx={{ minWidth: 800, width: "100%" }}>
                <TableHead>
                  <TableRow>
                    {PRODUCT_COLUMNS.filter(c => visibleColumns.has(c.id)).map(col => (
                      <TableCell
                        key={col.id}
                        align={col.align}
                        sx={{
                          minWidth: col.minWidth, px: 2, py: 1.25,
                          // backgroundColor: "#f8fafc !important",
                          // color: "var(--ec-table-head-text-muted)",
                          backgroundColor: `${C.headerBg} !important`,
color: `${C.headerText} !important`,
                          fontWeight: 700, fontSize: "0.72rem",
                          letterSpacing: "0.06em", textTransform: "uppercase",
                          borderBottom: "none", whiteSpace: "nowrap",
                          position: "sticky", top: 0, zIndex: 2,
                        }}
                      >
                        {col.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>

                <TableBody
                  sx={{
                    "& .MuiTableCell-root": { borderBottom: `1px solid ${C.border}` },
                    "& .MuiTableRow-root:last-child .MuiTableCell-root": { borderBottom: "none" },
                  }}
                >
                  {/* Loading skeletons */}
                  {loading && [...Array(8)].map((_, i) => (
                    <TableRow key={i}>
                      {PRODUCT_COLUMNS.filter(c => visibleColumns.has(c.id)).map(col => (
                        <TableCell key={col.id} sx={{ px: 2, py: currentDensity.py }}>
                          <Skeleton variant="rectangular" height={20} sx={{ borderRadius: 1, opacity: 1 - i * 0.09 }} />
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}

                  {/* Empty not searched state */}
                  {!loading && products.length === 0 && (
                    <TableRow>
                      <TableCell
                        colSpan={PRODUCT_COLUMNS.filter(c => visibleColumns.has(c.id)).length}
                        align="center"
                        sx={{ py: 8, borderBottom: "none", background: "transparent" }}
                      >
                        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2 }}>
                          <Box sx={{ width: 64, height: 64, borderRadius: "50%", backgroundColor: "var(--ec-color-surface-muted)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                            {(asiHasSearched || customHasSearched || promoWorldHasSearched)
                              ? <FolderOffIcon sx={{ fontSize: 32, color: "var(--ec-color-text-muted)" }} />
                              : <StorefrontIcon sx={{ fontSize: 32, color: "var(--ec-color-text-muted)" }} />
                            }
                          </Box>
                          <Box sx={{ textAlign: "center" }}>
                            <Typography variant="h6" fontWeight={600} color="text.secondary" gutterBottom>
                              {(asiHasSearched || customHasSearched || promoWorldHasSearched) ? "No products found" : "Search to get started"}
                            </Typography>
                            <Typography variant="body2" color="text.disabled" sx={{ maxWidth: 340 }}>
                              {(asiHasSearched || customHasSearched || promoWorldHasSearched)
                                ? "Try a different keyword or adjust your filters."
                                : 'Type a keyword like "hat" or "shirt" and click Search.'}
                            </Typography>
                          </Box>
                        </Box>
                      </TableCell>
                    </TableRow>
                  )}

                  {/* Product rows */}
                  {!loading && products.map((product, index) => {
                    const rawId        = product.Id || product.id;
                    const isSelected   = checkIsSelected(product);
                    const isLoadingThis = !!loadingProducts[rawId];
                    const imgUrl = resolveImageUrl(product);
                    const resolvedPrice = resolvePrice(product);
                    const priceVal = resolvedPrice?.value ?? null;
                    const currency = resolvedPrice?.currency || "CAD";
                    const supplierName = resolveSupplierName(product);
                    const inStock      = !!product.HasInventory;

                    return (
                      <TableRow
                        key={rawId}
                        hover
                        onClick={() => openPopup(product, false, activeTab === "PromoWorld" ? "promoworld" : null)}
                        sx={{
                          cursor: "pointer",
                          backgroundColor: isSelected ? "rgba(var(--ec-color-primary-rgb), 0.04)" : C.paperBg,
                          transition: "background-color 0.1s",
                          "&:hover": { backgroundColor: C.subtleBg },
                        }}
                      >
                        {PRODUCT_COLUMNS.filter(c => visibleColumns.has(c.id)).map(col => {
                          const cellContent = (() => {
                            // if (col.id === "s_no") return (currentPage - 1) * 25 + index + 1;

if (col.id === "s_no") return (currentPage - 1) * PRODUCTS_PER_PAGE + index + 1;


                            if (col.id === "image") return (
                              <Box sx={{ width: 52, height: 52, borderRadius: "8px", overflow: "hidden", bgcolor: "#f8fafc", display: "flex", alignItems: "center", justifyContent: "center", border: `1px solid ${C.border}` }}>
                                {imgUrl ? (
                                  <Box
                                    component="img"
                                    key={imgUrl} src={imgUrl}
                                    alt=""
                                    sx={{ width: "100%", height: "100%", objectFit: "contain", p: 0.25 }}
                                    onError={event => handleProductImageError(event, product)}
                                  />
                                ) : null}
                                <ImageNotSupportedIcon sx={{ display: imgUrl ? "none" : "block", fontSize: 20, color: C.textMuted, opacity: 0.3 }} />
                              </Box>
                            );

                            if (col.id === "name") return (
                              <Box>
                                <Typography variant="body2" fontWeight={600}
                                  sx={{ color: C.textPri, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: 240 }}>
                                  {product.Name}
                                </Typography>
                                {activeTab === "PromoWorld" && (
                                  <Chip label={resolveInventoryLabel(product) === "Stock unknown" ? "PromoWorld" : resolveInventoryLabel(product)} size="small" sx={{ mt: 0.35, height: 18, fontSize: "0.6rem", fontWeight: 800, bgcolor: "#e0f2fe", color: "#0369a1", border: "1px solid #7dd3fc", "& .MuiChip-label": { px: "6px" } }} />
                                )}
                                {product.ShortDescription && (
                                  <Typography variant="caption"
                                    sx={{ color: C.textMuted, display: "block", fontSize: "0.68rem", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: 240 }}>
                                    {product.ShortDescription}
                                  </Typography>
                                )}
                              </Box>
                            );

                            if (col.id === "supplier") return (
                              <Typography variant="body2" sx={{ color: C.textSec }}>{supplierName || "—"}</Typography>
                            );

                            if (col.id === "price") return priceVal != null
                              ? <Typography variant="body2" fontWeight={700} sx={{ color: "var(--ec-color-primary)" }}>{currency} ${Number(priceVal).toFixed(2)}</Typography>
                              : <Typography variant="caption" color="text.disabled">—</Typography>;

                            if (col.id === "colors") return Array.isArray(product.Colors) && product.Colors.length > 0
                              ? (
                                <Box sx={{ display: "flex", gap: 0.4, flexWrap: "wrap" }}>
                                  {product.Colors.slice(0, 3).map((c, i) => (
                                    <Chip key={i} label={c} size="small"
                                      sx={{ height: 18, fontSize: "0.63rem", fontWeight: 600, bgcolor: "var(--ec-status-neutral-bg)", color: "var(--ec-status-neutral-text)", border: "1px solid var(--ec-status-neutral-border)", "& .MuiChip-label": { px: "6px" } }} />
                                  ))}
                                  {product.Colors.length > 3 && <Typography variant="caption" color="text.disabled" sx={{ alignSelf: "center" }}>+{product.Colors.length - 3}</Typography>}
                                </Box>
                              )
                              : <Typography variant="caption" color="text.disabled">—</Typography>;

                            if (col.id === "sizes") return Array.isArray(product.Sizes) && product.Sizes.length > 0
                              ? (
                                <Box sx={{ display: "flex", gap: 0.4, flexWrap: "wrap" }}>
                                  {product.Sizes.slice(0, 3).map((s, i) => (
                                    <Chip key={i} label={s} size="small"
                                      sx={{ height: 18, fontSize: "0.63rem", fontWeight: 600, bgcolor: "var(--ec-status-neutral-bg)", color: "var(--ec-status-neutral-text)", border: "1px solid var(--ec-status-neutral-border)", "& .MuiChip-label": { px: "6px" } }} />
                                  ))}
                                  {product.Sizes.length > 3 && <Typography variant="caption" color="text.disabled" sx={{ alignSelf: "center" }}>+{product.Sizes.length - 3}</Typography>}
                                </Box>
                              )
                              : <Typography variant="caption" color="text.disabled">—</Typography>;

                            if (col.id === "stock") return (
                              <Chip
                                label={inStock ? "In Stock" : "Out"}
                                size="small"
                                sx={{
                                  height: 20, fontSize: "0.65rem", fontWeight: 700,
                                  backgroundColor: inStock ? "var(--ec-status-success-bg)" : "var(--ec-status-error-bg)",
                                  color:           inStock ? "var(--ec-status-success-text)" : "var(--ec-status-error-text)",
                                  border: `1px solid ${inStock ? "var(--ec-status-success-border)" : "var(--ec-status-error-border)"}`,
                                }}
                              />
                            );

                            if (col.id === "sku") return (
  <Typography variant="caption"
    sx={{ fontFamily: "monospace", color: C.textSec, fontSize: "0.75rem" }}>
    {product.Number || "—"}
  </Typography>
);

if (col.id === "material") return (
  <Typography variant="caption" sx={{ color: C.textSec }}>
    {Array.isArray(product.Materials) && product.Materials.length
      ? product.Materials.join(", ")
      : "—"}
  </Typography>
);

if (col.id === "prod_time") {
  const times = product.ProductionTimes || [];
  const label = times.length === 1
    ? `${times[0]} days`
    : times.length > 1
    ? `${Math.min(...times)}–${Math.max(...times)} days`
    : "—";
  return <Typography variant="caption" sx={{ color: C.textSec }}>{label}</Typography>;
}

                            if (col.id === "actions") return (
                              <Box onClick={e => e.stopPropagation()}>
                                {isPresentation && updateItemsToOrder ? (
                                  isSelected ? (
                                    <Button size="small" variant="outlined" color="error"
                                      onClick={() => removeFromSelected(product)} disabled={isLoadingThis}
                                      sx={{ fontSize: "0.72rem", height: 28, borderRadius: "8px", textTransform: "none", fontWeight: 600, minWidth: 72 }}>
                                      {isLoadingThis ? <CircularProgress size={12} /> : "Remove"}
                                    </Button>
                                  ) : (
                                    <Button size="small" variant="contained"
                                      onClick={() => (activeTab === "ASI" || activeTab === "PromoWorld") ? handleCardClick(product) : handleAddCustomProduct(product)}
                                      disabled={isLoadingThis}
                                      sx={{ fontSize: "0.72rem", height: 28, borderRadius: "8px", textTransform: "none", fontWeight: 700, minWidth: 72, boxShadow: "none" }}>
                                      {isLoadingThis ? <CircularProgress size={12} color="inherit" /> : "+ Add"}
                                    </Button>
                                  )
                                ) : (
                                  <Button size="small" variant="outlined"
                                    onClick={() => openPopup(product, false, activeTab === "PromoWorld" ? "promoworld" : null)}
                                    sx={{ fontSize: "0.72rem", height: 28, borderRadius: "8px", textTransform: "none", fontWeight: 600, minWidth: 60 }}>
                                    View
                                  </Button>
                                )}
                              </Box>
                            );

                            return "—";
                          })();

                          return (
                            <TableCell
                              key={col.id}
                              align={col.align}
                              sx={{ px: 2, py: currentDensity.py, fontSize: currentDensity.fontSize, color: C.textPri, verticalAlign: "middle" }}
                            >
                              {cellContent}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          )}


          {(asiHasSearched || customHasSearched || promoWorldHasSearched) && (
            <Box
              sx={{
                px: 2, py: 0, backgroundColor: C.paperBg,
                borderTop: `1px solid ${C.border}`, flexShrink: 0,
                display: "flex", alignItems: "center", justifyContent: "space-between", minHeight: 52,
              }}
            >
              <Typography variant="body2" sx={{ color: "var(--ec-color-text-muted)", fontSize: "0.8125rem", pl: 1 }}>
                {products.length > 0
                  ? `Page ${currentPage} of ${totalPages} · ${products.length} product${products.length !== 1 ? "s" : ""}`
                  : "No results"}
              </Typography>

              <Stack direction="row" spacing={1} alignItems="center">
                <Button size="small" variant="outlined"
                  onClick={handlePreviousPage}
                  disabled={currentPage === 1 || loading}
                  sx={{ textTransform: "none", fontWeight: 600, height: 32, minWidth: 80, borderRadius: "8px" }}>
                  ← Previous
                </Button>
                <Typography variant="body2" sx={{ color: C.textMuted, px: 0.5, fontWeight: 500, minWidth: 60, textAlign: "center" }}>
                  {currentPage} / {totalPages}
                </Typography>
                <Button size="small" variant="outlined"
                  onClick={handleNextPage}
                  disabled={currentPage === totalPages || loading}
                  sx={{ textTransform: "none", fontWeight: 600, height: 32, minWidth: 80, borderRadius: "8px" }}>
                  Next →
                </Button>
              </Stack>
            </Box>
          )}

        </UITableShell>

      </Box>
    </div>




    <Menu
      anchorEl={columnMenuAnchor}
      open={Boolean(columnMenuAnchor)}
      onClose={() => setColumnMenuAnchor(null)}
      slotProps={{ paper: { sx: { minWidth: 210, borderRadius: 2 } } }}
    >
      <Typography variant="overline" sx={{ px: 2, pt: 1.25, pb: 0.5, display: "block", color: "text.disabled" }}>Columns</Typography>
      <Divider sx={{ mb: 0.5 }} />
      {PRODUCT_COLUMNS.filter(c => !c.locked).map(col => (
        <MenuItem key={col.id} onClick={() => toggleColVisibility(col.id)} sx={{ py: 0.4 }}>
          <Checkbox size="small" checked={visibleColumns.has(col.id)} sx={{ p: 0.5, mr: 0.5, color: "primary.main", "&.Mui-checked": { color: "primary.main" } }} />
          <ListItemText primaryTypographyProps={{ fontSize: "0.875rem" }}>{col.label}</ListItemText>
        </MenuItem>
      ))}
    </Menu>


    <Menu
      anchorEl={densityMenuAnchor}
      open={Boolean(densityMenuAnchor)}
      onClose={() => setDensityMenuAnchor(null)}
      slotProps={{ paper: { sx: { minWidth: 180, borderRadius: 2 } } }}
    >
      <Typography variant="overline" sx={{ px: 2, pt: 1.25, pb: 0.5, display: "block", color: "text.disabled" }}>Row density</Typography>
      {["compact", "comfortable", "spacious"].map(d => (
        <MenuItem key={d} onClick={() => { setDensity(d); setDensityMenuAnchor(null); }} sx={{ py: 0.75, textTransform: "capitalize" }}>
          <Checkbox size="small" checked={density === d} sx={{ p: 0.5, mr: 0.5, color: "primary.main", "&.Mui-checked": { color: "primary.main" } }} />
          <ListItemText primaryTypographyProps={{ fontSize: "0.875rem", textTransform: "capitalize" }}>{d}</ListItemText>
        </MenuItem>
      ))}
    </Menu>



    {/* Supplier picker */}
    <Dialog open={supplierPickerOpen} onClose={() => setSupplierPickerOpen(false)} maxWidth="sm" fullWidth>
      <DialogTitle className="create-order-dialog-title">Select a supplier</DialogTitle>
      <DialogContent dividers sx={{ p: 0 }}>
        {loadingSupplierOptions
          ? <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}><CircularProgress size={28} /></Box>
          : supplierOptions.length === 0
          ? <Box sx={{ py: 4, textAlign: "center" }}><Typography color="text.disabled">No connected suppliers found.</Typography></Box>
          : (
            <List disablePadding>
              {supplierOptions.map((s) => {
                const asi = getAsiFromSupplier(s);

                return (
                  <ListItemButton
                    key={s.id}
                    onClick={() => asi && handlePickSupplier(s)}
                    divider
                    disabled={!asi}
                  >
                    <ListItemText
                      primary={s.businessName || s.name || "Unnamed"}
                      secondary={asi ? `ASI: ${asi}` : "Missing ASI number"}
                      primaryTypographyProps={{ fontWeight: 600, fontSize: "0.875rem" }}
                      secondaryTypographyProps={{
                        fontSize: "0.75rem",
                        color: asi ? "text.secondary" : "error",
                      }}
                    />
                  </ListItemButton>
                );
              })}
            </List>
          )
        }
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setSupplierPickerOpen(false)} sx={{ textTransform: "none", fontWeight: 600 }}>Close</Button>
      </DialogActions>
    </Dialog>

          {/*HELLO5555
          Popup look up type: {popupLookupType}*/}

          {/* {isPopupOpen && (
            <ProductPopup
              isOpen={isPopupOpen}
              onRequestClose={closePopup}
              // if you’re doing an ID‐only lookup:
              productId={popupProductId}
              // if you already have the full object you could pass it too:
              product={popupProduct}
              instanceUniqueId={instanceUniqueId}
              lookupType={popupLookupType}
            />
          )} */}

           {/* Product detail popup */}
    {isPopupOpen && (
      <ProductPopup
        isOpen={isPopupOpen}
        onRequestClose={closePopup}
        productId={popupProductId}
        product={popupProduct}
        instanceUniqueId={instanceUniqueId}
        lookupType={popupLookupType}
        updateItemsToOrder={updateItemsToOrder}
        order={order}
        defaultMargin={defaultMargin}
        defaultTaxId={defaultTaxId}
      />
    )}
          {showCustomPopup && (
            <PopupCustomProduct
              open={showCustomPopup}
              onClose={() => setShowCustomPopup(false)}
              handleCreateProduct={handleCreateProduct}
              handleUpdateProduct={handleUpdateProduct}
              instanceUniqueId={instanceUniqueId}
              mode={editingProduct ? "edit" : "create"}
              initialProduct={editingProduct || null}
            />
          )}
          {showImportPopup && (
            <PopupImportCustomCatalog
              open={showImportPopup}
              onClose={() => setShowImportPopup(false)}
              instanceUniqueId={instanceUniqueId}
              onImported={() => handleSearch(1)} // refresh custom list after import
            />
          )}
        {/* </>
      )}
    </div>
  </div>)); */}


    </div>
  );

  if (!popupMode || isEmbedded) {
    return content;
  }

  if (typeof document === "undefined") {
    return null;
  }

  return createPortal(
    <div className="instance-products-popup-root">{content}</div>,
    document.body
  );

}


// Both the searchable picker and the manual exact-name picker use this single
// ASI capture path. Never save an ASI Core ID without verifying its instance link.
async function captureProductAsiSupplier(instanceUniqueId, asiSupplierId) {
  const { data } = await axios.post(
    `${process.env.REACT_APP_NODEJS_SERVER_URL}/suppliers/custom-product/capture-asi`,
    { instanceUniqueId, asiSupplierId },
    { headers: { accessToken: localStorage.getItem("accessToken") } }
  );
  return data.supplier;
}

// Core-first, on-demand supplier search. Searching never writes CoreSupplier;
// only an explicit ASI selection invokes the capture service.
function CustomProductSupplierSearch({ instanceUniqueId, showError, helperText }) {
  const { values, setFieldValue } = useFormikContext();
  const [query, setQuery] = useState("");
  const [core, setCore] = useState([]);
  const [asi, setAsi] = useState([]);
  const [coreMore, setCoreMore] = useState(false);
  const [asiMore, setAsiMore] = useState(false);
  const [corePage, setCorePage] = useState(1);
  const [asiPage, setAsiPage] = useState(1);
  const [coreLoading, setCoreLoading] = useState(false);
  const [coreLookup, setCoreLookup] = useState({ query: "", status: "idle", hasMatches: false });
  const [manualAsiQuery, setManualAsiQuery] = useState(null);
  const [asiLoading, setAsiLoading] = useState(false);
  const [captureLoading, setCaptureLoading] = useState(false);
  const [problem, setProblem] = useState("");
  const [expanded, setExpanded] = useState(false);
  const [committedQuery, setCommittedQuery] = useState("");
  const [searchReady, setSearchReady] = useState(true);
  const token = useRef(0);
  const auth = { headers: { accessToken: localStorage.getItem("accessToken") } };
  const asiMode = supplierAsiSearchMode({
    query: committedQuery, coreLookup, manualAsiQuery, searchReady,
  });

  useEffect(() => {
    const timer = setTimeout(() => { setCommittedQuery(query.trim()); setCorePage(1); setAsiPage(1); setSearchReady(true); }, 275);
    return () => clearTimeout(timer);
  }, [query]);

  useEffect(() => {
    let valid = true;
    if (!expanded || !searchReady) return () => { valid = false; };
    if (corePage === 1) {
      setCoreLookup({ query: committedQuery, status: "loading", hasMatches: false });
    }
    setCoreLoading(true);
    axios.get(`${process.env.REACT_APP_NODEJS_SERVER_URL}/suppliers/custom-product/search`, {
      params: { instanceUniqueId, q: committedQuery, page: corePage }, ...auth,
    }).then(({ data }) => {
      if (!valid) return;
      const rows = Array.isArray(data?.rows) ? data.rows : [];
      setCore(previous => corePage === 1 ? rows
        : [...previous, ...rows].filter((s, i, arr) => arr.findIndex(p => String(p.Id) === String(s.Id)) === i));
      setCoreMore(Boolean(data.hasMore));
      if (corePage === 1) {
        setCoreLookup({ query: committedQuery, status: "success", hasMatches: rows.length > 0 });
      }
    }).catch(() => {
      if (!valid) return;
      if (corePage === 1) {
        setCoreLookup({ query: committedQuery, status: "error", hasMatches: false });
      }
      setProblem("Unable to search Core suppliers.");
    })
      .finally(() => { if (valid) setCoreLoading(false); });
    return () => { valid = false; };
  }, [instanceUniqueId, committedQuery, corePage, expanded, searchReady]);

  useEffect(() => {
    let valid = true;
    // Only call external ASI after a successful empty Core search, or an
    // explicit user request when Core already provided matches.
    if (!expanded || asiMode !== "search") return () => { valid = false; };
    setAsiLoading(true);
    axios.get(`${process.env.REACT_APP_NODEJS_SERVER_URL}/suppliers/custom-product/search-asi`, {
      params: { instanceUniqueId, q: committedQuery, page: asiPage }, ...auth,
    }).then(({ data }) => {
      if (!valid) return;
      setAsi(previous => asiPage === 1 ? (data.rows || [])
        : [...previous, ...(data.rows || [])].filter((s, i, arr) => arr.findIndex(p => String(p.Id) === String(s.Id)) === i));
      setAsiMore(Boolean(data.hasMore));
      if (data.partial) setProblem("Some ASI results are unavailable. Retry your search.");
    }).catch(() => { if (valid) setProblem("ASI search is unavailable. Core suppliers can still be selected."); })
      .finally(() => { if (valid) setAsiLoading(false); });
    return () => { valid = false; };
  }, [instanceUniqueId, committedQuery, asiPage, expanded, asiMode]);

  const choose = async row => {
    if (captureLoading) return;
    if (row.source === "core" && row.supplierType !== "asi") {
      ++token.current;
      setFieldValue("supplier", row.Name);
      setFieldValue("supplierObj", { Id: row.Id, Name: row.Name });
      setFieldValue("supplierDetails", {});
      setFieldValue("supplierAutoApprove", false);
      setExpanded(false); setProblem("");
      return;
    }
    const currentToken = ++token.current;
    setCaptureLoading(true); setProblem("");
    try {
      const chosen = await captureProductAsiSupplier(instanceUniqueId, row.Id);
      if (currentToken !== token.current) return;
      setFieldValue("supplier", chosen.Name);
      setFieldValue("supplierObj", { Id: chosen.Id, Name: chosen.Name });
      setFieldValue("supplierDetails", {});
      setFieldValue("supplierAutoApprove", false);
      setExpanded(false);
    } catch (error) {
      if (currentToken === token.current) setProblem(
        error?.response?.data?.error || "Unable to capture this ASI supplier. No supplier was selected.");
    } finally { if (currentToken === token.current) setCaptureLoading(false); }
  };
  const representedIds = new Set(core.filter(s => s.supplierType === "asi").map(s => String(s.Id)));
  const visibleAsi = asi.filter(s => !representedIds.has(String(s.Id)));
  return (
    <Box sx={{ mt: 2 }}>
      <TextField
        label="Supplier" fullWidth
        value={expanded ? query : (values.supplier || "")}
        onFocus={() => {
          setExpanded(true); setQuery(""); setCommittedQuery("");
          setCore([]); setAsi([]); setCoreMore(false); setAsiMore(false);
          setCoreLookup({ query: "", status: "idle", hasMatches: false });
          setManualAsiQuery(null);
          setCorePage(1); setAsiPage(1); setSearchReady(true); setProblem("");
        }}
        onChange={event => {
          setExpanded(true); setQuery(event.target.value); setSearchReady(false);
          setCore([]); setAsi([]); setCoreMore(false); setAsiMore(false);
          setCoreLookup({ query: "", status: "idle", hasMatches: false });
          setManualAsiQuery(null); setAsiLoading(false);
          setCorePage(1); setAsiPage(1); setProblem("");
        }}
        placeholder="Search existing Core suppliers"
        error={showError}
        helperText={helperText || "Core suppliers first; ASI is searched automatically when Core has no matches."}
        disabled={captureLoading}
      />
      {captureLoading && <Typography variant="caption">Verifying and capturing ASI supplier…</Typography>}
      {problem && <Typography color="error" variant="caption">{problem}</Typography>}
      {expanded && (
        <Paper variant="outlined" sx={{ mt: 1, p: 1, maxHeight: 340, overflowY: "auto" }}>
          <Typography variant="overline" color="text.secondary">Core Suppliers</Typography>
          {core.map(s => (
            <MenuItem key={`core-${s.Id}`} onClick={() => choose(s)} disabled={captureLoading}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, minWidth: 0 }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, flexShrink: 0 }}>
                  <StorageIcon color="action" fontSize="small" titleAccess="Core Supplier" />
                  {s.asiLinked && (
                    <LinkIcon color="success" fontSize="small" titleAccess="Linked to ASI" />
                  )}
                </Box>
                <Box sx={{ minWidth: 0 }}>
                  <Typography variant="body2">{s.Name}</Typography>
                  <Typography variant="caption" color="text.secondary">
                    Core Supplier · Core #{s.Id}
                    {s.AsiNumber ? ` · ASI ${s.AsiNumber}` : ""}
                  </Typography>
                </Box>
              </Box>
            </MenuItem>
          ))}
          {coreLoading && <Typography variant="caption">Searching Core…</Typography>}
          {!coreLoading && coreLookup.query === committedQuery
            && coreLookup.status === "success" && !core.length && (
              <Typography variant="caption">No matching Core suppliers.</Typography>
            )}
          {coreMore && <Button size="small" onClick={() => setCorePage(p => p + 1)}>More Core suppliers</Button>}
          {asiMode === "offer" && (
            <Button size="small" disabled={captureLoading} onClick={() => {
              setManualAsiQuery(committedQuery);
              setAsiPage(1); setAsi([]); setAsiMore(false); setProblem("");
            }}>
              Search more ASI suppliers
            </Button>
          )}
          {asiMode === "search" && (
            <>
              <Divider sx={{ my: 1 }}/>
              <Typography variant="overline" color="text.secondary">ASI Catalogue</Typography>
              {visibleAsi.map(s => (
                <MenuItem key={`asi-${s.Id}`} onClick={() => choose(s)} disabled={captureLoading}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, minWidth: 0 }}>
                    <PublicIcon color="primary" fontSize="small" titleAccess="Live ASI Supplier" />
                    <Box sx={{ minWidth: 0 }}>
                      <Typography variant="body2">{s.Name}</Typography>
                      <Typography variant="caption" color="text.secondary">
                        ASI catalogue · ID {s.Id}{s.AsiNumber ? ` · ASI ${s.AsiNumber}` : ""} · Captured on selection
                      </Typography>
                    </Box>
                  </Box>
                </MenuItem>
              ))}
              {asiLoading && <Typography variant="caption">Searching live ASI suppliers…</Typography>}
              {!asiLoading && !visibleAsi.length && asi.length > 0 && (
                <Typography variant="caption" color="text.secondary">
                  ASI suppliers on this page are already listed in Core above.
                </Typography>
              )}
              {!asiLoading && !asi.length && !asiMore && (
                <Typography variant="caption" color="text.secondary">
                  No matching ASI suppliers found.
                </Typography>
              )}
              {asiMore && <Button size="small" onClick={() => setAsiPage(p => p + 1)}>More ASI suppliers</Button>}
            </>
          )}
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1 }}>
            <Button size="small" onClick={() => setExpanded(false)}>Close results</Button>
          </Box>
        </Paper>
      )}
    </Box>
  );
}

function ManualSupplierMatchField({ instanceUniqueId, showError, helperText }) {
  const { values, setFieldValue } = useFormikContext();
  const { authState } = useContext(AuthContext);
  const supplierAdmin = ["admin", "administrator", "super-administrator", "superadmin"]
    .includes(String(authState?.role || "").toLowerCase().replace(/[_\s]+/g, "-"));
  const [matches, setMatches] = useState([]);
  const [unavailableCount, setUnavailableCount] = useState(0);
  const [checking, setChecking] = useState(false);
  const [lookupError, setLookupError] = useState(false);
  const [capturingAsi, setCapturingAsi] = useState(false);
  const [captureError, setCaptureError] = useState("");
  const supplierName = String(values.supplier || "").trim().replace(/\s+/g, " ");

  useEffect(() => {
    let cancelled = false;
    setMatches([]);
    setUnavailableCount(0);
    setLookupError(false);
    setChecking(Boolean(supplierName));
    if (!supplierName) return () => { cancelled = true; };
    const timer = setTimeout(async () => {
      try {
        const response = await axios.get(
          process.env.REACT_APP_NODEJS_SERVER_URL + "/suppliers/custom-product/exact-name",
          {
            params: { instanceUniqueId, name: supplierName },
            headers: { accessToken: localStorage.getItem("accessToken") },
          }
        );
        if (!cancelled) {
          setMatches(response.data.matches || []);
          setUnavailableCount(response.data.unavailableCount || 0);
        }
      } catch (_error) {
        if (!cancelled) setLookupError(true);
      } finally {
        if (!cancelled) setChecking(false);
      }
    }, 250);
    return () => { cancelled = true; clearTimeout(timer); };
  }, [supplierName, instanceUniqueId]);

  const chooseManualMatch = async (match) => {
    if (capturingAsi) return;
    let selected = { Id: match.Id, Name: match.Name };
    if (match.source === "asi-live") {
      setCapturingAsi(true);
      setCaptureError("");
      try {
        selected = await captureProductAsiSupplier(instanceUniqueId, match.Id);
      } catch (error) {
        setCaptureError(error?.response?.data?.error || "Could not link this ASI supplier. No selection was saved.");
        return;
      } finally {
        setCapturingAsi(false);
      }
    }
    setFieldValue("supplier", selected.Name);
    setFieldValue("supplierObj", { Id: selected.Id, Name: selected.Name });
    setFieldValue("supplierDetails", {});
    setFieldValue("supplierAutoApprove", false);
    setCaptureError("");
  };

  const selectedId = String(values.supplierObj?.Id ?? "");
  const selectedMatch = matches.some((match) => String(match.Id) === selectedId);

  return (
    <Box>
      <TextField
        label="Supplier (manual)"
        fullWidth margin="normal" value={values.supplier}
        disabled={capturingAsi}
        onChange={(event) => {
          setFieldValue("supplier", event.target.value);
          setFieldValue("supplierObj", null);
          setCaptureError("");
        }}
        error={showError}
        helperText={helperText || "Type a supplier name to check for an existing exact match."}
      />
      {checking && <Typography variant="caption">Checking existing suppliers…</Typography>}
      {capturingAsi && <Typography variant="caption">Verifying ASI supplier association…</Typography>}
      {captureError && <Typography variant="caption" color="error">{captureError}</Typography>}
      {!checking && lookupError && <Typography variant="caption" color="error">Could not check existing suppliers. Please try again.</Typography>}
      {!checking && !lookupError && matches.length > 0 && (
        <Box sx={{ mt: 1 }}>
          <Typography variant="body2" sx={{ mb: 1 }}>
            {selectedMatch ? "Existing supplier selected" : "Exact match found — select the existing supplier:"}
          </Typography>
          {matches.map((match) => (
            <Button key={match.Id} type="button" size="small"
              variant={String(match.Id) === selectedId ? "contained" : "outlined"}
              sx={{ mr: 1, mb: 1, textTransform: "none" }}
              disabled={capturingAsi}
              onClick={() => chooseManualMatch(match)}>
              {match.Name} · Core #{match.Id} · {match.source === "asi-live" ? "ASI" : "Custom"}
            </Button>
          ))}
        </Box>
      )}
      {!checking && !lookupError && unavailableCount > 0 && (
        <Typography variant="caption" color="warning.main">
          An archived or declined supplier also has this name. Review it in the supplier directory.
        </Typography>
      )}
      {!checking && !lookupError && matches.length === 0 && unavailableCount === 0 && Boolean(supplierName) && (
        <Box sx={{ mt: 1 }}>
          <Typography variant="caption" color="text.secondary">
            No exact match. Saving creates a new Core Supplier with its own ID, pending review.
          </Typography>
          <Accordion sx={{ mt: 1 }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="body2">New supplier details (optional)</Typography>
            </AccordionSummary>
            <AccordionDetails>
              {[
                ["email", "Email"],
                ["phone", "Phone"],
                ["fax", "Fax"],
                ["website", "Website (https://)"],
                ["addressStreet", "Street"],
                ["addressCity", "City"],
                ["addressState", "Province / State"],
                ["addressPostal", "Postal / ZIP"],
                ["addressCountry", "Country"],
              ].map(([field, label]) => (
                <TextField
                  key={field} size="small" fullWidth margin="dense" label={label}
                  value={values.supplierDetails?.[field] || ""}
                  onChange={(event) => setFieldValue("supplierDetails." + field, event.target.value)}
                />
              ))}
              {supplierAdmin && (
                <FormControlLabel
                  control={<Checkbox
                    checked={Boolean(values.supplierAutoApprove)}
                    onChange={(_, checked) => setFieldValue("supplierAutoApprove", checked)}
                  />}
                  label="Approve new supplier immediately (administrator)"
                />
              )}
            </AccordionDetails>
          </Accordion>
        </Box>
      )}
    </Box>
  );
}

function PopupCustomProduct({
  open,
  onClose,
  handleCreateProduct,
  handleUpdateProduct,     
  instanceUniqueId,
  mode = "create",         
  initialProduct = null 
}) {
  const [overrideSupplier, setOverrideSupplier] = useState(false);

  const [recentTemplates, setRecentTemplates] = useState([]);
  const [loadingTemplates, setLoadingTemplates] = useState(false);

  // image upload state
  const [uploadingImages, setUploadingImages] = useState(false);
  const [imageUrls, setImageUrls] = useState([]); // ordered list; [0] is featured
  const fileInputRef = useRef(null);

  const initialValues = {
    templateId: "",
    // core
    supplierObj: null,
    supplier: "",
    supplierDetails: {},
    supplierAutoApprove: false,
    supplierCode: "",
    name: "",
    description: "",
    shortDescription: "",

    // images
    imageUrl: "",
    imagesJson: "[]",

    // details (accordion)
    categories: "",
    themes: "",
    origin: "",
    tradeNames: "",
    productionTime: "",
    rushTime: "",

    // pricing
    priceMode: "single", // "single" | "variants"
    currency: "CAD",
    price: 0,
    cost: 0,
    isQUR: false,

    variants: [
      // { Number, ImageUrl, Price, Cost, CurrencyCode, Attributes: [{ type, value }] }
    ],
    attributesJson: "{}",
    skuJson: "[]"
  };

  useEffect(() => {
    if (!open) return;
    setLoadingTemplates(true);
    axios
      .get(`${process.env.REACT_APP_NODEJS_SERVER_URL}/products/get-custom-products`, {
        params: { instanceUniqueId, latest: 50 } // tweak count as you like
      })
      .then(res => setRecentTemplates(Array.isArray(res.data) ? res.data : []))
      .catch(() => setRecentTemplates([]))
      .finally(() => setLoadingTemplates(false));
  }, [open, instanceUniqueId]);  

  const prefillFromTemplate = React.useCallback((tpl, setFieldValue) => {
    if (!tpl) return; 

    // images: prefer ImageUrl then Images[0]
    const toArray = (x) => Array.isArray(x) ? x : (typeof x === "string" ? (() => { try { return JSON.parse(x); } catch { return []; } })() : []);
    const imgs = toArray(tpl.Images);
    const primary = tpl.ImageUrl || imgs[0] || "";

    // put into gallery + form
    const nextImages = primary ? (imgs.length ? imgs : [primary]) : imgs;
    setImageUrls(nextImages);
    setFieldValue("imageUrl", primary);
    setFieldValue("imagesJson", JSON.stringify(nextImages));

    // supplier
    const supName = tpl?.Supplier?.Name || "";
    const foundSup = tpl?.Supplier?.Id && supName ? { Id: tpl.Supplier.Id, Name: supName } : null;
    setFieldValue("supplier", supName);
    setFieldValue("supplierObj", foundSup);
    // Keep historic ID-based selections, including ASI, during product edits.
    setOverrideSupplier(Boolean(supName && !foundSup));

    // basics
    setFieldValue("supplierCode", tpl?.Number || "");
    setFieldValue("name", tpl?.Name || "");
    setFieldValue("description", tpl?.Description || "");
    setFieldValue("shortDescription", tpl?.ShortDescription || "");

    // csv-ish fields
    const join = (arr) =>
    Array.isArray(arr)
      ? arr.map(x => (typeof x === "object" ? x.Name : x)).filter(Boolean).join(", ")
      : "";

    setFieldValue("categories", join(tpl?.Categories));
    setFieldValue("themes", join(tpl?.Themes));
    setFieldValue("origin", join(tpl?.Origin));
    setFieldValue("tradeNames", join(tpl?.TradeNames));

    setFieldValue("productionTime", String(tpl?.ProductionTime ?? ""));
    setFieldValue("rushTime", String(tpl?.RushTime ?? ""));

    // prices / variants
    const variants = Array.isArray(tpl?.Variants) ? tpl.Variants : [];
    if (variants.length) {
      setFieldValue("priceMode", "variants");
      const skuRows = Array.isArray(tpl?.Sku) ? tpl.Sku : [];
      const mapped = variants.map((v, index) => {
        const p0 = Array.isArray(v.Prices) && v.Prices[0] ? v.Prices[0] : null;
        const number = v.Number || v.SKU || "";
        return {
          Number: number,
          ImageUrl: v.ImageUrl || primary || "",
          Price: p0?.Price ?? "",
          Cost: p0?.Cost ?? p0?.Price ?? "",
          CurrencyCode: p0?.CurrencyCode || "CAD",
          Attributes: formAttributesFromFlatVariant(v, skuValuesForVariant(skuRows, v, index))
        };
      });
      setFieldValue("variants", mapped);
      // clear single price to avoid confusion
      setFieldValue("price", "");
      setFieldValue("cost", "");
    } else {
      setFieldValue("priceMode", "single");
      const p = tpl?.LowestPrice || (Array.isArray(tpl?.Prices) && tpl.Prices[0]) || null;
      if (p) {
        setFieldValue("currency", p.CurrencyCode || "CAD");
        setFieldValue("price", p.Price ?? p.Cost ?? "");
        setFieldValue("cost", p.Cost ?? p.Price ?? "");
      }
      setFieldValue("variants", []);
    }
  }, []); 


  const schema = Yup.object({
    supplier: Yup.string().required("Supplier is required"),
    name: Yup.string().required("Product name is required"),
    description: Yup.string().required("Product description is required"),
    priceMode: Yup.string().oneOf(["single", "variants"]).required(),
    price: Yup.number().when("priceMode", {
      is: "single",
      then: (s) => s.typeError("Enter a number").min(0, "Enter 0 or more").required("Price is required")
    }),
    cost: Yup.number().when("priceMode", {
      is: "single",
      then: (s) => s.typeError("Enter a number").min(0, "Enter 0 or more")
    }),
    variants: Yup.array().when("priceMode", {
      is: "variants",
      then: (s) =>
        s
          .of(
            Yup.object({
              Number: Yup.string().required("Number is required"),
              Price: Yup.number()
                .typeError("Enter a number")
                .min(0, "Enter 0 or more")
                .required("Price is required"),
              Cost: Yup.number()
                .typeError("Enter a number")
                .min(0, "Enter 0 or more")
                .required("Cost is required"),
              CurrencyCode: Yup.string().required("Currency is required"),
              Attributes: Yup.array()
                .test("has-attribute", "Add at least one attribute type and value.", (attrs) =>
                  Array.isArray(attrs) && attrs.some((attr) =>
                    String(attr?.type || "").trim() && String(attr?.value || "").trim()
                  )
                )
            })
          )
          .min(1, "Add at least one variant")
    })
  });


  // helpers
  const parseCsv = (str) =>
    (str || "")
      .split(",")
      .map((s) => s.trim())
      .filter(Boolean);

  const toPriceObj = (price, cost, currency) => ({
    Cost: Number(cost ?? price) || Number(price) || 0,
    IsQUR: false,
    Price: Number(price) || 0,
    Quantity: { From: 1, To: qtyInfinity, $index: 1 },
    CurrencyCode: currency || "CAD"
  });

  // ----- Drag & Drop images -----
  const onPickFiles = async (fileList, setFieldValue) => {
    if (!fileList?.length) return;
    setUploadingImages(true);
    try {
      const uploads = [];
      for (const f of fileList) {
        // pass the correct customer/instance id in the path, and the file + folder in body
        const up = await uploadSupplierImage(f, "custom-products");
        const url = up?.data?.url || up?.data?.Location;

        if (url) uploads.push(url);
      }
      if (uploads.length) {
        const next = [...imageUrls, ...uploads];
        setImageUrls(next);
        setFieldValue('imageUrl', next[0] || '');                  // featured = first
        setFieldValue('imagesJson', JSON.stringify(next));
        if (fileInputRef.current) fileInputRef.current.value = ''; // allow reselecting same file
      }
    } catch (e) {
      console.error('Image upload failed', e);
    } finally {
      setUploadingImages(false);
    }
  };


  const onDrop = (e, setFieldValue) => {
    e.preventDefault();
    const files = Array.from(e.dataTransfer.files || []).filter((f) =>
      /^image\//i.test(f.type)
    );
    if (files.length) onPickFiles(files, setFieldValue);
  };

  const makeFeatured = (idx, setFieldValue) => {
    const next = [...imageUrls];
    const [picked] = next.splice(idx, 1);
    next.unshift(picked);
    setImageUrls(next);
    setFieldValue("imageUrl", next[0] || "");
    setFieldValue("imagesJson", JSON.stringify(next));
  };

  const removeImage = (idx, setFieldValue) => {
    const next = imageUrls.filter((_, i) => i !== idx);
    setImageUrls(next);
    setFieldValue("imageUrl", next[0] || "");
    setFieldValue("imagesJson", JSON.stringify(next));
  };

  // Small titled section with icon (keeps your classes; adds `section-card`)
  const SectionCard = ({ icon: Icon, title, hint, children, className }) => (
    <Box
      className={`section-card ${className || ""}`}
      sx={{
        borderRadius: 2,
        border: "1px solid rgba(0,0,0,0.08)",
        boxShadow: "0 1px 2px rgba(0,0,0,0.04)",
        p: 2,
        mb: 2
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
        {Icon && <Icon sx={{ opacity: 0.75 }} />}
        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
          {title}
        </Typography>
        {!!hint && (
          <Chip size="small" variant="outlined" label={hint} sx={{ ml: 1 }} />
        )}
      </Box>
      {children}
    </Box>
  );

  // Use for labels that need a hover explanation
  const LabelWithHelp = ({ label, help }) => (
    <Box sx={{ display: "inline-flex", alignItems: "center", gap: 0.5 }}>
      <span>{label}</span>
      {help && (
        <Tooltip title={help} PopperProps={{ sx: { zIndex: 20000 } }} arrow>
          <InfoOutlinedIcon fontSize="small" sx={{ opacity: 0.6 }} />
        </Tooltip>
      )}
    </Box>
  );

  // Simple tab panel for pricing mode
  const TabPanel = ({ value, when, children }) => (value === when ? <Box sx={{ mt: 2 }}>{children}</Box> : null);


  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle className="create-order-dialog-title" sx={{ pr: 7 }}>
        {mode === "edit" ? "Edit Product" : "Create New Product"}
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ position: "absolute", right: 12, top: 12 }}
          size="large">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <Formik
        initialValues={initialValues}
        validationSchema={schema}
        validateOnChange={false}
        validateOnBlur={true}
        onSubmit={async (values, helpers) => {
          // build payload for your existing handler
          const {
            priceMode,
            currency,
            price,
            cost,
            variants
          } = values;

          let useAdvancedPrices = false;
          let pricesJson = "";
          let variantsJson = "";
          let attributesJson = "{}";
          let skuJson = "[]";

          if (priceMode === "single") {
            const existingAttributes = initialProduct?.Attributes ?? {};
            const existingSku = initialProduct?.Sku ?? [];

            useAdvancedPrices = false;
            pricesJson = ""; // server will use `price` + `currency`
            variantsJson = "[]";
            // Legacy single-price products can still carry useful option metadata.
            // Preserve it on edit; brand-new single-price products should stay empty.
            attributesJson = JSON.stringify(mode === "edit" ? (existingAttributes || {}) : {});
            skuJson = JSON.stringify(mode === "edit" ? (existingSku || []) : []);
          } else {
            // variants mode: construct explicit sellable variants only; Attributes are option buckets, not generated combinations
            const vs = (variants || []).map((v) => ({
              ...buildFlatVariantFromFormVariant({
                ...v,
                ImageUrl: v.ImageUrl || values.imageUrl || imageUrls[0] || "",
                CurrencyCode: v.CurrencyCode || values.currency || "CAD",
              }),
            }));
            const attrs = buildAttributesFromVariants(vs);
            const sku = buildSkuFromVariants(vs);

            variantsJson = JSON.stringify(vs);
            attributesJson = JSON.stringify(attrs);
            skuJson = JSON.stringify(sku);

            // build a single min price so backend accepts `useAdvancedPrices`
            const pricesFlat = vs.map((vv) => vv.Prices?.[0]).filter(Boolean);
            const minPrice = pricesFlat.reduce(
              (acc, p) =>
                acc == null || (p?.Price ?? Infinity) < (acc?.Price ?? Infinity)
                  ? p
                  : acc,
              null
            );
            const maxPrice = pricesFlat.reduce(
              (acc, p) =>
                acc == null || (p?.Price ?? -Infinity) > (acc?.Price ?? -Infinity)
                  ? p
                  : acc,
              null
            );

            useAdvancedPrices = true;
            pricesJson = JSON.stringify(
              minPrice ? [minPrice] : [toPriceObj(0, 0, "CAD")]
            );

            // attach helpers the API can use (optional but useful)
            values.lowestPriceJson = JSON.stringify(minPrice || null);
            values.highestPriceJson = JSON.stringify(maxPrice || null);
          }

          const singlePrice = Number(values.price || 0);
          const singleCost =
            values.cost === "" || values.cost == null
              ? singlePrice
              : Number(values.cost);

          const payload = {
            instanceUniqueId,
            // supplier
            supplier: values.supplier,
            supplierObj: values.supplierObj || null,
            supplierDetails: values.supplierDetails || {},
            supplierAutoApprove: Boolean(values.supplierAutoApprove),
            // basics
            supplierCode: values.supplierCode || "",
            name: values.name,
            description: values.description,
            shortDescription: values.shortDescription || "",
            // images
            imageUrl: values.imageUrl || imageUrls[0] || "",
            imagesJson: values.imagesJson,
            // details
            categories: values.categories,
            themes: values.themes,
            origin: values.origin,
            tradeNames: values.tradeNames,
            productionTime: values.productionTime || 0,
            rushTime: values.rushTime || 0,
            // pricing
            priceMode,
            price: priceMode === "single" ? singlePrice : 0,
            cost: priceMode === "single" ? singleCost : 0,
            currency: priceMode === "single" ? currency : (currencies[0] || "CAD"),
            isQUR: values.isQUR ? "1" : "0",
            useAdvancedPrices: String(useAdvancedPrices),
            pricesJson,
            variantsJson,
            attributesJson,
            skuJson
          };

          try {
            const isEdit = Boolean(initialProduct?.Id ?? initialProduct?.id);
            if (isEdit) {
              if (!(await handleUpdateProduct(payload, initialProduct))) return;
            } else {
              if (!(await handleCreateProduct(payload))) return;
            }
            helpers.resetForm();
            onClose();
          } finally {
            helpers.setSubmitting(false);
          }

        }}
      >
        {({
          values,
          errors,
          touched,
          setFieldValue,
          handleSubmit,
          isSubmitting,
          submitCount
        }) => {
          const { show, text } = getErrorHelpers(errors, touched, submitCount);
          return (
            <form onSubmit={handleSubmit}>
              <PrefillOnEdit
                open={open}
                mode={mode}
                initialProduct={initialProduct}
                prefillFromTemplate={prefillFromTemplate}
                setImageUrls={setImageUrls}
              />
              <DialogContent dividers>
                <Grid container spacing={2}>
                  {/* LEFT – 60% */}
                  <Grid item xs={12} md={7}>



                  {mode !== "edit" && (
                  <SectionCard icon={AssignmentIcon} title="Start with a template" hint="Optional">
                    <Field
                      as={TextField}
                      select
                      name="templateId"
                      label={<LabelWithHelp label="Import settings from…" help="Prefill this form with a recent custom product. You can still edit anything after importing." />}
                      fullWidth
                      margin="normal"
                      value={values.templateId}
                      onChange={(e) => {
                        const id = e.target.value;
                        setFieldValue("templateId", id);
                        const tpl = recentTemplates.find(p => String(p.Id ?? p.id) === String(id));
                        prefillFromTemplate(tpl, setFieldValue);
                      }}
                      helperText={loadingTemplates ? "Loading…" : "Choose a product to copy settings/images/prices"}
                    >
                      <MenuItem value="">— None —</MenuItem>
                      {recentTemplates.map((p) => (
                        <MenuItem key={p.Id || p.id} value={p.Id || p.id}>
                          {p.Name || "Untitled"}
                        </MenuItem>
                      ))}
                    </Field>
                  </SectionCard>
                  )}

<SectionCard icon={CategoryIcon} title="Basics">
  <Box sx={{ display: "flex", gap: 2, alignItems: "center", mb: 1 }}>
    <FormControlLabel
      control={
        <Checkbox
          checked={overrideSupplier}
          onChange={() => {
             setOverrideSupplier((v) => !v);
             setFieldValue("supplierObj", null);
             setFieldValue("supplierDetails", {});
             setFieldValue("supplierAutoApprove", false);
           }}
        />
      }
      label={<LabelWithHelp label="Override supplier" help="If off, search existing Core and live ASI suppliers. If on, enter a new custom supplier name or select an exact match." />}
    />
  </Box>

  {!overrideSupplier ? (
    <CustomProductSupplierSearch instanceUniqueId={instanceUniqueId} showError={show("supplier")} helperText={text("supplier")} />
  ) : (
    <ManualSupplierMatchField instanceUniqueId={instanceUniqueId} showError={show("supplier")} helperText={text("supplier")} />
  )}

  {values.priceMode === "single" && (
    <TextField
      label={<LabelWithHelp label="Supplier Product Code" help="Supplier’s SKU or your internal code, used for quick reference." />}
      fullWidth
      margin="normal"
      value={values.supplierCode}
      onChange={(e) => setFieldValue("supplierCode", e.target.value)}
      placeholder="e.g., RFWOR115PG"
    />
  )}

  <TextField
    label={<LabelWithHelp label="Product name" help="The title that appears on cards, quotes, and client views." />}
    fullWidth
    margin="normal"
    value={values.name}
    onChange={(e) => setFieldValue("name", e.target.value)}
    error={show("name")}
    helperText={text("name")}
  />

  <BlurTextField
    name="description"
    label={<LabelWithHelp label="Product description" help="Full description (features, materials, packaging, notes, etc.)." />}
    multiline
    rows={5}
    margin="normal"
  />
</SectionCard>

<SectionCard icon={CategoryIcon} title="General details" hint="Optional">
  <Accordion sx={{ mt: 0 }} TransitionProps={{ unmountOnExit: true }}>
    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
      <Typography>Show fields</Typography>
    </AccordionSummary>
    <AccordionDetails>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <BlurTextField
            name="shortDescription"
            label={<LabelWithHelp label="Short description" help="One-liner for product cards and quick views." />}
            margin="normal"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label={<LabelWithHelp label="Categories" help="Comma-separated. Example: Awards, Glass, Recognition" />}
            fullWidth
            value={values.categories}
            onChange={(e) => setFieldValue("categories", e.target.value)}
            placeholder="Awards, Glass, Recognition"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label={<LabelWithHelp label="Themes" help="Comma-separated. Example: Holiday, Event" />}
            fullWidth
            value={values.themes}
            onChange={(e) => setFieldValue("themes", e.target.value)}
            placeholder="Holiday, Event"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label={<LabelWithHelp label="Origin" help="Comma-separated. Countries of origin used for filtering." />}
            fullWidth
            value={values.origin}
            onChange={(e) => setFieldValue("origin", e.target.value)}
            placeholder="Canada, USA"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label={<LabelWithHelp label="Trade names" help="Comma-separated alternate or branded names used in search." />}
            fullWidth
            value={values.tradeNames}
            onChange={(e) => setFieldValue("tradeNames", e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label={<LabelWithHelp label="Production time (days)" help="Estimated standard lead time in business days." />}
            type="number"
            fullWidth
            value={values.productionTime}
            onChange={(e) => setFieldValue("productionTime", e.target.value)}
            InputProps={{ startAdornment: <AccessTimeIcon sx={{ mr: 1, opacity: .6 }} /> }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label={<LabelWithHelp label="Rush time (days)" help="Accelerated lead time (if applicable)." />}
            type="number"
            fullWidth
            value={values.rushTime}
            onChange={(e) => setFieldValue("rushTime", e.target.value)}
            InputProps={{ startAdornment: <AccessTimeIcon sx={{ mr: 1, opacity: .6 }} /> }}
          />
        </Grid>
      </Grid>
    </AccordionDetails>
  </Accordion>
</SectionCard>




                  </Grid>

                  {/* RIGHT – 40% */}
                  <Grid item xs={12} md={5} className="product-image-overview">

                  <SectionCard icon={CollectionsIcon} title="Product images" className="product-image-overview" hint="Drag & drop">
  <Typography variant="body2" sx={{ mb: 1, opacity: 0.8 }}>
    First image becomes the featured image automatically. Click a tile to set <em>Featured</em> or remove.
  </Typography>

  <Box
    onDragOver={(e) => e.preventDefault()}
    onDrop={(e) => onDrop(e, setFieldValue)}
    sx={{
      border: "2px dashed rgba(0,0,0,0.2)",
      borderRadius: 2,
      p: 3,
      textAlign: "center",
      cursor: "pointer",
      mb: 2
    }}
    onClick={() => fileInputRef.current?.click()}
  >
    <input
      ref={fileInputRef}
      type="file"
      accept="image/*"
      multiple
      hidden
      onChange={(e) => onPickFiles(Array.from(e.target.files || []), setFieldValue)}
    />
    <Typography sx={{ opacity: 0.75 }}>
      {uploadingImages ? "Uploading…" : "Drop images here or click to choose"}
    </Typography>
    <Typography variant="caption" sx={{ opacity: 0.6 }}>
      Stored in S3 under <code>supplier-images/custom-products</code>.
    </Typography>
  </Box>

  {imageUrls.length > 0 && (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: 1,
        mb: 2
      }}
      className="product-image-gallery"
    >
      {imageUrls.map((url, idx) => (
        <Box
          key={url + idx}
          sx={{
            position: "relative",
            borderRadius: 1,
            overflow: "hidden",
            border: idx === 0 ? "2px solid #1976d2" : "1px solid rgba(0,0,0,0.12)"
          }}
        >
          <img src={url} alt={`img-${idx}`} style={{ width: "100%", display: "block" }} />
          <Box
            sx={{ position: "absolute", top: 4, left: 4, display: "flex", gap: 0.5 }}
          >
            {idx === 0 && <Chip size="small" color="primary" label="Featured" />}
          </Box>
          <Box
            sx={{
              position: "absolute",
              top: 4,
              right: 4,
              display: "flex",
              gap: 0.5
            }}
          >
            {idx !== 0 && (
              <Button size="small" variant="contained" onClick={() => makeFeatured(idx, setFieldValue)}>
                Featured
              </Button>
            )}
            <IconButton
              size="small"
              color="error"
              onClick={() => removeImage(idx, setFieldValue)}
              sx={{ bgcolor: "rgba(255,255,255,0.9)" }}
              title="Remove image"
            >
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Box>
        </Box>
      ))}
    </Box>
  )}
</SectionCard>

<SectionCard icon={MonetizationOnIcon} title="Pricing">

  {/* NEW: Currency selector for both Single + Variant modes */}
  <Grid container spacing={2} sx={{ mb: 2 }}>
    <Grid item xs={12} sm={4}>
      <TextField
        select
        label={<LabelWithHelp label="Currency" help="Currency applied for Single and Variant pricing." />}
        fullWidth
        value={values.currency}
        onChange={(e) => setFieldValue("currency", e.target.value)}
      >
        {currencies.map((c) => (
          <MenuItem key={c} value={c}>{c}</MenuItem>
        ))}
      </TextField>
    </Grid>
  </Grid>

  <Tabs
    value={values.priceMode}
    onChange={(_, v) => setFieldValue("priceMode", v)}
    aria-label="Pricing mode"
  >
    <Tab
      value="single"
      icon={<PriceChangeIcon />}
      iconPosition="start"
      label="Single price"
    />
    <Tab
      value="variants"
      icon={<InventoryIcon />}  // you already import this
      iconPosition="start"
      label="Variants"
    />
  </Tabs>

  <Divider sx={{ my: 1 }} />

  <Typography variant="body2" sx={{ opacity: 0.8 }}>
    {values.priceMode === "single"
      ? "Use one base price & currency for the product. Great for simple SKUs."
      : "Add explicit sellable variant rows with SKU, attributes, and their own price/cost. We’ll display the lowest price on cards."}
  </Typography>

  <TabPanel value={values.priceMode} when="single">
    <Grid container spacing={2} sx={{ mt: 0.5 }}>
      <Grid item xs={12} sm={4}>
        <TextField
          select
          label={<LabelWithHelp label="Currency" help="Currency for the single price." />}
          fullWidth
          value={values.currency}
          onChange={(e) => setFieldValue("currency", e.target.value)}
        >
          {currencies.map((c) => (
            <MenuItem key={c} value={c}>
              {c}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid item xs={12} sm={4}>
        <TextField
          label={<LabelWithHelp label="Net Cost" help="Your internal net cost. If blank we'll fall back to Retail." />}
          type="number"
          fullWidth
          value={values.cost}
          onChange={(e) => setFieldValue("cost", e.target.value)}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <TextField
          label={<LabelWithHelp label="Retail" help="Retail price shown on cards and quotes." />}
          type="number"
          fullWidth
          value={values.price}
          onChange={(e) => setFieldValue("price", e.target.value)}
          error={show("price")}
          helperText={text("price")}
        />
      </Grid>
      <Grid item xs={12}>
        <FormControlLabel
          control={
            <Checkbox
              checked={values.isQUR}
              onChange={(e) => setFieldValue("isQUR", e.target.checked)}
            />
          }
          label={<LabelWithHelp label="Is QUR" help="Quote Upon Request — hide pricing and prompt for a custom quote." />}
        />
      </Grid>
    </Grid>
  </TabPanel>

  <TabPanel value={values.priceMode} when="variants">
    {touched.variants && typeof errors.variants === "string" && (
      <Typography color="error" sx={{ mb: 1 }}>
        {errors.variants}
      </Typography>
    )}
    {(values.variants || []).map((v, idx) => {
      const vErr = Array.isArray(errors.variants) ? errors.variants[idx] : undefined;
      const vTouch = Array.isArray(touched.variants) ? touched.variants[idx] : undefined;
      const showVarErr = (field) => Boolean(vErr?.[field]) && Boolean(vTouch?.[field] || submitCount > 0);
      const textVarErr = (field) => (showVarErr(field) ? vErr?.[field] : undefined);

      return (
        <Box
          key={`var-${idx}`}
          sx={{
            border: "1px solid rgba(0,0,0,0.12)",
            borderRadius: 1,
            p: 2,
            mb: 1.5
          }}
        >
          <Grid container spacing={1.5}>
            <Grid item xs={12} sm={4}>
              <TextField
                label={<LabelWithHelp label="Number" help="Supplier code/SKU for this variant." />}
                fullWidth
                value={v.Number || ""}
                onChange={(e) => setFieldValue(`variants[${idx}].Number`, e.target.value)}
                error={showVarErr("Number")}
                helperText={textVarErr("Number")}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                label="Currency"
                value={values.currency}
                fullWidth
                disabled
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              <TextField
                label={<LabelWithHelp label="Net Cost" help="Net cost for this variant." />}
                type="number"
                fullWidth
                value={v.Cost ?? ""}
                onChange={(e) => setFieldValue(`variants[${idx}].Cost`, e.target.value)}
                error={showVarErr("Cost")}
                helperText={textVarErr("Cost")}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                label={<LabelWithHelp label="Retail" help="Retail price for this variant." />}
                type="number"
                fullWidth
                value={v.Price ?? ""}
                onChange={(e) => setFieldValue(`variants[${idx}].Price`, e.target.value)}
                error={showVarErr("Price")}
                helperText={textVarErr("Price")}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                label={<LabelWithHelp label="Image URL (optional)" help="Leave blank to inherit the featured product image." />}
                fullWidth
                value={v.ImageUrl || ""}
                onChange={(e) => setFieldValue(`variants[${idx}].ImageUrl`, e.target.value)}
                placeholder={values.imageUrl || "https://…"}
              />
            </Grid>

            <Grid item xs={12}>
              <Box sx={{ mt: 1, p: 1.5, borderRadius: 1, bgcolor: "rgba(0,0,0,0.03)" }}>
                <Typography variant="subtitle2" sx={{ mb: 1 }}>Attributes</Typography>
                {(Array.isArray(v.Attributes) && v.Attributes.length ? v.Attributes : [{ type: "Size", value: "" }]).map((attr, attrIdx) => (
                  <Grid container spacing={1} key={`var-${idx}-attr-${attrIdx}`} sx={{ mb: 1 }}>
                    <Grid item xs={12} sm={5}>
                      <TextField
                        label="Attribute Type"
                        fullWidth
                        value={attr.type || ""}
                        onChange={(e) => setFieldValue(`variants[${idx}].Attributes[${attrIdx}].type`, e.target.value)}
                        placeholder={COMMON_VARIANT_ATTRIBUTE_TYPES.join(", ")}
                        inputProps={{ list: `variant-attribute-types-${idx}-${attrIdx}` }}
                      />
                      <datalist id={`variant-attribute-types-${idx}-${attrIdx}`}>
                        {COMMON_VARIANT_ATTRIBUTE_TYPES.map((type) => (
                          <option key={type} value={type} />
                        ))}
                      </datalist>
                    </Grid>
                    <Grid item xs={12} sm={5}>
                      <TextField
                        label="Attribute Value"
                        fullWidth
                        value={attr.value || ""}
                        onChange={(e) => setFieldValue(`variants[${idx}].Attributes[${attrIdx}].value`, e.target.value)}
                        placeholder="e.g., Large, Red, Cotton"
                      />
                    </Grid>
                    <Grid item xs={12} sm={2} sx={{ display: "flex", alignItems: "center" }}>
                      <IconButton
                        color="error"
                        disabled={(v.Attributes || []).length <= 1}
                        onClick={() => {
                          const nextAttrs = [...(v.Attributes || [])];
                          nextAttrs.splice(attrIdx, 1);
                          setFieldValue(`variants[${idx}].Attributes`, nextAttrs.length ? nextAttrs : [{ type: "Size", value: "" }]);
                        }}
                        title="Remove attribute"
                      >
                        <DeleteIcon />
                      </IconButton>
                    </Grid>
                  </Grid>
                ))}
                {showVarErr("Attributes") && (
                  <Typography variant="caption" color="error">{textVarErr("Attributes")}</Typography>
                )}
                <Button
                  size="small"
                  startIcon={<AddIcon />}
                  onClick={() => setFieldValue(`variants[${idx}].Attributes`, [
                    ...(v.Attributes || []),
                    { type: "", value: "" }
                  ])}
                >
                  Add attribute
                </Button>
              </Box>
            </Grid>
          </Grid>
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1 }}>
            <IconButton
              color="error"
              onClick={() => {
                const next = [...values.variants];
                next.splice(idx, 1);
                setFieldValue("variants", next);
              }}
              title="Remove variant"
              size="large">
              <DeleteIcon />
            </IconButton>
          </Box>
        </Box>
      );
    })}

    <Button
      startIcon={<AddIcon />}
      onClick={() =>
        setFieldValue("variants", [
          ...(values.variants || []),
          {
            Number: "",
            ImageUrl: "",
            Price: 0,
            Cost: 0,
            CurrencyCode: values.currency || "CAD",
            Attributes: [{ type: "Size", value: "" }]
          }
        ])
      }
    >
      Add variant
    </Button>
  </TabPanel>
</SectionCard>

                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button
                  type="submit"
                  variant="contained"
                  disabled={isSubmitting || uploadingImages}
                >
                  {mode === "edit" ? "Save changes" : "Create product"}
                </Button>
              </DialogActions>
            </form>
          );
        }}  
      </Formik>
    </Dialog>
  );
}



const human = (bytes) => {
  if (!Number.isFinite(bytes)) return "";
  const units = ["B","KB","MB","GB","TB"];
  let i = 0, n = bytes;
  while (n >= 1024 && i < units.length - 1) { n /= 1024; i++; }
  return `${n.toFixed(n < 10 && i > 0 ? 1 : 0)} ${units[i]}`;
};

export const supplierOptionsForImportSource = (importSource, generalSuppliers, supplierApiOptions) =>
  importSource === "supplier_api" ? supplierApiOptions : generalSuppliers;

export const ImportProgressChips = ({ status, context, sourceType }) => (
  <Stack direction="row" alignItems="center" role="group" aria-label="Import status and context" sx={{ mb: 1, gap: 1, flexWrap: "wrap" }}>
    <Chip label={status === "reading_file" && sourceType === "supplier_service_product_data" ? "fetching catalogue" : status} color={status === "failed" ? "error" : status === "completed" ? "success" : status === "cancelled" ? "default" : "info"} />
    {context?.supplierName && <Chip label={context.supplierName} variant="outlined" />}
    <Chip label={context?.destinationLabel} variant="outlined" />
  </Stack>
);

export const PopupImportCustomCatalog = ({ open, onClose, instanceUniqueId, onImported }) => {
  const [suppliers, setSuppliers] = useState([]);
  const [supplierApiOptions, setSupplierApiOptions] = useState([]);
  const [loadingSuppliers, setLoadingSuppliers] = useState(false);
  const [loadingSupplierApiOptions, setLoadingSupplierApiOptions] = useState(false);

  // upload state


  const [phase, setPhase] = useState('idle'); // 'idle' | 'upload' | 'processing' | 'done'
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState({ pct: 0, loaded: 0, total: 0 });
  const [importResult, setImportResult] = useState(null);
  const [showResultDialog, setShowResultDialog] = useState(false);
  const [lastDryRunValues, setLastDryRunValues] = useState(null);
  const [submittedImportContext, setSubmittedImportContext] = useState(null);
  const [lastSupplierApiImportValues, setLastSupplierApiImportValues] = useState(null);
  const [activeImportBatchId, setActiveImportBatchId] = useState(null);
  const [polling, setPolling] = useState(false);
  const [pollError, setPollError] = useState(null);
  const [supplierApiConnection, setSupplierApiConnection] = useState(null);
  const [supplierApiEstimate, setSupplierApiEstimate] = useState(null);
  const [loadingSupplierApiEstimate, setLoadingSupplierApiEstimate] = useState(false);
  const abortRef = useRef(null);
  const resultViewEpoch = useRef(0);
  const { enabled: autoContinueEnabled, message: autoContinueMessage, start: startAutoContinue, stop: stopAutoContinue } = useProductDataAutoContinue({
    open, visible: showResultDialog, result: importResult, submitted: submittedImportContext, polling, uploading,
    onContinue: () => continueProductDataBatch(true),
  });
  const closeImportDialog = () => { stopAutoContinue(); resultViewEpoch.current += 1; onClose(); };
  const closeImportResults = () => { stopAutoContinue(); resultViewEpoch.current += 1; setShowResultDialog(false); };
  useEffect(() => { if (!open) resultViewEpoch.current += 1; }, [open]);

  useEffect(() => {
    if (!open) return;
    setLoadingSuppliers(true);
    axios.get(`${process.env.REACT_APP_NODEJS_SERVER_URL}/suppliers/get-suppliers`, {
      params: { instanceUniqueId, tab: "custom", pageSize: 1000 },
      headers: { accessToken: localStorage.getItem("accessToken") },
    })
      .then(res => {
        const customs = (res.data.rows || []).filter(sup => {
          try {
            return Array.isArray(sup.References) &&
                   sup.References.some(r => r.source === "custom-core");
          } catch { return false; }
        });
        setSuppliers(customs);
      })
      .catch(err => console.error("Failed to load suppliers:", err))
      .finally(() => setLoadingSuppliers(false));
  }, [open, instanceUniqueId]);

  const loadSupplierApiOptions = useCallback(async () => {
    setLoadingSupplierApiOptions(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/products/catalogue-imports/supplier-api/options`,
        { params: { instanceUniqueId }, headers: { accessToken: localStorage.getItem("accessToken") } }
      );
      setSupplierApiOptions(supplierApiOptionsFromResponse(response));
    } catch (error) {
      console.error("Failed to load Supplier API options:", error);
      setSupplierApiOptions([]);
    } finally {
      setLoadingSupplierApiOptions(false);
    }
  }, [instanceUniqueId]);

  useEffect(() => {
    if (!activeImportBatchId) return undefined;
    let cancelled = false;
    let timeoutId;

    const poll = async () => {
      try {
        const resp = await axios.get(
          `${process.env.REACT_APP_NODEJS_SERVER_URL}/products/catalogue-imports/${activeImportBatchId}`,
          { headers: { accessToken: localStorage.getItem("accessToken") } }
        );
        if (cancelled) return;
        setImportResult(resp.data);
        setPollError(null);
        const status = resp.data.batch?.Status;
        if (["completed", "failed", "cancelled", "paused"].includes(status)) {
          setPolling(false);
          setActiveImportBatchId(null);
          if (status === "completed" && !resp.data.dryRun) {
            onImported && onImported();
          }
          return;
        }
        timeoutId = setTimeout(poll, 1500);
      } catch (e) {
        if (!cancelled) {
          stopAutoContinue("Auto-continue stopped because the progress request failed.");
          setPollError(e?.response?.data?.error || e.message);
          timeoutId = setTimeout(poll, 3000);
        }
      }
    };

    setPolling(true);
    poll();
    return () => {
      cancelled = true;
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [activeImportBatchId, onImported, stopAutoContinue]);

  const initialValues = {
    importSource: "file",
    supplierId: "",
    supplierName: "",
    supplierObj: null,
    file: null,
    currency: "CAD",
    overwrite: false,
    dryRun: false,
    destination: "instance_custom",
    destinationSelections: {},
    importProfile: "parent_variant_csv",
    validationMode: "lenient",
    missingItemStrategy: "leave_unchanged",
    tradeName: "",
    imprintingJson: "",
    columnMap: "",
    rowLimit: 0,
    groupLimit: 0,
    autoContinue: false,
    catalogueMode: "bounded_batch",
    fullImportConfirmed: false,
    catalogueSince: ""
  };

  const validationSchema = Yup.object({
    supplierName: Yup.string().required("Supplier is required"),
    file: Yup.mixed().when("importSource", {
      is: "file",
      then: schema => schema.required("File is required"),
      otherwise: schema => schema.nullable()
    })
  });

  const checkSupplierApiConnection = async (supplier) => {
    if (!supplier?.supplierId) return setSupplierApiConnection(null);
    setSupplierApiConnection({ status: "testing", connected: null });
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/products/catalogue-imports/supplier-api/status`,
        { params: { supplier: supplier.name, supplierId: supplier.supplierId, instanceUniqueId }, headers: { accessToken: localStorage.getItem("accessToken") } }
      );
      setSupplierApiConnection(response.data.connection);
    } catch (error) {
      setSupplierApiConnection(error?.response?.data?.connection || { status: "connection_failed", connected: false });
    }
  };

  const loadSupplierApiEstimate = async ({ supplier, destination = "instance_custom", catalogueSince = "", importProfile = "parent_variant_csv" } = {}) => {
    const supplierId = supplier?.supplierId ?? supplier?.Id ?? supplier?.id;
    const supplierName = supplier?.name ?? supplier?.Name;
    if (!supplierId) { setSupplierApiEstimate(null); return; }
    setLoadingSupplierApiEstimate(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/products/catalogue-imports/supplier-api/product-data/estimate`,
        { params: {
          instanceUniqueId,
          supplierId,
          supplierName,
          provider: supplier.provider,
          destination,
          importProfile,
          ...(catalogueSince ? { changeTimeStamp: `${catalogueSince}T00:00:00Z` } : {}),
        }, headers: { accessToken: localStorage.getItem("accessToken") } }
      );
      setSupplierApiEstimate(response.data);
    } catch (error) {
      setSupplierApiEstimate({ available: false, warning: error?.response?.data?.error || "Catalogue estimate unavailable." });
    } finally {
      setLoadingSupplierApiEstimate(false);
    }
  };

  const executeCatalogueImport = async (values, { setSubmitting = () => {}, resetForm = () => {}, setFieldValue = () => {}, keepResultOpen = false } = {}) => {
    if (values.catalogueMode === "full_catalogue" && !values.dryRun && !values.fullImportConfirmed) { setPollError("Explicitly confirm the full import before starting."); setSubmitting(false); return; }
    const viewEpoch = resultViewEpoch.current;
    if (!values.continueFromBatchId) startAutoContinue(Boolean(!values.catalogueMode && values.autoContinue && !values.dryRun
      && supportsProductDataAutoContinue(values.importSource, supplierApiConnection)));
    try {
      if (keepResultOpen) setImportResult({ dryRun: false, destination: values.destination,
        batch: { Status: "upload_received", SupplierName: values.supplierName, progressPct: 0 } });
      setSubmittedImportContext({ ...buildImportDisplayContext(null, values),
        importSource: values.importSource, sourceType: values.supplierObj?.sourceType, dryRun: values.dryRun });
      setUploading(true);
      setPhase('upload');
      setProgress({ pct: 0, loaded: 0, total: 0 });
      if (values.importSource === "supplier_api" && supplierApiConnection?.capabilities?.cataloguePreview && supplierApiConnection?.capabilities?.catalogueImport !== true) {
        setActiveImportBatchId(null); setPolling(false); setPollError(null);
        const preview = await axios.get(`${process.env.REACT_APP_NODEJS_SERVER_URL}/products/catalogue-previews/supplier-api/product-data`, { params: { instanceUniqueId, supplierId: values.supplierId, limit: Number(values.groupLimit) > 0 ? Number(values.groupLimit) : 10, ...(values.catalogueSince ? { changeTimeStamp: `${values.catalogueSince}T00:00:00Z` } : {}) }, headers: { accessToken: localStorage.getItem("accessToken") } });
        setImportResult({ ...preview.data, previewOnly: true }); if (viewEpoch === resultViewEpoch.current) setShowResultDialog(true); return;
      }
      const controller = new AbortController();
      abortRef.current = controller;

      const form = new FormData();
      form.append("instanceUniqueId", instanceUniqueId || "elite-promo-marketing");
      form.append("importSource", values.importSource || "file");
      form.append("supplierObj", JSON.stringify(values.supplierObj || { Name: values.supplierName }));
      if (values.importSource === "supplier_api" && values.supplierObj?.provider) form.append("provider", values.supplierObj.provider);
      if (values.importSource === "supplier_api" && values.supplierObj?.sourceType) form.append("sourceType", values.supplierObj.sourceType);
      form.append("currency", values.currency);
      form.append("overwrite", values.overwrite ? "1" : "0");
      form.append("dryRun", values.dryRun ? "1" : "0");
      form.append("importProfile", values.importProfile || "parent_variant_csv");
      form.append("destination", values.destination || "instance_custom");
      form.append("validationMode", values.validationMode || "lenient");
      form.append("missingItemStrategy", values.missingItemStrategy || "leave_unchanged");
      form.append("asyncMode", "1");
      if (values.importSource === "supplier_api" && values.catalogueMode) {
        form.append("catalogueMode", values.catalogueMode); form.append("fullImportConfirmed", values.fullImportConfirmed ? "1" : "0");
        if (values.resumeFullJobId) { form.append("resumeFullJobId", String(values.resumeFullJobId)); form.append("expectedJobRevision", String(values.expectedJobRevision)); form.append("resumeFullJobConfirmed", values.resumeFullJobConfirmed ? "1" : "0"); }
      }
      appendCatalogueImportLimits(form, values);
      if (values.importSource === "supplier_api" && values.continueFromBatchId) form.append("continueFromBatchId", String(values.continueFromBatchId));
      if (values.tradeName) form.append("tradeName", values.tradeName);
      if (values.importSource === "file" && values.imprintingJson?.trim()) {
        // optional: send an imprinting template via productsJson
        form.append("productsJson", JSON.stringify([
          { Name: "__IMPRINTING_PLACEHOLDER__", imprintingJson: JSON.parse(values.imprintingJson) }
        ]));
      }
      if (values.importSource === "file" && values.columnMap?.trim()) {
        form.append("columnMap", values.columnMap);
      }
      if (values.importSource === "file") form.append("file", values.file);

      const resp = await axios.post(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/products/create-custom-catalogue`,
        form,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            accessToken: localStorage.getItem("accessToken")
          },
          signal: controller.signal,
          onUploadProgress: (evt) => {
            if (!evt.total) {
              // total may be undefined in some browsers/proxies → show indeterminate
              setProgress(p => ({ ...p, pct: null, loaded: evt.loaded || 0, total: 0 }));
              setPhase('upload');
              return;
            }
            const pct = Math.round((evt.loaded / evt.total) * 100);
            setProgress({ pct, loaded: evt.loaded, total: evt.total });
            if (pct >= 100) setPhase('processing'); // switch as soon as upload is done
          }
        }
      );
      setFieldValue("fullImportConfirmed", false);
      if (values.importSource === "supplier_api") setLastSupplierApiImportValues(snapshotDryRunValues(values));

      if (resp.data?.accepted && resp.data?.importBatchId) {
        setImportResult({
          ...resp.data,
          batch: { Status: resp.data.status || "queued", DryRun: values.dryRun, Diagnostics: { destination: values.destination || "instance_custom" }, progressPct: 0 }
        });
        if (viewEpoch === resultViewEpoch.current) setShowResultDialog(true);
        setPollError(null);
        setActiveImportBatchId(resp.data.importBatchId);
        if (values.dryRun) setLastDryRunValues(snapshotDryRunValues(values));
      } else {
        setImportResult(resp.data);
        if (viewEpoch === resultViewEpoch.current) setShowResultDialog(true);
        if (values.dryRun) {
          setLastDryRunValues(snapshotDryRunValues(values));
        } else {
          onImported && onImported();
          if (!keepResultOpen && !values.autoContinue) {
            const msg = "Import complete";
            alert(`${msg}: ${JSON.stringify(resp.data.summary, null, 2)}`);
            resetForm();
            onClose();
          }
        }
      }
    } catch (e) {
      stopAutoContinue("Auto-continue stopped because the import request failed or was cancelled.");
      if (axios.isCancel?.(e) || e.name === "CanceledError") {
        console.warn("Upload canceled");
      } else {
        console.error(e);
        if (e?.response?.status === 409 && (e?.response?.data?.activeBatch || e?.response?.data?.recovery)) {
          const conflict = e.response.data;
          const activeBatch = conflict.activeBatch;
          const recovery = conflict.recovery || { batchId: activeBatch.id, status: activeBatch.status,
            updatedAt: activeBatch.updatedAt, recoverable: activeBatch.recoverable, stale: activeBatch.stale };
          setImportResult({ ...conflict, dryRun: values.dryRun,
            recovery, batch: { id: activeBatch?.id || conflict.importBatchId, Status: activeBatch?.status || recovery.status } });
          if (viewEpoch === resultViewEpoch.current) setShowResultDialog(true);
        } else alert(`Import failed: ${e?.response?.data?.error || e.message}`);
      }
    } finally {
      setPhase('done');
      setSubmitting(false);
      setUploading(false);
      setProgress({ pct: 0, loaded: 0, total: 0 });
      abortRef.current = null;
    }
  };

  const handleCancelUpload = () => {
    stopAutoContinue("Auto-continue stopped because the upload was cancelled.");
    resultViewEpoch.current += 1;
    try {
      abortRef.current?.abort();
    } catch {}
  };

  const isDeterminate = progress.pct != null && progress.total > 0;

  const batch = importResult?.batch || importResult?.importBatch || {};
  const resultDiagnostics = batch.Diagnostics || importResult?.diagnostics || {};
  const resultContext = buildImportDisplayContext(importResult, submittedImportContext);
  const resultSummary = importResult?.summary || {
    created: batch.Created,
    updated: batch.Updated,
    skipped: batch.Skipped,
    errors: batch.Errors,
    warnings: batch.Warnings,
    wouldCreate: batch.WouldCreate,
    wouldUpdate: batch.WouldUpdate,
    wouldSkip: batch.WouldSkip,
    wouldError: batch.WouldError
  };
  const columnMapping = resultDiagnostics.columnMapping || {};
  const issueSamples = importResult?.issues || resultDiagnostics.issues?.samples || resultDiagnostics.warnings || [];
  const failureDetails = buildImportFailureDetails({ status: batch.Status, diagnostics: resultDiagnostics, issueSamples });
  const activeStatuses = ["queued", "upload_received", "reading_file", "normalizing", "planning", "processing", "persisting_issues", "cancel_requested"];
  const isActiveImportStatus = activeStatuses.includes(batch.Status);
  const canContinueProductDataBatch = canContinueProductDataImport({
    result: importResult, submitted: submittedImportContext, polling, uploading,
  });

  const runImportFromDryRun = async () => {
    if (!lastDryRunValues) { setPollError("Dry-run settings are no longer available. Close this result and run the dry run again."); return; }
    if (dryRunImportActionState({ result: importResult, polling, batchStatus: batch.Status, uploading, hasSavedValues: Boolean(lastDryRunValues) }).disabled) return;
    const realImportValues = { ...snapshotDryRunValues(lastDryRunValues), dryRun: false };
    setShowResultDialog(false);
    await executeCatalogueImport(realImportValues);
  };

  const continueProductDataBatch = async (keepResultOpen = false) => {
    const batchId = batch.id || importResult?.importBatchId;
    if (!batchId || !canContinueProductDataBatch) return;
    const sourceValues = lastSupplierApiImportValues || lastDryRunValues;
    if (!sourceValues) { stopAutoContinue("Auto-continue stopped: saved import settings are unavailable."); setPollError("Import settings are no longer available. Close this result and start the next batch from the import form."); return; }
    if (!keepResultOpen) setShowResultDialog(false);
    await executeCatalogueImport({ ...snapshotDryRunValues(sourceValues), continueFromBatchId: batchId }, { keepResultOpen });
  };

  const resumeFullCatalogueJob = async () => {
    const progress = safeFullCatalogueProgress(resultDiagnostics.fullCatalogueJob); const source = lastSupplierApiImportValues;
    if (!progress?.canResume || !source || polling || uploading || !window.confirm('Resume this full catalogue job from its last verified completed batch? No timed-out request will be replayed automatically.')) return;
    await executeCatalogueImport({ ...snapshotDryRunValues(source), catalogueMode: 'full_catalogue', fullImportConfirmed: !source.dryRun,
      resumeFullJobId: batch.id || importResult.importBatchId, expectedJobRevision: progress.revision, resumeFullJobConfirmed: true }, { keepResultOpen: true });
  };

  const cancelActiveImport = async () => {
    stopAutoContinue("Auto-continue stopped because the import was cancelled.");
    if (uploading) { handleCancelUpload(); return; }
    const batchId = batch.id || importResult?.importBatchId || activeImportBatchId;
    if (!batchId) return;
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/products/catalogue-imports/${batchId}/cancel`,
        { instanceUniqueId, ...(resultDiagnostics.fullCatalogueJob ? { expectedJobRevision: resultDiagnostics.fullCatalogueJob.revision } : {}) },
        { headers: { accessToken: localStorage.getItem("accessToken") } }
      );
      const cancelledBatch = response.data?.batch;
      if (cancelledBatch?.Status === "cancelled") {
        setImportResult({ ...response.data, importBatchId: batchId, dryRun: importResult?.dryRun });
        setActiveImportBatchId(null);
        setPolling(false);
      } else {
        setActiveImportBatchId(batchId);
      }
    } catch (e) {
      setPollError(e?.response?.data?.error || e.message);
    }
  };

  const recoverStaleImport = async () => {
    const batchId = importResult?.recovery?.batchId;
    if (!batchId || !importResult.recovery.recoverable) return;
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/products/catalogue-imports/${batchId}/recover-stale`,
        { instanceUniqueId },
        { headers: { accessToken: localStorage.getItem("accessToken") } }
      );
      setImportResult({ ...response.data, importBatchId: batchId, dryRun: importResult?.dryRun });
      setPollError("");
      setActiveImportBatchId(null);
      setPolling(false);
    } catch (error) {
      setPollError(error?.response?.data?.message || error.message);
    }
  };

  const previewResultModel = buildPreviewResultModel(importResult);
  const dryRunImportAction = dryRunImportActionState({ result: importResult, polling, batchStatus: batch.Status, uploading, hasSavedValues: Boolean(lastDryRunValues) });

  return (<>
    <Dialog open={open && !showResultDialog} onClose={uploading ? undefined : closeImportDialog} maxWidth="sm" className="create-order-dialog" fullWidth>
      <DialogTitle className="create-order-dialog-title">
        Import Product Catalogue - (Experimental)
      </DialogTitle>

      <DialogContent>
        {/* Upload progress bar */}
        {(uploading || phase === 'processing') && (
          <Box sx={{ mb: 2 }}>
            <ImportProgressChips status={phase === "upload" ? "uploading" : "processing"} context={submittedImportContext} />
            {autoContinueMessage && <Typography role="status" variant="body2" sx={{ mb: 1 }}>{autoContinueMessage}</Typography>}
            <LinearProgress
              variant={phase === 'upload' && isDeterminate ? "determinate" : "indeterminate"}
              value={phase === 'upload' && isDeterminate ? progress.pct : undefined}
            />
            <Box sx={{ display: "flex", justifyContent: "space-between", mt: 0.5 }}>
              <Typography variant="caption">
                {phase === 'upload'
                  ? (isDeterminate ? `${progress.pct}%` : "Uploading…")
                  : "Processing on server…"}
              </Typography>
              <Typography variant="caption">
                {phase === 'upload' && isDeterminate ? `${human(progress.loaded)} / ${human(progress.total)}` : ""}
              </Typography>
            </Box>
          </Box>
        )}



        {loadingSuppliers ? (
          <CircularProgress size={24} />
        ) : (
          <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={executeCatalogueImport}>
            {({ isSubmitting, setFieldValue, values }) => (
              <Form>
                <TextField
                  select name="importSource" label="Import Source" value={values.importSource}
                  onChange={e => {
                    const source = e.target.value;
                    setFieldValue("importSource", source);
                    setFieldValue("catalogueMode", "bounded_batch");
                    setFieldValue("fullImportConfirmed", false);
                    setFieldValue("destination", destinationForImportSource(source, values.destinationSelections));
                    setFieldValue("supplierId", "");
                    setFieldValue("supplierName", "");
                    setFieldValue("supplierObj", null);
                    setFieldValue("autoContinue", false);
                    setFieldValue("groupLimit", source === "supplier_api" ? 25 : 0);
                    if (source === "supplier_api") loadSupplierApiOptions();
                    setSupplierApiConnection(null);
                    setSupplierApiEstimate(null);
                  }} fullWidth margin="normal" disabled={uploading}
                >
                  <MenuItem value="file">File Upload</MenuItem>
                  <MenuItem value="supplier_api">Supplier API</MenuItem>
                </TextField>
                <TextField
                  select
                  name={values.importSource === "supplier_api" ? "supplierId" : "supplierName"}
                  label="Custom Supplier"
                  value={values.importSource === "supplier_api" ? values.supplierId : values.supplierName}
                  onChange={(e) => {
                    if (values.importSource === "supplier_api") {
                      const selection = resolveSupplierApiSelection(supplierApiOptions, e.target.value);
                      const option = selection.option;
                      setFieldValue("catalogueMode", "bounded_batch");
                      setFieldValue("fullImportConfirmed", false);
                      setFieldValue("supplierId", option?.supplierId || "");
                      setFieldValue("supplierName", option?.name || "");
                      setFieldValue("supplierObj", supplierApiSupplierPayload(option));
                      setFieldValue("autoContinue", false);
                      const safeLimits = productDataImportLimits(option?.capabilities?.productDataImport?.maxInitialProductLimit);
                      if (!safeLimits.includes(Number(values.groupLimit))) setFieldValue("groupLimit", safeLimits.includes(25) ? 25 : safeLimits[safeLimits.length - 1] || 1);
                      if (selection.connection) setSupplierApiConnection(selection.connection);
                      else checkSupplierApiConnection(option);
                      loadSupplierApiEstimate({ supplier: option, destination: values.destination, catalogueSince: values.catalogueSince, importProfile: values.importProfile });
                    } else {
                      const name = e.target.value;
                      setFieldValue("supplierName", name);
                      const sup = suppliers.find(s => s.Name === name) || null;
                      setFieldValue("supplierObj", sup);
                      setSupplierApiEstimate(null);
                    }
                  }}
                  fullWidth
                  margin="normal"
                  helperText={<ErrorMessage name="supplierName" />}
                  disabled={buildSupplierApiSelectorModel({ importSource: values.importSource, suppliers, supplierApiOptions, uploading }).disabled}
                >
                  {buildSupplierApiMenuItems({ importSource: values.importSource, suppliers, supplierApiOptions, uploading }).map(item => (
                    <MenuItem key={item.key} value={item.value} disabled={item.disabled}>{item.label}</MenuItem>
                  ))}
                </TextField>

                {supplierApiAvailabilityMessage({ importSource: values.importSource, loading: loadingSupplierApiOptions, options: supplierApiOptions }) && (
                  <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                    {supplierApiAvailabilityMessage({ importSource: values.importSource, loading: loadingSupplierApiOptions, options: supplierApiOptions })}
                  </Typography>
                )}

                {values.importSource === "supplier_api" && (
                  <Typography variant="body2" color={supplierApiConnection?.capabilities?.catalogueImport === false ? "text.secondary" : supplierApiConnection?.connected ? "success.main" : supplierApiConnection?.connected === false ? "error.main" : "text.secondary"} sx={{ mt: 1 }}>
                    Connection: {supplierApiConnectionLabel(supplierApiConnection)}
                  </Typography>
                )}

                {values.importSource === "supplier_api" && (loadingSupplierApiEstimate || supplierApiEstimate) && (
                  <Typography variant="body2" color={supplierApiEstimate?.available === false ? "text.secondary" : "info.main"} sx={{ mt: 0.5 }}>
                    {supplierApiEstimateMessage(supplierApiEstimate, loadingSupplierApiEstimate)}
                  </Typography>
                )}

                <TextField
                  select
                  name="destination"
                  label="Import Destination"
                  value={values.destination}
                  onChange={e => {
                    const destination = e.target.value;
                    setFieldValue("destination", destination);
                    setFieldValue("destinationSelections", { ...values.destinationSelections, [values.importSource]: destination });
                    if (values.importSource === "supplier_api") loadSupplierApiEstimate({ supplier: values.supplierObj, destination, catalogueSince: values.catalogueSince, importProfile: values.importProfile });
                  }}
                  fullWidth
                  margin="normal"
                  disabled={uploading}
                  helperText="Choose where normalized products will be saved."
                >
                  {catalogueImportDestinations.map(item => <MenuItem key={item.value} value={item.value}>{item.label}</MenuItem>)}
                </TextField>

                {values.importSource === "file" && <TextField
                  select
                  name="importProfile"
                  label="Import Format"
                  value={values.importProfile}
                  onChange={e => setFieldValue("importProfile", e.target.value)}
                  fullWidth
                  margin="normal"
                  disabled={uploading}
                  helperText="Choose how catalogue rows should be grouped and mapped."
                >
                  <MenuItem value="parent_variant_csv">Parent/Variant Product CSV</MenuItem>
                  <MenuItem value="generic">Generic CSV/XLSX</MenuItem>
                </TextField>}

                <TextField
                  select
                  name="validationMode"
                  label="Validation Mode"
                  value={values.validationMode}
                  onChange={e => setFieldValue("validationMode", e.target.value)}
                  fullWidth
                  margin="normal"
                  disabled={uploading}
                >
                  <MenuItem value="lenient">Lenient - import valid products and report warnings</MenuItem>
                  <MenuItem value="strict">Strict - block import on required-field errors</MenuItem>
                </TextField>

                <TextField
                  select
                  name="missingItemStrategy"
                  label="Missing Items on Re-import"
                  value={values.missingItemStrategy}
                  onChange={e => setFieldValue("missingItemStrategy", e.target.value)}
                  fullWidth
                  margin="normal"
                  disabled={uploading}
                  helperText="Choose what happens to previously imported products/variants that are missing from this file."
                >
                  <MenuItem value="leave_unchanged">Leave unchanged</MenuItem>
                  <MenuItem value="mark_inactive">Mark missing products/variants inactive</MenuItem>
                </TextField>

                {values.importSource === "file" && <TextField
                  name="columnMap"
                  label="Advanced: Column Map (optional)"
                  value={values.columnMap}
                  onChange={e => setFieldValue("columnMap", e.target.value)}
                  fullWidth margin="normal" multiline rows={4}
                  placeholder='{"productName":"catalogName","productCode":"sku","productSize":"size","retailPrice":"price","productImage":"imageUrl","imageUrl":"imageUrl","pageHeader":"category"}'
                  disabled={uploading}
                />}

                {values.importSource === "file" && <div style={{ margin: "1rem 0" }}>
                  <input
                    id="file"
                    name="file"
                    type="file"
                    accept=".xlsx,.xls,.csv"
                    onChange={e => setFieldValue("file", e.currentTarget.files?.[0] || null)}
                    disabled={uploading}
                  />
                  <div style={{ fontSize: 12, opacity: 0.8 }}>
                    Upload .xlsx or .csv (large files supported; you’ll see progress).
                  </div>
                  <ErrorMessage name="file" component="div" style={{ color: "red" }} />
                </div>}

                <TextField
                  select
                  name="currency"
                  label="Currency"
                  value={values.currency}
                  onChange={e => setFieldValue("currency", e.target.value)}
                  fullWidth margin="normal"
                  disabled={uploading}
                >
                  {["CAD", "USD"].map(cur => <MenuItem key={cur} value={cur}>{cur}</MenuItem>)}
                </TextField>

                <TextField
                  name="tradeName"
                  label="Trade Name (optional)"
                  value={values.tradeName}
                  onChange={e => setFieldValue("tradeName", e.target.value)}
                  fullWidth margin="normal"
                  disabled={uploading}
                />

                <FormControlLabel
                  control={<Checkbox checked={values.overwrite} onChange={e => setFieldValue("overwrite", e.target.checked)} disabled={uploading} />}
                  label={values.importProfile === "parent_variant_csv" ? "Overwrite existing (match by external product ID + supplier)" : "Overwrite existing (match by Name + Supplier)"}
                />
                <FormControlLabel
                  control={<Checkbox checked={values.dryRun} onChange={e => { setFieldValue("dryRun", e.target.checked); setFieldValue("fullImportConfirmed", false); }} disabled={uploading} />}
                  label="Dry run (no writes)"
                />

                {values.importSource === "file" && <TextField
                  name="imprintingJson"
                  label="Imprinting JSON (optional)"
                  value={values.imprintingJson}
                  onChange={e => setFieldValue("imprintingJson", e.target.value)}
                  fullWidth margin="normal" multiline rows={3}
                  placeholder='{"Methods":[{"Code":"LASER","Name":"Laser Engraving"}],"Colors":[{"Code":"STD","Name":"Standard"}]}'
                  disabled={uploading}
                />}

                {values.importSource === "file" && <TextField
                  select
                  name="rowLimit"
                  label="Import only first N rows (optional)"
                  value={values.rowLimit}
                  onChange={e => setFieldValue("rowLimit", Number(e.target.value))}
                  fullWidth
                  margin="normal"
                  disabled={uploading}
                  helperText="Use this to test small batches. 0 = all rows."
                >
                  {[0,1,5,10,25,50,100,250,500,1000].map(n => (
                    <MenuItem key={n} value={n}>
                      {n === 0 ? "All rows" : n}
                    </MenuItem>
                  ))}
                </TextField>}

                {supportsProductDataAutoContinue(values.importSource, supplierApiConnection) && <CatalogueProcessingMode
                  mode={values.catalogueMode || 'bounded_batch'} dryRun={values.dryRun} confirmed={values.fullImportConfirmed} disabled={uploading}
                  onChange={(mode, confirmed) => { if (typeof confirmed === 'boolean') { setFieldValue('fullImportConfirmed', confirmed); return; }
                    setFieldValue('catalogueMode', mode); setFieldValue('fullImportConfirmed', false); setFieldValue('autoContinue', false);
                    if (mode === 'full_catalogue') { setFieldValue('groupLimit', Math.min(10, supplierApiConnection?.capabilities?.productDataImport?.maxInitialProductLimit || 25)); setFieldValue('rowLimit', 0); setFieldValue('catalogueSince', ''); }
                  }} />}
                <TextField
                  select
                  name="groupLimit"
                  label={values.catalogueMode === "full_catalogue" ? "Internal batch size (complete products)" : values.importProfile === "parent_variant_csv" ? "Import first N products (by parent/group key)" : "Import first N products (by name)"}
                  value={values.groupLimit}
                  onChange={e => setFieldValue("groupLimit", Number(e.target.value))}
                  fullWidth margin="normal" disabled={uploading}
                  helperText={values.catalogueMode === "full_catalogue" ? "All supplier identities are processed across safe batches; this is not a total catalogue limit." : "Only this bounded batch is processed."}
                >
                  {(values.catalogueMode === "full_catalogue" ? [1,2,5,10,25].filter(n => n <= (supplierApiConnection?.capabilities?.productDataImport?.maxInitialProductLimit || 25)) : values.importSource === "supplier_api" ? productDataImportLimits(
                    supplierApiConnection?.capabilities?.productDataImport?.maxInitialProductLimit
                  ) : [0,1,2,5,10,25,50,100]).map(n => (
                    <MenuItem key={n} value={n}>
                      {n === 0 ? "All products" : n}
                    </MenuItem>
                  ))}
                </TextField>

                {!values.catalogueMode && supportsProductDataAutoContinue(values.importSource, supplierApiConnection) && <FormControlLabel
                  control={<Checkbox checked={Boolean(values.autoContinue)} disabled={uploading}
                    onChange={event => setFieldValue("autoContinue", event.target.checked)} />}
                  label="Automatically continue remaining batches"
                />}
                {values.importSource === "supplier_api" && <TextField
                  name="catalogueSince"
                  label="Catalogue changes since"
                  type="date"
                  value={values.catalogueSince}
                  onChange={e => {
                    const catalogueSince = e.target.value;
                    setFieldValue("catalogueSince", catalogueSince);
                    loadSupplierApiEstimate({ supplier: values.supplierObj, destination: values.destination, catalogueSince, importProfile: values.importProfile });
                  }}
                  fullWidth margin="normal" disabled={uploading || values.catalogueMode === 'full_catalogue'}
                  InputLabelProps={{ shrink: true }}
                  helperText="Narrows the initial DateModified response. First-N limits processing only after the supplier enumeration has been fetched."
                />}

                <DialogActions>
                  <Button onClick={uploading ? handleCancelUpload : closeImportDialog} color={uploading ? "warning" : "secondary"}>
                    {uploading ? "Cancel upload" : "Cancel"}
                  </Button>
                  <Button
                    type="submit"
                    color="primary"
                    disabled={isSubmitting || uploading || (values.importSource === "supplier_api" && supplierApiConnection?.capabilities?.catalogueImport === false && !supplierApiConnection?.capabilities?.cataloguePreview)}
                    variant="contained"
                  >
                    {uploading ? "Uploading…" : (values.dryRun ? "Dry Run" : (supplierApiConnection?.capabilities?.catalogueImport ? "Import" : "Preview Product Data"))}
                  </Button>
                </DialogActions>
              </Form>
            )}
          </Formik>
        )}
      </DialogContent>
    </Dialog>

      <Dialog open={showResultDialog} onClose={closeImportResults} maxWidth="md" fullWidth scroll="paper">
        <DialogTitle>{importResult?.previewOnly ? "Product Data Preview" : (importResult?.dryRun ? "Dry Run Results" : "Import Results")}</DialogTitle>
        <DialogContent dividers sx={{ overflowY: "auto" }}>
          <ImportProgressChips status={batch.Status || (previewResultModel.isPreviewOnly ? "preview" : "pending")} context={resultContext} sourceType={resultDiagnostics.sourceType || submittedImportContext?.sourceType} />
          {autoContinueMessage && <Typography role="status" variant="body2" sx={{ mb: 1 }}>{autoContinueMessage}</Typography>}
          {previewResultModel.isPreviewOnly && (
            <Box sx={{ mb: 2 }}><Typography color="info.main" sx={{ mb: 2 }}>Pricing unavailable — preview only.</Typography><Typography variant="subtitle2" sx={{ mb: 1 }}>{previewResultModel.count} product{previewResultModel.count === 1 ? "" : "s"} previewed</Typography>{previewResultModel.empty && <Typography color="text.secondary" sx={{ mb: 1 }}>No products found.</Typography>}<TableContainer component={Paper} sx={{ maxHeight: 500 }}><Table size="small" stickyHeader><TableHead><TableRow><TableCell>Product ID</TableCell><TableCell>Name</TableCell><TableCell>Part / SKU</TableCell><TableCell>Category</TableCell><TableCell>Country</TableCell><TableCell>Status</TableCell></TableRow></TableHead><TableBody>{previewResultModel.rows.map((row,index)=><TableRow key={`${row.externalProductId}-${row.variantSku}-${index}`}><TableCell>{row.externalProductId}</TableCell><TableCell>{row.productName}</TableCell><TableCell>{row.variantSku}</TableCell><TableCell>{row.categories?.[0]?.category || "—"}</TableCell><TableCell>{row.countryOfOrigin || "—"}</TableCell><TableCell>{[row.isCloseout&&"Closeout",row.isCaution&&"Caution",row.isRushService&&"Rush",row.isOnDemand&&"On demand",row.isHazmat&&"Hazmat"].filter(Boolean).join(", ")||"Active"}</TableCell></TableRow>)}</TableBody></Table></TableContainer></Box>
          )}
          {!previewResultModel.isPreviewOnly && (<>
          <FullCatalogueProgress value={resultDiagnostics.fullCatalogueJob} />
          {safeFullCatalogueProgress(resultDiagnostics.fullCatalogueJob)?.canResume && <Button disabled={uploading || polling} onClick={resumeFullCatalogueJob}>Resume full catalogue from verified checkpoint</Button>}

          <Box sx={{ mb: 2 }}>
            <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
              {polling && <Typography variant="caption">Polling for progress…</Typography>}
              {pollError && <Typography variant="caption" color="error">{pollError}</Typography>}
            </Stack>
            <LinearProgress
              variant={batch.progressPct != null ? "determinate" : "indeterminate"}
              value={batch.progressPct != null ? batch.progressPct : undefined}
            />
            <Box sx={{ display: "flex", justifyContent: "space-between", mt: 0.5 }}>
              <Typography variant="caption">{batch.ProcessedRows || 0} / {batch.TotalRows || 0} rows</Typography>
              <Typography variant="caption">{batch.progressPct != null ? `${batch.progressPct}%` : "Working…"}</Typography>
            </Box>
            {batch.ErrorMessage && <Typography color="error" variant="body2" sx={{ mt: 1 }}>{batch.ErrorMessage}</Typography>}
          </Box>
          {failureDetails && (
            <Paper variant="outlined" sx={{ p: 1.5, mb: 2, borderColor: "error.light" }}>
              <Typography variant="subtitle2" color="error" sx={{ mb: 0.5 }}>Failure Details</Typography>
              {failureDetails.friendlyMessage && <Typography variant="body2" sx={{ mb: 0.5 }}>{failureDetails.friendlyMessage}</Typography>}
              <Typography variant="body2">Error Code: {failureDetails.errorCode}</Typography>
              {failureDetails.catalogueFetch?.operation && <Typography variant="body2">Operation: {failureDetails.catalogueFetch.operation}</Typography>}
              {failureDetails.catalogueFetch?.timeoutMs != null && <Typography variant="body2">Operation timeout: {failureDetails.catalogueFetch.timeoutMs} ms · operation elapsed: {failureDetails.catalogueFetch.operationElapsedMs ?? "not recorded"} ms · session elapsed: {failureDetails.catalogueFetch.elapsedMs ?? "unknown"} ms · automatic retries: 0</Typography>}
              {failureDetails.failureStage && <Typography variant="body2">Failure Stage: {failureDetails.failureStage}</Typography>}
              {failureDetails.provider && <Typography variant="body2">Provider: {failureDetails.provider}</Typography>}
              {failureDetails.sourceType && <Typography variant="body2">Source Type: {failureDetails.sourceType}</Typography>}
              {Object.prototype.hasOwnProperty.call(failureDetails, "sourceComplete") && <Typography variant="body2">Source Complete: {String(failureDetails.sourceComplete)}</Typography>}
            </Paper>
          )}
          {catalogueFetchMessage(resultDiagnostics, batch.Status, importResult?.dryRun) && <Typography sx={{ mb: 2 }}>{catalogueFetchMessage(resultDiagnostics, batch.Status, importResult?.dryRun)}</Typography>}
          {importResult?.canImport === false && !safeFullCatalogueProgress(resultDiagnostics.fullCatalogueJob) && resultDiagnostics.outcome !== "no_results" && (
            <Typography color="error" sx={{ mb: 2 }}>
              This import cannot run with the current validation mode. Review errors below and update the file/settings.
            </Typography>
          )}
          {resultDiagnostics.sourceType === "supplier_api" && (
            <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
              <Chip label={`Pages fetched: ${resultDiagnostics.pagesFetched ?? 0}`} variant="outlined" />
              <Chip label={resultDiagnostics.sourceComplete ? "Source complete" : "Source incomplete"} color={resultDiagnostics.sourceComplete ? "success" : "warning"} />
            </Stack>
          )}
          {resultDiagnostics.staleReconciliationWarning && (
            <Typography color="warning.main" sx={{ mb: 2 }}>{resultDiagnostics.staleReconciliationWarning}</Typography>
          )}
          <Grid container spacing={1} sx={{ mb: 2 }}>
            {[
              ["Total Rows", batch.TotalRows ?? resultDiagnostics.totalRows],
              ["Product Groups", batch.ProductGroups ?? resultDiagnostics.productGroups],
              ["Variant Rows", batch.VariantRows ?? resultDiagnostics.variantRows],
              ["Would Create", resultSummary.wouldCreate ?? resultSummary.created],
              ["Would Update", resultSummary.wouldUpdate ?? resultSummary.updated],
              ["Would Skip", resultSummary.wouldSkip ?? resultSummary.skipped],
              ["Errors", batch.Errors ?? resultDiagnostics.issues?.totalErrors ?? resultSummary.errors],
              ["Warnings", batch.Warnings ?? resultDiagnostics.issues?.totalWarnings]
            ].map(([label, value]) => (
              <Grid item xs={6} sm={3} key={label}>
                <Paper sx={{ p: 1 }}>
                  <Typography variant="caption" color="text.secondary">{label}</Typography>
                  <Typography variant="h6">{value ?? 0}</Typography>
                </Paper>
              </Grid>
            ))}
          </Grid>

          {columnMapping.profile && (
            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2">Matched Columns</Typography>
              <Typography variant="body2">Profile: {columnMapping.profile} · Confidence: {Math.round((columnMapping.confidence || 0) * 100)}%</Typography>
              <Typography variant="body2">Matched: {Object.entries(columnMapping.matchedColumns || {}).map(([k, v]) => `${k}: ${v}`).join(", ") || "None"}</Typography>
              {!!columnMapping.missingRequiredColumns?.length && (
                <Typography variant="body2" color="error">Missing required: {columnMapping.missingRequiredColumns.join(", ")}</Typography>
              )}
              {!!columnMapping.missingOptionalColumns?.length && (
                <Typography variant="body2" color="text.secondary">Missing optional: {columnMapping.missingOptionalColumns.join(", ")}</Typography>
              )}
            </Box>
          )}

          {!!resultDiagnostics.productNameCollisions?.length && (
            <Typography color="warning.main" sx={{ mb: 2 }}>
              Same product name appears under multiple parent IDs. This is okay because parent key is used, but review for duplicates.
            </Typography>
          )}

          <Typography variant="subtitle2" sx={{ mb: 1 }}>Issue Samples</Typography>
          <TableContainer component={Paper} sx={{ maxHeight: 260 }}>
            <Table size="small" stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell>Severity</TableCell>
                  <TableCell>Code</TableCell>
                  <TableCell>Row</TableCell>
                  <TableCell>Product ID</TableCell>
                  <TableCell>Variant SKU</TableCell>
                  <TableCell>Message</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {issueSamples.slice(0, 100).map((issue, idx) => (
                  <TableRow key={`${issue.code || issue.Code}-${issue.rowNumber || issue.RowNumber}-${idx}`}>
                    <TableCell><Chip size="small" color={(issue.severity || issue.Severity) === "error" ? "error" : "warning"} label={issue.severity || issue.Severity || "warning"} /></TableCell>
                    <TableCell>{issue.code || issue.Code}</TableCell>
                    <TableCell>{issue.rowNumber || issue.RowNumber || "—"}</TableCell>
                    <TableCell>{issue.externalProductId || issue.ExternalProductId || "—"}</TableCell>
                    <TableCell>{issue.externalVariantId || issue.ExternalVariantId || "—"}</TableCell>
                    <TableCell>{issue.message || issue.Message}</TableCell>
                  </TableRow>
                ))}
                {!issueSamples.length && (
                  <TableRow><TableCell colSpan={6}>No issue samples returned.</TableCell></TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          </>)}
        </DialogContent>
        <DialogActions sx={{ position: "sticky", bottom: 0, bgcolor: "background.paper", zIndex: 1 }}>
          <Button onClick={closeImportResults}>Close</Button>
          {previewResultModel.showImportBatch && (<>

          {importResult?.recovery?.recoverable && (
            <Button color="warning" variant="outlined" onClick={recoverStaleImport}>
              Recover stale import
            </Button>
          )}
          {isActiveImportStatus && (
            <Button color="warning" onClick={cancelActiveImport} disabled={batch.Status === "cancel_requested"}>
              {batch.Status === "cancel_requested" ? "Cancelling…" : "Cancel Import"}
            </Button>
          )}
          {dryRunImportAction.visible && (
            <Button
              variant="contained"
              disabled={dryRunImportAction.disabled}
              onClick={runImportFromDryRun}
            >
              Run Import with These Settings
            </Button>
          )}
          {canContinueProductDataBatch && !autoContinueEnabled && (
            <Button variant="outlined" onClick={() => continueProductDataBatch()}>
              Continue Next Batch
            </Button>
          )}

          </>)}
        </DialogActions>
      </Dialog>
    </>
  );
};

export default InstanceProducts;
